/// all the store logic and listeneres are here. The rest are just dumb Components. Makis was here. 2019
import { useEffect, useState, useRef } from "react"
import "./scss/font.scss"
import "./scss/base.scss"
import React from "react"
import ReactGA from "react-ga4"
import upperFirst from "lodash/upperFirst"
import AppSumoFlow, { clearAppSumoDetails } from "./promos/AppSumoFlow"
import Badge from "@material-ui/core/Badge"
import cx from "classnames"
import Loadable from "react-loadable"
import { emailDomainToSamlProviderMap, getDomainFromEmail, isActiveDirectoryEmail } from "./comp/Utils"

import { toast, ToastContainer } from "react-toastify"
import IconLeave from "./comp/icons/IconLeave"
import flatMap from "lodash/flatMap"

import groupBy from "lodash/groupBy"
import uniqBy from "lodash/uniqBy"
import { BsCalendar4Week } from "react-icons/bs"
import get from "lodash/get"
import forIn from "lodash/forIn"
import pick from "lodash/pick"
import differenceBy from "lodash/differenceBy"

import BarLoader from "react-spinners/BarLoader"
import update from "immutability-helper"
import { eachDayOfInterval } from "date-fns/eachDayOfInterval"
import { eachMonthOfInterval } from "date-fns/eachMonthOfInterval"
import { startOfWeek } from "date-fns/startOfWeek"
import apiFile from "./services/file/file.api"
import { logError } from "./services/logging.service"
import IconSpeed from "./comp/icons/IconSpeed"
import Home from "./section/Home"
import Board from "./section/Board"

import { BsReceipt } from "react-icons/bs"
import FullScreen from "./comp/FullScreen"
import { addDbItem, getDbItem } from "./utils/idb-util"
import { motion, AnimatePresence } from "framer-motion"

import history, {
    addParam,
    addParams,
    removeParams,
    removeParam,
    getQ,
    getHash,
    removeQueryParam,
} from "./comp/History"
import { getStartHour, dateValidationPass, getStaleDate, getCompleteBufferDate } from "./utils/dates"
import {
    ensureNumber,
    isMongoId,
    darkThemes,
    isGtGr,
    makeHash,
    useDebouncedEffect,
    makeRefHash,
    getErrorMsg,
} from "./utils/utils"
import { updateBudgetOnRaciTasks } from "./utils/financials"
import { getSimpleAction } from "./utils/actionItem"

import Tip from "./comp/Tip"
import Confirm from "./comp/Confirm"

import Card from "./comp/Card"

import isEmail from "validator/lib/isEmail"
import isMobilePhone from "validator/lib/isMobilePhone"

import { startOfMonth } from "date-fns/startOfMonth"
import { isThisWeek } from "date-fns/isThisWeek"

import { endOfWeek } from "date-fns/endOfWeek"
import { endOfDay } from "date-fns/endOfDay"
import { isBefore } from "date-fns/isBefore"
import { isSaturday } from "date-fns/isSaturday"
import isSunday from "date-fns/isSunday"
import { isSameMonth } from "date-fns/isSameMonth"
import { isAfter } from "date-fns/isAfter"
import startOfDay from "date-fns/startOfDay"
import endOfMonth from "date-fns/endOfMonth"
import addMonths from "date-fns/addMonths"
import addDays from "date-fns/addDays"
import nextMonday from "date-fns/nextMonday"
import nextTuesday from "date-fns/nextTuesday"
import { toZonedTime } from "date-fns-tz"
import { getMissingTimesheets } from "./utils/timesheets"
import { getTimeUtc } from "./utils/dates"

import { canAccessOrgSpace, assignPersonToRole } from "./comp/OrgUtils"

import { getRole } from "./comp/OrgGetRole"

import { getUserRequestId } from "./services/auth/auth.service"

//IMPORT APIS

import apiAuth, { samlSignInWithPopup, verifyAuthorized } from "./services/auth/auth.api"
import apiAction from "./services/action/action.api"
import apiActionItem from "./services/actionItem/actionItem.api"

import apiOrg from "./services/org/org.api"
import apiMission from "./services/mission/mission.api"
import apiPlanItems from "./services/planItems/planItems.api"
import apiNotification from "./services/notification/notification.api"
import apiUnsubscribe from "./services/unsubscribe/unsubscribe.api"

import apiTemplate from "./services/template/template.api"

import "react-toastify/dist/ReactToastify.css"
import { IoClose } from "react-icons/io5"

import { PiLightningDuotone, PiTriangleDuotone, PiHouseLight } from "react-icons/pi"

import { existsTimeTracking, getMissionPerson, getAllActions, getAllActionItems } from "./comp/MissionUtils"

import firebase from "./services/firebase.service"

import mojs from "@mojs/core"
import Drive from "./drive/Drive"
import { getObjectId, getRefId } from "./utils/utils"

import { getFullName } from "./comp/PeopleUtils"
import PanelNotification, { checkForClientPrograms } from "./comp/PanelNotification"
import ErrorBoundary from "./ErrorBoundary"
import { hasAppReconnected, unmountAppReconnect } from "./services/app-reconnect.service"
import { subMonths } from "date-fns"

import { v4 as uniqid } from "uuid"

import { delAllExpiredCache } from "./utils/cache"
import { setCsrf, setSessionCookie } from "./services/session/session.api"
import isNil from "lodash/isNil"

const axios = require("axios")

const VERSION = 1

//CODE-SPLIT SOME MODULES

const MxAdmin = Loadable({
    loader: () => import("./comp/MxAdmin"),
    loading: () => <span />,
})

const ActionItem = Loadable({
    loader: () => import("./comp/ActionItem"),
    loading: () => <span />,
})
const CrudMission = Loadable({
    loader: () => import("./module/CrudMission"),
    loading: () => <span />,
})
const CreateMission = Loadable({
    loader: () => import("./comp/CreateMission"),
    loading: () => <span />,
})
const CreateBid = Loadable({
    loader: () => import("./comp/CreateBid"),
    loading: () => <span />,
})
const Power = Loadable({
    loader: () => import("./section/Power"),
    loading: () => <span />,
})

const SimplyX = Loadable({
    loader: () => import("./section/SimplyX"),
    loading: () => <span />,
})

const MxGanttMission = Loadable({
    loader: () => import("./section/MxGanttMission"),
    loading: () => <span />,
})

const BudgetPro = Loadable({
    loader: () => import("./comp/BudgetPro"),
    loading: () => <span />,
})

const Calendar = Loadable({ loader: () => import("./comp/Calendar"), loading: () => <span /> })

const MySpace = Loadable({
    loader: () => import("./section/MySpace"),
    loading: () => <span />,
})

const BudgetSetup = Loadable({
    loader: () => import("./comp/BudgetSetup"),
    loading: () => <span />,
})

const Org = Loadable({
    loader: () => import("./module/Org"),
    loading: () => <span />,
})
const CrudOrg = Loadable({
    loader: () => import("./module/CrudOrg"),
    loading: () => <span />,
})

const Login = Loadable({
    loader: () => import("./section/Login"),
    loading: () => <span />,
})

const Navigator = Loadable({
    loader: () => import("./comp/Navigator"),
    loading: () => <span />,
})

const TimeTracking = Loadable({ loader: () => import("./section/TimeTracking"), loading: () => <span /> })

const CreateTemplate = Loadable({
    loader: () => import("./comp/CreateTemplate"),
    loading: () => <span />,
})

const LeaveTracker = Loadable({ loader: () => import("./section/LeaveTracker"), loading: () => <span /> })

const ExpenseTracker = Loadable({ loader: () => import("./comp/ExpenseTracker"), loading: () => <span /> })

const PacmanLoader = Loadable({
    loader: () => import("react-spinners/PacmanLoader"),
    loading: () => <span />,
})

const RingLoader = Loadable({
    loader: () => import("react-spinners/RingLoader"),
    loading: () => <span />,
})

const RiseLoader = Loadable({
    loader: () => import("react-spinners/RiseLoader"),
    loading: () => <span />,
})

const Wfh = Loadable({
    loader: () => import("./comp/Wfh"),
    loading: () => <span />,
})
const CIRCLE_OPTS = {
    fill: "none",
    className: "mo-js-shape",
    radius: 25,
    strokeWidth: { 50: 0 },
    scale: { 0: 1 },
    duration: 500,
    left: 0,
    top: 0,
    easing: "cubic.out",
}

const missionTreeConfig = { isActive: true, staleDate: getStaleDate(), completedBufferDate: getCompleteBufferDate() }

class App extends React.Component {
    constructor(props) {
        super(props)
        const me = this

        this.msgBeep = React.createRef()

        const qHash = getHash()
        const q = {
            ...getQ(),
            ...qHash,
        }

        this.fetchedOrgs = {}
        this.isLaunched = true

        // Hygiene

        delAllExpiredCache().catch(() => {
            // Nothing
        })

        removeParams(
            "_v,hq,mc-org,diagnostic,mc-org-goal,make-template,create-proposal,myspace,mc,change-date,change-domains,hq-creating,mc-prop,org-cfg,oc-domains,create-mission,leave-notice,invite-notice,"
        )

        // END Hygiene

        this.hasUnmounted = false
        this.hasAppReconnectedSocket = null

        this.state = {
            avKey: uniqid(),
            orgsFetchedData: [],
            person: {},
            orgs: [],
            missions: [],
            showLeaveTracker: false,
            showExpenseTracker: false,
            phases: [],
            actions: [],
            missionChange: {},
            orgChange: {},
            fileSelected: null,
            fileSelectedList: null,
            notificationList: [],
            notificationUnread: 0,
            notificationOpen: false,
            mfaDisabledMissions: [],
            mfaDisabledOrgs: [],
            mfaRequiredMsg: false,
            activityList: [],
            helpIndex: 1,
            loadingBlockerLoader: "bar",
        }

        switch (q["mode"]) {
            // Firebase
            case "resetPassword":
                me.flowResetPassword()
                break
            case "recoverEmail":
                me.flowRecoverEmail()
                break
        }

        this.actionItemTO = 0

        this.unsubscribeFromIdTokenChanges = firebase.auth().onIdTokenChanged(async (user) => {
            // User is signed in, signed out or token was refreshed.
            try {
                if (user) {
                    await setCsrf()
                    await setSessionCookie()
                } else {
                    // Cannot revoke, user already logged out
                }
            } catch (err) {}
        })

        this.unsubscribeFromAuthStateChanged = firebase.auth().onAuthStateChanged(async (authorized) => {
            if (authorized) {
                try {
                    await verifyAuthorized()
                } catch (err) {
                    if (["auth/invalid-provider", "auth/sso-not-authorized", "auth/sso-required"].includes(err?.code)) {
                        toast.error(err?.message, { autoClose: 6000 })
                        setTimeout(() => {
                            try {
                                this.personSignOut()
                            } catch (err) {}
                        }, 6000)
                    } else if (["auth/failed-unexpected"].includes(err?.code)) {
                        toast.error(
                            "Oops. An error occurred and we are already investigating it. Please try again in a bit or help@missionx.ai",
                            { autoClose: false }
                        )
                    } else if (["auth/failed"].includes(err?.code)) {
                        this.personSignOut()
                    }
                    return
                }
                setCookie("mission-x-active-login", "true", 60)
                if (me.preAuthHistoryListener) me.preAuthHistoryListener()
                if (!this.hasAppReconnectedSocket) {
                    // Listen only once
                    this.hasAppReconnectedSocket = hasAppReconnected((offlineMs) => {
                        // Don't run the callback if component has been unmounted
                        if (!this.hasUnmounted) {
                            try {
                                if (offlineMs >= 300000) {
                                    console.log("Sockets were disconnected for about " + offlineMs / 1000 + "s.")
                                    me.reBuildState()
                                }
                            } catch (err) {
                                console.error("Failed to update state", err)
                            }
                        }
                    })
                }

                if (process.env.REACT_APP_ENV === "prod") {
                    ReactGA.initialize("G-GNWFCEYWW1")
                }

                this.setState({
                    multiFactor: authorized.multiFactor.enrolledFactors[0],
                })

                switch (q["mode"]) {
                    // Firebase
                    case "verifyEmail":
                        me.flowVerifyEmail()
                        break
                    case "verifyAndChangeEmail":
                        me.flowVerifyAndChangeEmail()
                        break
                    case "verifyEmailSecondary":
                        me.flowVerifyEmailSecondary()
                        break
                    case "unsubscribe":
                        me.flowUnsubscribe()
                        break
                }

                if (q["diagnostic"]) {
                    this.setState(
                        {
                            error: "true",
                        },
                        () => {}
                    )
                }

                if (q.token && q.from === "orgInvite") {
                    /**
                     * @makis accounts merge
                      */
                    await apiOrg
                        .handleInvite(q.token)
                        .finally(() => me.personAuthInit())
                        .catch((err) => {
                            if (err.code === "merge_confirm_required") {
                                // Prompt the user to confirm an attempt to merge the two accounts
                                // Otherwise they will need to log out and login with the account that corresponds to the invited email.
                                // Use apiOrg.getInviteByToken(q.token) to get invite details.
                                // If they confirm, call again the same method: apiOrg.handleInvite(q.token, {mergeConfirmation: true})
                            }
                            else if (err.code !== "invite/active-directory") {
                                toast.warn(err.message)
                            }
                        })
                } else if (q.token && q.from === "invite") {
                    /**
                     * @makis accounts merge
                     */
                    await apiMission
                        .handleInvite(q.token)
                        .finally(() => me.personAuthInit())
                        .catch((err) => {
                            if (err.code === "merge_confirm_required") {
                                // Prompt the user to confirm an attempt to merge the two accounts
                                // Otherwise they will need to log out and login with the account that corresponds to the invited email.
                                // Use apiMission.getInviteByToken(q.token) to get invite details.
                                // If they confirm, call again the same method: apiMission.handleInvite(q.token, {mergeConfirmation: true})
                            }
                            else if (err.code !== "invite/active-directory") {
                                toast.warn(err.message)
                            }
                        })
                } else {
                    await me.personAuthInit()
                }

                if (q["from"] === "mentionEmail" && !!q["room"] && !!q["roomName"]) {
                    const params = []
                    if (q["roomName"] === "ActionItem") {
                        params.push({ param: "action-item", value: q["room"] })
                    }
                    removeParams(["from", "room", "roomName"].join(","))
                    addParams(params)
                }

                me.loadAll()
                me.authHistoryListener = history.listen((location, action) => me.routing())
            } else {

                this.setState({
                    login: true,
                })

                if (!window.location.pathname.includes("/login")) {
                    await apiAuth.clearSiteData();
                    window.location = "/login" + window.location.search
                }

                if (q["mode"] && (q.mode === "verifyEmail" || q.mode === "verifyEmailSecondary")) {
                    setTimeout(() => {
                        toast("Awesome! Let's login and get you verified. 🦋", {
                            autoClose: 8000,
                        })
                    }, 600)
                }
            }
        })
    }

    setLocal = () => {
        const me = this

        axios
            .get("https://api.bigdatacloud.net/data/ip-geolocation?key=759b615e643048409fc401ffc9a67b46")
            .then((res) => {
                const d = res.data
                const p = me.state.person

                if (
                    d.country.isoAlpha2 === p.country &&
                    d.location.city === p.city &&
                    d.location.principalSubdivision === p.state
                ) {
                    toast("Your location appears the same. Please make sure you are not using a VPN.")
                    return
                }

                me.personUpdate({
                    country: d.country.isoAlpha2,
                    city: d.location.city,
                    state: d.location.principalSubdivision,
                    timezone: d.location.timeZone.ianaTimeId,
                }).then((r) => {})
            })
    }
    silentFail(error, data = {}) {
        clearTimeout(this.silentFailTo)
        this.silentFailTo = setTimeout(() => {
            logError(error, data)
        }, 100)
    }
    loadLatestNotifications() {
        const orpahnCheck = checkForClientPrograms(this)
        apiNotification
            .getNotificationUnreadCount()
            .then((res) => {
                apiNotification.getNotificationList({ limit: Math.max(res.count, 300) }).then((list) => {
                    this.setState({
                        notificationList: list,
                        notificationUnread:
                            (res?.count || 0) + orpahnCheck.orphans + ensureNumber(this.state.missingTimesheets),
                        theNotificationsHaveLanded: true,
                    })
                })
            })
            .catch(() => {
                this.setState({
                    theNotificationsHaveLanded: true,
                })
            })
    }
    refuseCookies() {
        this.setState({
            showCookies: false, //this is just to show the cookie banner
        })
        localStorage.setItem(
            "dna-accept-cookie",
            JSON.stringify({
                rejected: true,
            })
        )
    }
    acceptCookies() {
        this.setState({
            showCookies: false,
        })

        localStorage.setItem(
            "dna-accept-cookie",
            JSON.stringify({
                accepted: true,
            })
        )
    }
    openExpensePanel() {
        this.setState({
            showExpenses: true,
        })
    }
    initialStateLogic(q) {
        const me = this

        let state = {
            missions: [],
            phases: [],
            actions: [],
            person: {},
        }

        return state
    }
    flowResetPassword() {
        const q = getQ()
        const me = this

        apiAuth
            .signOut()
            .then(() => {
                apiAuth
                    .verifyPasswordResetCode(q.oobCode)
                    .then((res) => {
                        me.tempResetEmail = res
                        me.tempResetCode = q.oobCode

                        me.setState({
                            login: true,
                        })
                    })
                    .catch((err) => {
                        toast.error("🧐 So sorry but: " + err.message, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 6000,
                        })

                        this.silentFail("wekorheijled.sdseeeew" + err?.message)

                        history.push("/?login=open")

                        me.setState({
                            resetLoginStates: new Date().getTime(),
                            login: true,
                        })

                        me.forceUpdate()
                    })
            })
            .catch((err) => {
                throw err
            })
    }
    flowVerifyEmail() {
        const q = getQ()
        const { oobCode } = q

        if (!oobCode) {
            return
        }

        const me = this

        apiAuth
            .verifyEmail(oobCode)
            .then((person) => {
                toast.success("Congratulations. You're now verified!", {
                    autoClose: 5000,
                })

                me.setState({
                    person: update(this.state.person, {
                        emailVerified: { $set: person.emailVerified },
                        emailList: { $set: person.emailList },
                    }),
                })

                let toInvite = localStorage.getItem("dna-to-invite")

                if (toInvite) {
                    toInvite = JSON.parse(toInvite)?.toInvite || []
                } else {
                    toInvite = []
                }

                if (toInvite.length) {
                    localStorage.setItem(
                        "dna-to-invite",
                        JSON.stringify({
                            toInvite: [],
                        })
                    )

                    const metadata = {
                        config: {
                            permission: 2,
                        },
                        message: "Help manage our missionX workspace.",
                    }

                    toInvite.forEach((ti, i) => {
                        if (this.state.orgs.find((o) => o._id === ti.org))
                            this.orgInvitePerson(ti.org, ti.email, metadata, null, true)
                    })
                }
            })
            .finally(() => removeParams("oobCode,apiKey,mode,lang"))
            .catch((err) => {
                setTimeout(() => {
                    switch (err.code) {
                        case "auth/invalid-action-code":
                            return toast.error(
                                "Sorry this validation link is no longer valid. Please check your email for a more recent link.",
                                { autoClose: 6000 }
                            )
                        case "auth/expired-action-code":
                            return toast.error(
                                "The verification email has expired. Sorry please request a new one. My Space... icon top right.",
                                { autoClose: 6000 }
                            )
                        case "email_verify_unexpected":
                            return toast.error(err.message)
                        case "auth/argument-error":
                            return
                        default:
                            toast.error(
                                "Failed to verify email. The code may be invalid (new one sent) Contact us if you did not receive a new email: help@missionx.ai",
                                {
                                    autoClose: 8000,
                                }
                            )
                    }
                }, 1000)
            })
    }
    flowVerifyAndChangeEmail() {
        const q = getQ()
        const { oobCode } = q

        if (!oobCode) {
            return
        }

        const me = this

        apiAuth
            .verifyAndUpdateEmail(oobCode)
            .then(({ previousEmail, newEmail }) => {
                me.setState({
                    person: update(this.state.person, {
                        email: newEmail,
                        emailVerified: { $set: true },
                    }),
                })

                addParam("myspace", "open")
                toast.success(
                    `Congratulations. Your email was verified and successfully changed from "${previousEmail}" to "${newEmail}"!`,
                    {
                        autoClose: 8000,
                    }
                )
            })
            .finally(() => removeParams("oobCode,apiKey,mode,lang"))
            .catch((err) => {
                switch (err.code) {
                    case "auth/expired-action-code":
                        return toast.error(
                            "The verification email has expired. Sorry please try changing your email again from My Space...",
                            { autoClose: 6000 }
                        )
                    case "auth/user-token-expired":
                        return setTimeout(() => {
                            toast("Redirecting you to re-authenticate", {
                                autoClose: 2000,
                            })
                            setTimeout(() => {
                                window.location.href = "/"
                            }, 2000)
                        }, 1000)
                    default:
                        toast.error(`${err.message}. Maybe try again or contact us: help@missionx.ai`, {
                            autoClose: 10000,
                        })
                }
            })
    }
    flowVerifyEmailSecondary() {
        const q = getQ()
        const { oobCode } = q

        if (!oobCode) {
            return
        }

        apiAuth
            .emailListVerify(oobCode)
            .finally(() => removeParams("oobCode,mode,apiKey,lang"))
            .then((profile) => {
                toast.success("🚀 Nicely done Your email has been verified!", {
                    autoClose: 5000,
                })

                this.setState({
                    person: update(this.state.person, {
                        emailList: { $set: profile.emailList },
                    }),
                })
            })
            .catch((err) => {
                toast.error(err.message, {
                    autoClose: 6000,
                })
            })
    }
    flowRecoverEmail() {
        const q = getQ()
        const { oobCode } = q

        if (!oobCode) {
            return
        }

        apiAuth
            .recoverEmail(oobCode)
            .finally(() => removeParams("oobCode,apiKey,mode,lang"))
            .then(({ recoveryEmail }) => {
                if (recoveryEmail) {
                    this.setState({
                        person: update(this.state.person, {
                            email: { $set: recoveryEmail },
                        }),
                    })
                }
                toast.success(`🚀 Yeahy! Your email "${recoveryEmail || ""}" has been recovered!`, {
                    autoClose: 5000,
                })
            })
            .catch((err) => {
                switch (err.code) {
                    case "auth/user-token-expired":
                        history.push("/?login=open")
                        this.setState({
                            login: true,
                        })
                        return toast.success(
                            "🚀 Yeahy! Your email has been recovered! Please login again to continue.",
                            {
                                autoClose: 6000,
                            }
                        )
                    default:
                        toast.error(err.message, {
                            autoClose: 6000,
                        })
                }
            })
    }
    /**
     * TODO: Make email unsubscribe more robust.
     * Maybe confirm and provide a way to subscribe back.
     */
    flowUnsubscribe() {
        const q = getQ()
        if (apiUnsubscribe[q.from] && q.token) {
            apiUnsubscribe[q.from](q.token)
                .finally(() => history.push("/"))
                .then(() => toast.success("Unsubscribed successfully!", { autoClose: 5000 }))
                .catch((err) => toast.error(err.message, { autoClose: 6000 }))
        }
    }
    claimAppSumo() {
        const flowOkToStart = ({ code, res }) => {
            this.setState({
                appsumo: res,
                appSumoOobCode: code,
            })
        }

        const stachedCode = localStorage.getItem("mx-app-sumo-oobCode-" + this.state.person._id)

        const oobCode = JSON.parse(stachedCode)?.oobCode

        if (oobCode) {
            apiOrg
                .getAppSumoByOobCode(oobCode)
                .then((res) => {
                    if (!this.state.person.emailList.find((ob) => ob.email === res.activation_email)) {
                        apiAuth
                            .emailListAdd(res.activation_email)
                            .then((updatedProfile) => {
                                toast.success(`Great! Please check your email to verify ${res.activation_email}`)
                                this.personUpdate({
                                    emailList: updatedProfile.emailList,
                                })

                                flowOkToStart({ oobCode, res })
                            })
                            .catch((err) => {
                                toast(
                                    `So sorry, but the AppSumo activation email account ${res.activation_email} appears to be in use. Please logout and login using that email to claim your package!`,
                                    { autoClose: false }
                                )

                                clearAppSumoDetails({ app: this })
                            })
                    } else {
                        flowOkToStart({ oobCode, res })
                    }
                })
                .catch((err) => {
                    removeParams("from,oobCode")
                    clearAppSumoDetails({ app: this })

                    this.silentFail("oobCOde::" + (err?.message + " - " + err?.toString()))

                    if (!toast.isActive("summoKiller1")) {
                        toast.warning(
                            "🐋 Oh no! Terribly sorry but there was an issue verifying your AppSumo package. Please try the link again from AppSumo or contact us: help@missionx.ai",
                            {
                                autoClose: false,
                                toastId: "summoKiller1",
                            }
                        )
                    }
                })
        } else {
            this.silentFail("oobCOdeStache" + stachedCode)
            clearAppSumoDetails({ app: this })
            toast.warning(
                "🐳 Sorry but it appears that I cannot authorize this actvation. Please try following your AppSumo activation link again and please let us know in the chat or email us help@missionx.ai",
                {
                    autoClose: false,
                }
            )
        }
    }
    setPersonalSetting(obj) {
        let d = this.state.person.appSettings || {}
        d = { ...d, ...obj }

        this.personUpdate({ appSettings: d })
    }
    setUiSeenFlags(param, val, local) {
        let newArr = this.state.person.uiMessageFlags || []
        if (!newArr.includes(param)) {
            if (val) {
                newArr.push(param + "-" + val)
            } else {
                newArr.push(param)
            }
            this.personUpdate({ uiMessageFlags: newArr })
        }
        if (local) localStorage.setItem(param, true)
    }
    hasSeenMsg(param) {
        return this.state.person.uiMessageFlags?.find((d) => d === param) || localStorage.getItem(param)
    }
    storeAppSumoDetails() {
        const q = getQ()
        let code = q.oobCode
        let newArr = this.state.person.uiMessageFlags || []

        if (!newArr.includes("appsumo")) {
            newArr.push("appsumo")

            this.personUpdate({ uiMessageFlags: newArr })
        }

        localStorage.setItem(
            "mx-app-sumo-oobCode-" + this.state.person._id,
            JSON.stringify({
                oobCode: code,
            })
        )
    }

    inLogic() {
        //Where to go after signin logic

        const section = history.location.pathname.replace("/", "")
        const q = getQ()

        if (q.from === "appsumo") this.storeAppSumoDetails()

        this.setState({
            login: false,
        })

        if (
            this.state.person._id &&
            (!this.state.person.avatar || !this.state.person.firstName?.trim() || !this.state.person.lastName?.trim())
        ) {
            history.push("/home")
            addParam("myspace", "open")

            if (
                (!this.state.person.firstName?.trim() && this.state.person.lastName?.trim()) ||
                (this.state.person.firstName?.trim() && !this.state.person.lastName?.trim())
            ) {
                toast.error("Hello. Could you please check that your first and last name is correct?", {
                    autoClose: 5000,
                })
            }

            this.setState({
                myspace: true,
                login: false,
            })
        } else if (section === "" || section === "login") {
            history.push("/home")
        } else {
            removeParam("login")
        }

        function isFirstLetterLowercase(word) {
            if (!word || typeof word !== "string") return false
            const firstChar = word.charAt(0)
            return firstChar === firstChar.toLowerCase() && firstChar !== firstChar.toUpperCase()
        }

        if (isFirstLetterLowercase(this.state.person.firstName)) {
            const newName = upperFirst(this.state.person.firstName)
            this.personUpdate({ firstName: newName })
        }
        if (isFirstLetterLowercase(this.state.person.lastName)) {
            const newName = upperFirst(this.state.person.lastName)
            this.personUpdate({ lastName: newName })
        }

        if (!this.state.person.city || !this.state.person.country || !this.state.person.state) {
            this.setLocal()
        }

        if (this.hasSeenMsg("firefox")) {
            const isFirefox = typeof InstallTrigger !== "undefined"

            if (isFirefox) {
                this.confirm({
                    comp: (
                        <p>
                            Hold on. Wait a minute. You're using Firefox. Cool browser, but it has some quirks we
                            haven't had time to address yet, so you may experience an issue or two until it is fully
                            supported.
                        </p>
                    ),
                    imgComp: <img src="/img/ff.png" style={{ width: 100, marginBottom: 20 }} />,
                    yesText: "Understood",
                    onYes: () => {
                        this.setUiSeenFlags("firefox")
                    },
                })
            }
        }
    }
    loadAll() {
        SimplyX.preload()
        Power.preload()
        MxGanttMission.preload()
        this.setState({
            showAll: true,
        })
    }
    resetEntryStates() {
        setTimeout(() => {
            this.setState({
                resetLoginStates: new Date().getTime(),
            })
        }, 500)
    }

    componentWillUnmount() {
        clearInterval(this.activityInterval)
        unmountAppReconnect()

        this.hasUnmounted = true
        this.hasAppReconnectedSocket = null
    }
    cookieLogic() {
        let accpt = JSON.parse(localStorage.getItem("dna-accept-cookie"))

        if (accpt && accpt.accepted) {
            if (!window.location.href.includes("localhost")) {
                ReactGA.initialize("G-GNWFCEYWW1")
            }
        } else {
            axios
                .get("https://api.bigdatacloud.net/data/ip-geolocation?key=759b615e643048409fc401ffc9a67b46")
                .then((res) => {
                    if (res.data.location.continentCode === "EU") {
                        this.setState({
                            showCookies: true,
                        })
                    } else {
                        this.acceptCookies()
                        ReactGA.initialize("G-GNWFCEYWW1")
                    }
                })
                .catch((msg) => {
                    this.setState({
                        showCookies: true,
                    })
                })
        }
    }
    componentDidMount() {
        this.mainCircle = new mojs.Shape({
            ...CIRCLE_OPTS,
            stroke: "orange",
        })

        this.xBurstShape = new mojs.Burst({
            radius: { 0: 120 },
            count: 5,
            duration: 100,
            className: "mo-js-shape",
            strokeWidth: 1,
            left: 0,
            top: 0,
            children: {
                fill: { cyan: "yellow" },
            },
        })

        this.smallCircles = []
        const colors = ["orange", "red", "gold", "#cc0000"]

        for (let i = 0; i < 4; i++) {
            this.smallCircles.push(
                new mojs.Shape({
                    ...CIRCLE_OPTS,
                    parent: this.mainCircle.el,
                    className: "mo-js-c",
                    strokeWidth: { 30: 0 },
                    left: 0,
                    top: 0,
                    stroke: colors[i % colors.length],
                    delay: "rand(0, 350)",
                    x: "rand(-50, 150)",
                    y: "rand(-50, 150)",
                    radius: "rand(5, 20)",
                })
            )
        }

        this.doneBurst = new mojs.Burst({
            radius: { 0: 500 },
            //parent : this.element,
            left: 0,
            top: 0,
            className: "mo-js-shape",
            count: 20,
            children: {
                scale: { 12: 0 },
                shape: "polygon",
                points: 6,
                fill: { lime: "cyan" },
                angle: { 360: 0 },
                duration: 900,
                delay: "stagger( rand(0, 50) )",
            },
        })

        Login.preload()
    }
    circleBurst(left, top) {
        this.mainCircle.tune({ x: left, y: top }).replay()

        for (let i = 0; i < this.smallCircles.length; i++) {
            this.smallCircles[i].generate().replay()
        }
    }
    xBurst(left, top) {
        this.xBurstShape.tune({ x: left, y: top }).replay()
    }
    preAuthRouting() {
        const q = getQ()

        const section = window.location.pathname.split("/")[1]

        if (q.from === "appsumo" && !this.state.login) {
            this.setState({
                login: true,
            })
        } else if ((section === "board" || section === "home" || q.mission) && !q.login) {
            history.push("/")

            addParam("login", "open")

            this.setState({
                login: true,
            })
        } else if (q.login || q.mode) {
            this.setState({
                login: true,
            })
        } else if (q.mode === "verifyEmail") {
            this.setState({
                login: true,
            })
        } else {
            this.setState({
                login: undefined,
            })
        }
    }

    routing() {
        const q = getQ()

        const loc = history.location
        let section =
            loc && loc.pathname
                ? loc.pathname.replace("/", "") === ""
                    ? "login"
                    : loc.pathname.replace("/", "")
                : "login"

        if (
            this.state.person._id &&
            (!this.state.person.avatar || !this.state.person.firstName || !this.state.person.lastName)
        ) {
            return
        }

        if (q["org"] && !this.state.org) {
            this.closeActionItem()
        }
        if (q["mission"] && !this.state.mission) {
            this.closeActionItem()
        }

        if (!q["action-item"] && this.state.showDetailsData) {
            this.setState({
                showDetailsData: null,
                showDetailsDataOptions: null,
            })
        } else if (
            q["action-item"] &&
            this.state.showDetailsData &&
            q["action-item"] !== this.state.showDetailsData._id
        ) {
            this.showActionItemDetails(q["action-item"])
        }

        if (this.theMissionsHaveLanded) {
            const orgIndex = q.org ? this.state.orgs.findIndex((o) => getObjectId(o) === q.org) : -1

            if (q.org && orgIndex === -1 && !q.hq) {
                toast.error("Sorry that Organization wasn't found. Maybe removed?")
                removeParams("org,org-tab,hq")
                return
            }

            if (q.hq && q["mission"]) {
                removeQueryParam("mission")
            }

            this.setState({
                action: q.action,
                org: q.org,
                mission: q.hq || q["create-mission"] ? null : q.mission, //&& !q.action ? q.mission: undefined,
                phase: q.hq || q["create-mission"] ? null : q.phase, //&& !q.action ? q.phase: undefined,
                orgIndex: orgIndex !== -1 ? orgIndex : undefined,
                missionCrud: q.mc,
                createMission: q["create-mission"],
                createProposal: q["create-proposal"],
                orgCrud: q.hq,
                myspace: q["create-mission"] || q["create-proposal"] || q.hq ? null : q.myspace || q.invite,
                board: section === "board" ? true : undefined,
                home: section === "home" ? true : undefined,
                login: undefined,
                timeTracking: q["time-tracking"] && !q.mission && !q.org,
                controlPanel: false,
                error: q.diagnostic,
                powerTab: q.powerTab,
            })
        } else {
            this.setState({
                myspace: q.myspace || q.invite,
                board: section === "board" ? true : undefined,
                home: section === "home" ? true : undefined,
                controlPanel: false,
            })
        }
    }
    personUploadAvatar(file, base64) {
        if (!file || !base64) return

        if (base64) {
            const mergedChange = {
                ...this.state.person,
                avatar: base64,
            }

            this.setState({
                person: update(this.state.person, { $set: mergedChange }),
            })
        }
        return apiAuth.uploadAvatar(file).then((res) => {
            if (base64) {
                const newAvatar = {
                    ...this.state.person,
                    avatar: res.avatar,
                }

                this.setState(
                    {
                        person: update(this.state.person, { $set: newAvatar }),
                    },
                    () => {
                        this.updateStateForPersonAvatar(this.state.person, true)
                    }
                )
            }
        })
    }
    personUpdate(newData) {
        const me = this

        const mergedChange = { ...this.state.person, ...newData }

        this.setState({
            person: update(this.state.person, { $set: mergedChange }),
        })

        return apiAuth
            .updateProfile(newData)
            .then((res) => {
                me.updateStateForPersonAvatar(res)
            })
            .catch((err) => {
                this.silentFail("wkje93--w--wkskwiw" + (err?.message + " - " + err?.toString()))
            })
    }

    showSignInError(msg, option = {}) {
        if (!toast.isActive("erkejreo-3ede")) {
            toast.warning(msg, { ...option, toastId: "erkejreo-3ede" })
        }
        this.setState({
            resetLoginStates: new Date().getTime(),
        })
    }
    doesEmailExist(email) {
        return apiAuth.existsPersonWithEmail(email)
    }

    signInErrorHandler(err) {
        if (["auth/account-exists-with-different-credential", "auth/credential-already-in-use"].includes(err?.code)) {
            // An account already exists with the same email address but different sign-in credentials.
            // Sign in using a provider associated with this email address.
            // https://firebase.google.com/docs/auth/web/microsoft-oauth#expandable-1
            // How do we handle this?
            // Maybe, prompt the user to set his personal email as the primary email and try again?
            // Or force him to set a personal email to distinguish the two accounts (no linking)?
            // In either case we need to give the option to the user, what they would like to do.
            // toast.error(
            //     "An account already exists with the same email address but different sign-in credentials. Please contact help@missionx.ai so we can help",
            //     {
            //         autoClose: false,
            //     }
            // )
        } else if (err?.code === "auth/provider-already-linked") {
            // User can only be linked to one identity for the given provider.
            //this.silentFail(err?.code)
            toast.error(
                "(auth/provider-already-linked) You seam to be linked to multiple accounts for this provider. Please contact your Directory admin for more assistance",
                {
                    autoClose: false,
                }
            )
        }

        throw err
    }

    async signInWithSAML(email) {
        try {
            const emailDomain = getDomainFromEmail(email)

            if (!emailDomainToSamlProviderMap.has(emailDomain)) {
                return toast.error(
                    `There's no single sign-on setup for your email. Please login with another provider or reach out to an administrator from your organization.`,
                    {
                        autoClose: 10000,
                    }
                )
            }

            const { profile } = await samlSignInWithPopup(emailDomainToSamlProviderMap.get(emailDomain))
        } catch (err) {
            this.signInErrorHandler(err)
        }
    }
    async signInWithMicrosoft(email) {
        try {
            const emailDomain = getDomainFromEmail(email)

            if (emailDomainToSamlProviderMap.has(emailDomain)) {
                return toast.error(`Please sign in with single sign-on instead.`, {
                    autoClose: 10000,
                })
            }

            if (!isActiveDirectoryEmail(email)) {
                return toast.error(
                    `There's no microsoft setup for your email. Please login with another provider or reach out to an administrator from your organization.`,
                    {
                        autoClose: 10000,
                    }
                )
            }

            await apiAuth.microsoftSignInWithPopup(["User.Read"], {
                login_hint: email,
            })
        } catch (err) {
            //this.signInErrorHandler(err)
        }
    }
    signIn(email, password, errorCb, rememberMe) {
        return apiAuth
            .signInWithEmailAndPassword(email, password, {rememberMe})
            .then((res) => {
                //The auth change listener catches this
            })
            .catch((err) => {
                if (err.code === "auth/wrong-password") {
                    this.showSignInError("Ooops. Please check that your email and password are correct.")
                    if (errorCb) errorCb()
                } else if (err.code === "auth/user-not-found") {
                    if (errorCb) errorCb()

                    return apiAuth.existsPersonWithEmail(email).then((res) => {
                        if (res.exists) {
                            if (res.primaryEmail) {
                                this.showSignInError(
                                    `👋 Hello! The email you just tried is a secondary account linked to another email address. Please use your primary email ${res.primaryEmail} to login.`,
                                    { autoClose: false }
                                )
                            } else {
                                this.showSignInError(
                                    "The email you just tried is likely a secondary email on one of your projects. Please use your primary email to login.",
                                    { autoClose: false }
                                )
                            }
                        } else {
                            this.showSignInError(
                                "Sorry the username and password we're either not found or do not match"
                            )
                        }
                    })
                }

                if (errorCb) errorCb(err)

                throw err
            })
    }
    signUp(email, password, cb) {
        return apiAuth
            .signUp(email, password)
            .then(() => {
                const q = getQ()

                return apiAuth
                    .signInWithEmailAndPassword(email, password, {rememberMe: true})
                    .then(() => apiAuth.getCurrentUser())
                    .then(() =>
                        !["invite", "orgInvite"].includes(q.from) ? apiAuth.sendEmailVerification() : Promise.resolve()
                    )
                    .catch((err) => {})
            })
            .catch((err) => {
                if (err === "Unauthorized") {
                    return
                }
                if (cb) cb(err)
            })
    }
    enterTest(email, password, rememberMe) {
        const q = getQ()

        this.tooLong1 = setTimeout(() => {
            toast.error(
                "This is taking way too long. Somethings not right with the connection. Maybe try refreshing the page and we'll check on our side.",
                {
                    duration: 7000,
                }
            )

            me.resetEntryStates()
        }, 10000)

        if (!email || !password) {
            return this.showSignInError("Somethings missing. Please check that your email and password are ok.")
        }

        const me = this

        apiAuth
            .signInWithEmailAndPassword(email, password, {rememberMe})
            .then((res) => {
                clearTimeout(this.tooLong1)

                //The auth change listener catches this
            })
            .catch((err) => {
                if (err.code === "auth/wrong-password") {
                    this.showSignInError("Ooops. Please check that your email and password are correct.")
                } else if (err.code === "auth/user-not-found") {
                    apiAuth
                        .existsPersonWithEmail(email)
                        .then((res) => {
                            if (res.exists) {
                                clearTimeout(this.tooLong1)
                                toast.warning(
                                    "Hi. That email you just tried is likely a secondary email on one of your missions. Try your primary email to login.",
                                    { autoClose: false }
                                )
                                me.resetEntryStates()
                            } else {
                                //OK!

                                clearTimeout(this.tooLong1)

                                apiAuth
                                    .signUp(email, password)
                                    .then(() => {
                                        apiAuth
                                            .signInWithEmailAndPassword(email, password, {rememberMe})
                                            .then(() => apiAuth.getCurrentUser())
                                            .then(() =>
                                                !["invite", "orgInvite"].includes(q.from)
                                                    ? apiAuth.sendEmailVerification()
                                                    : Promise.resolve()
                                            )
                                            .then(() => {})
                                            .catch((err) => {
                                                me.resetEntryStates()
                                                toast.error("Sorry.  " + err.message)
                                            })
                                    })
                                    .catch((err) => {
                                        history.push("/login")

                                        me.resetEntryStates()
                                        toast.warning("Sorry but there was an issue: " + err.message, {
                                            position: toast.POSITION.TOP_CENTER,
                                            autoClose: 6000,
                                        })
                                    })
                            } //End else
                        })
                        .catch((err) => {
                            clearTimeout(this.tooLong1)
                            toast.error("Failed at log in while checking if email exist. I mean c'mon us....")
                            me.resetEntryStates()
                        })
                } else if (err.code === "auth/too-many-requests") {
                    /**
                     * @makis This error could be caused by bots or malicious users.
                     * TODO: Blacklist IP and require captcha to continue.
                     */
                    toast.error("Too many attempts. Please try again later or reset your password.")
                    me.resetEntryStates()
                    clearTimeout(this.tooLong1)
                } else {
                    toast.error("Sorry. Please try again later or contact us if the issue persists.")
                    me.resetEntryStates()
                    clearTimeout(this.tooLong1)
                }
            })
    }

    personSignOut(goToLogin) {
        (async () => {
            try {
                document.getElementById("dna-body").className = ""
                this.theMissionsHaveLanded = false
                this?.block("One moment please...")

                unmountAppReconnect();
                this.unsubscribeFromIdTokenChanges();
                this.unsubscribeFromAuthStateChanged();

                await apiAuth.clearSiteData();
                await apiAuth.signOut();

                if (goToLogin !== false) {
                    if (window.location.href.includes("localhost:")) {
                        window.location = "/login"
                    } else {
                        window.location = "https://missionx.ai"
                    }
                }
            } catch(err) {
                toast.error("An issue occurred: " + err.message)
                this?.unBlock()
            }
        })();
    }
    personResetPasswordRequest(emailOrNumber) {
        if (isEmail(emailOrNumber)) {
            apiAuth
                .sendPasswordResetEmail(emailOrNumber)
                .then((res) => {
                    toast.warning("Ok sent.‍ Please check your email and follow the link.", {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 5000,
                    })
                })
                .catch((err) => {
                    toast.error(err?.message || "I'm sorry there was an issue. Please contact help@missionx.ai.", {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 6000,
                    })
                })
        } else if (isMobilePhone(emailOrNumber)) {
            //  https://firebase.google.com/docs/auth/web/phone-auth
            //  3. Send a verification code to the user's phone
        } else {
            toast.error("Sorry. I didn't recoginize where you want me to send the reset details.")
        }
    }
    personConfirmPasswordReset(newPassword, cbError) {
        const me = this

        apiAuth
            .confirmPasswordReset(this.tempResetCode, newPassword)
            .then((res) => {
                toast.success("You did it! You're the best.", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 5000,
                })

                apiAuth
                    .signInWithEmailAndPassword(me.tempResetEmail, newPassword, {rememberMe: true})
                    .then(() => {
                        me.resetEntryStates()
                        history.push("/home")
                    })
                    .catch((err) => {
                        cbError(err)
                        me.resetEntryStates()
                    })
            })
            .catch((err) => {
                toast.error("An issue occurred: " + err.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 6000,
                })
            })
    }
    personActivateCode(code) {
        //The scenario we texted a code to their phone
        //  https://firebase.google.com/docs/auth/web/phone-auth
        //Here i will send you an email or phone number plus the code...
        /*
        MIKE CODE
        authApi.validateResetCode(code,emailOrNumber).then(res=>{
            //MIKE CODE signperson automatically
            addParam('password-reset')
        }).catch(err=>{
        //Makis here
      })
        */
    }
    updateTimeTracking() {
        this.setState({
            hasTimeTracking: this.state.orgs.find((o) => o.isLicensedActive),
        })
    }
    missionSetupBudget(obj) {
        this.setState({
            missionSetupBudget: obj,
        })
    }
    block = (...args) => {
        // defaults
        let msg = "One moment please...",
            tag = "Working",
            to = 300,
            loader = "bar"

        const first = args[0]

        // Only treat as new-style config if it's the single arg and contains known config keys.
        const looksLikeConfig =
            args.length === 1 &&
            first &&
            typeof first === "object" &&
            ("msg" in first || "tag" in first || "to" in first || "loader" in first || "type" in first)

        if (looksLikeConfig) {
            ;({ msg = "One moment please...", tag = "Working", to = 300, loader = "bar" } = first)
        } else {
            // old-style positional: (msg, to)
            ;[msg = "One moment please...", to = 300] = args
        }

        const obj = {
            loadingBlocker: true,
            loadingBlockerMessage: msg,
            loadingBlockerLoader: loader,
            loadingBlockerTag: tag,
        }

        if (this.state.loadingBlocker) return

        if (!to) {
            this.setState(obj)
        } else {
            clearTimeout(this.blockTO)
            this.blockTO = setTimeout(() => {
                this.setState(obj)
            }, Number(to))
        }
    }

    unBlock() {
        clearTimeout(this.blockTO)
        this.setState({
            loadingBlocker: false,
        })
    }
    hideAppElements() {
        this.setState({
            hideDamKnob: true,
            hideAvatar: true,
            hideExtras: true,
        })
    }

    showAppElements() {
        this.setState({
            hideDamKnob: false,
            hideAvatar: false,
            hideExtras: false,
        })
    }
    hideNavigator() {
        this.hideKnobs()
    }
    showNavigator() {
        this.showKnobs()
    }
    hideKnobs() {
        this.setState({
            hideDamKnob: true,
        })
    }

    showKnobs() {
        this.setState({
            hideDamKnob: false,
        })
    }
    hideAppAdminTools() {
        if (this.state.hideAdminTools !== true)
            this.setState({
                hideAdminTools: true,
            })
    }
    showAppAdminTools() {
        if (this.state.hideAdminTools === true)
            this.setState({
                hideAdminTools: false,
            })
    }
    reBuildState() {
        const me = this

        this.setState({
            syncBlocker: true,
        })

        console.log("missionX: State rebuild request")

        const q = new URLSearchParams(window.location.search)
        let og = q.get("org")

        if (og) {
            removeParam("org")
        }

        Promise.all([apiOrg.getOrgList(this), apiMission.streamMissionListTree(missionTreeConfig)])
            .finally(() => {
                this.setState({
                    syncBlocker: false,
                })
            })
            .then((results) => {
                const orgList = results[0] || []
                let missions = results[1] || []

                missions = missions.filter((m) => !!m && m.type !== "classic-gantt" && m.type !== "gantt")

                missions.forEach((m, i) => {
                    missions[i] = this.cleanBadData(m)
                })

                const allPlanItems = flatMap(missions, "planItems")

                let mfaDisabledMissions = []
                let mfaDisabledOrgs = []

                if (!this.state.multiFactor) {
                    mfaDisabledOrgs = orgList.filter((o) => {
                        return o.isMFARequired
                    })

                    mfaDisabledMissions = missions.filter((m) => {
                        return m.org?.isMFARequired
                    })

                    if (mfaDisabledMissions.length) {
                        missions = differenceBy(missions, mfaDisabledMissions, "_id")
                    }
                }

                const phases = allPlanItems.filter((item) => item.type === "phase")

                const actions = flatMap(phases, "actions")

                missions.forEach((m) => {
                    if (m.org && m.org._id && orgList.findIndex((o) => o._id === m.org._id) === -1) {
                        orgList.push(m.org)
                    }
                })

                this.fetchedOrgs = {}

                me.setState(
                    {
                        missions,
                        mfaDisabledMissions,
                        mfaDisabledOrgs,
                        phases,
                        actions,
                        orgs: orgList,
                        //avKey: uniqid(), //ALWAYS FORCE UPDATE, STUPID SHIT NOT WORKING
                    },
                    () => {
                        console.log("missionX: State rebuilt at " + new Date())
                        this.loadLatestNotifications()

                        this.setState({
                            missionChange: {
                                stateRebuild: uniqid(),
                            },
                        })

                        addParam("org", og)
                    }
                )
            })
            .catch((err) => {
                toast.error(err.message)
            })
    }
    cleanBadData(mission, orgs) {
        const cleanMxGanttActionItems = (action) => {
            let newActionItems = []

            action.actionItems.forEach((ai, i) => {
                if (ai.startDate && ai.startDate > ai.endDate) {
                    let change = {
                        endDate: getTimeUtc(endOfDay(toZonedTime(ai.startDate))),
                    }

                    this.actionItemUpdateX(ai, change)
                    newActionItems.push({ ...ai, ...change })

                    this.silentFail("cb-da-ai-1:" + mission._id + "-" + action._id + " " + ai._id)
                } else {
                    newActionItems.push(ai)
                }
            })

            return newActionItems || []
        }

        try {
            mission = { ...mission }

            if (!mission.people) {
                this.silentFail("people-XXX-" + mission._id + "-" + this.state.person._id)

                mission.people = []
            }

            if (mission?.org && mission.org?.isMFARequired && !this.state.multiFactor) {
                return mission
            }

            const myOrg = mission.org ? (orgs || this.state.orgs).find((o) => o._id === getObjectId(mission.org)) : null

            const meInOrg = myOrg?.people?.find((p) => getRefId(p) === this.state.person._id)
            const meInMission = mission.people?.find((p) => getRefId(p) === this.state.person._id)

            const canUpdate =
                meInOrg?.permission === 2 || meInMission?.permission === 1 || meInMission?.permission === 2

            mission.people = mission.people?.length
                ? uniqBy(
                      (mission.people || []).map((p) => ({ ...p, rfxs: getRefId(p) })),
                      "rfxs"
                  )
                : []

            if (!mission.planStartDate || !mission.planEndDate || mission.planStartDate > mission.planEndDate) {
                if (!mission.planStartDate && !mission.planEndDate) {
                    const d = getTimeUtc(startOfDay(new Date()))

                    mission.planStartDate = d
                    mission.planEndDate = getTimeUtc(addMonths(d, 3))

                    if (canUpdate)
                        this.missionUpdate(
                            mission._id,
                            {
                                planStartDate: mission.planStartDate,
                                planEndDate: mission.planEndDate,
                            },
                            null,
                            true
                        )

                    this.silentFail("mxs-11" + mission._id)
                }
                if (!mission.planStartDate && mission.planEndDate) {
                    const d = getTimeUtc(startOfDay(subMonths(toZonedTime(mission.planEndDate), 2)))

                    mission.planStartDate = d

                    if (canUpdate)
                        this.missionUpdate(
                            mission._id,
                            {
                                planStartDate: d,
                            },
                            null,
                            true
                        )
                    this.silentFail("mxs-12" + mission._id)
                } else if (mission.planStartDate && !mission.planEndDate) {
                    const d = getTimeUtc(endOfDay(addMonths(toZonedTime(mission.planStartDate), 2)))

                    mission.planEndDate = d
                    if (canUpdate)
                        this.missionUpdate(
                            mission._id,
                            {
                                planEndDate: d,
                            },
                            null,
                            true
                        )
                    this.silentFail("mxs-13" + mission._id)
                } else if (mission.planStartDate > mission.planEndDate) {
                    const d = getTimeUtc(endOfDay(addMonths(toZonedTime(mission.planStartDate), 3)))

                    mission.planEndDate = d
                    if (canUpdate)
                        this.missionUpdate(
                            mission._id,
                            {
                                planEndDate: getTimeUtc(endOfDay(addMonths(toZonedTime(mission.planStartDate), 3))),
                            },
                            null,
                            true
                        )
                    this.silentFail("mxs-14" + mission._id)
                }
            }

            let newPlanItems = []

            mission.planItems.forEach((planItem, piIndex) => {
                //ERROR
                if (planItem.startDate && planItem.startDate > planItem.endDate) {
                    let change = {}

                    if (planItem.type === "person") {
                        if (planItem.startDate > mission.planEndDate) {
                            change = {
                                startDate: mission.planStartDate,
                                endDate: mission.planEndDate,
                            }
                            newPlanItems.push({ ...planItem, ...change })
                        } else {
                            change = {
                                endDate: mission.planEndDate,
                            }
                            newPlanItems.push({ ...planItem, ...change })
                        }

                        this.silentFail("mx-wpw-1" + mission._id + "-" + planItem._id)
                    } else if (planItem.type === "cost") {
                        if (planItem.rateTime === "One time") {
                            change = {
                                endDate: getTimeUtc(endOfDay(toZonedTime(planItem.startDate))),
                            }
                        } else {
                            this.planItemRemoveX(planItem)
                            //remove
                            //dont push
                            this.silentFail("mx-wpw-2" + mission._id + "-" + planItem._id)
                        }
                    } else if (planItem.type === "phase") {
                        change = {
                            startDate: mission.planStartDate,
                            endDate: mission.planEndDate,
                        }
                        newPlanItems.push({ ...planItem, ...change })
                        this.silentFail("mx-wpw-3" + mission._id + "-" + planItem._id)
                    } else if (
                        planItem.type === "fundable_milestone" ||
                        planItem.type === "outcome" ||
                        planItem.type === "milestone"
                    ) {
                        change = {
                            endDate: getTimeUtc(endOfDay(toZonedTime(planItem.startDate))),
                        }
                        newPlanItems.push({ ...planItem, ...change })
                        this.silentFail("mx-wpw-4" + mission._id + "-" + planItem._id)
                    }

                    if (canUpdate) this.planItemUpdateX(planItem, change)

                    //done
                } else if (!planItem.startDate && !planItem.endDate) {
                    if (planItem.type === "phase") {
                        const change = {
                            startDate: mission.planStartDate,
                            endDate: mission.planEndDate,
                        }

                        if (canUpdate) this.planItemUpdateX(planItem, change)
                        newPlanItems.push({ ...planItem, ...change })

                        this.silentFail("mx-wpw-5" + mission._id + "-" + planItem._id)
                    } else {
                        if (canUpdate) this.planItemRemoveX(planItem)

                        this.silentFail("mx-wpw-6" + mission._id + "-" + planItem._id)
                        //dont push
                    }
                } else {
                    newPlanItems.push(planItem)
                }

                newPlanItems.forEach((pi, i) => {
                    let myActions = []

                    pi.actions.forEach((action, i) => {
                        if (mission.projectType === "mx-gantt" && action.actionItems.length) {
                            action.actionItems = cleanMxGanttActionItems(action)
                        }

                        if (action.startDate > action.endDate || !action.startDate || !action.endDate) {
                            if (mission.projectType === "kanban" || mission.projectType === "simple") {
                                const change = { startDate: mission.planStartDate, endDate: mission.planEndDate }
                                this.actionUpdate(action, change, true)
                                myActions.push({ ...action, ...change })

                                //this.silentFail("mx-awest-0" + mission._id + "-" + planItem._id)
                            } else if (mission.projectType === "mx-gantt") {
                                const change = { startDate: mission.planStartDate, endDate: mission.planEndDate }
                                if (canUpdate) this.actionUpdate(action, change, true)
                                myActions.push({ ...action, ...change })
                                //this.silentFail("mx-awest-1" + mission._id + "-" + planItem._id)
                            } else {
                                if ((action?.actionItems || []).length === 0) {
                                    if (canUpdate) this.actionDeleteX(action)
                                    //dont push
                                    //this.silentFail("mx-awest-2" + mission._id + "-" + planItem._id)
                                } else {
                                    if (mission.projectType === "power") {
                                        if (action.startDate) {
                                            const change = {
                                                endDate: getTimeUtc(
                                                    endOfWeek(toZonedTime(action.startDate), { weekStartsOn: 1 })
                                                ),
                                            }

                                            this.actionUpdate(action, change, true)

                                            myActions.push({ ...action, ...change })
                                            //this.silentFail("mx-awest-3" + mission._id + "-" + planItem._id)
                                        } else {
                                            this.actionDeleteX(action)
                                            //dont push
                                            //this.silentFail("mx-awest-4" + mission._id + "-" + planItem._id)
                                        }
                                    } else {
                                        const change = {
                                            startDate: mission.planStartDate,
                                            endDate: mission.planEndDate,
                                        }

                                        this.actionUpdate(action, change, true)
                                        myActions.push({ ...action, ...change })
                                        //this.silentFail("mx-awest-5" + mission._id + "-" + planItem._id)
                                    }
                                }
                            }
                        } else {
                            myActions.push(action)
                        }
                    })
                    newPlanItems[i].actions = myActions
                })
            })

            mission.planItems = newPlanItems
        } catch (err) {
            this.silentFail("clean-bad-data-fail " + (err?.message + " - " + err?.toString()))
        }

        return mission
    }

    onAsyncMissionsLoaded({ missions, orgList }) {
        missions = missions.filter((m) => !!m && m.type !== "classic-gantt" && m.type !== "gantt")
        let newMissions = []

        missions.forEach((m, i) => {
            const cm = this.cleanBadData(m, orgList)
            if (cm) {
                newMissions.push(cm)
            }
        })

        missions = newMissions

        let mfaDisabledMissions = []

        if (!this.state.multiFactor) {
            mfaDisabledMissions = missions.filter((m) => {
                return m.org?.isMFARequired
            })

            if (mfaDisabledMissions.length) {
                missions = differenceBy(missions, mfaDisabledMissions, "_id")
            }
        }

        //Check for missing orgs in case user is not org authed.
        missions.forEach((m) => {
            if (m.org && m.org._id && orgList.findIndex((o) => o._id === m.org._id) === -1) {
                orgList.push(m.org)
            }
        })

        const orgLincesed = orgList.find((o) => o.isLicensedActive)

        const tt = orgLincesed || existsTimeTracking(missions)

        this.setState(
            {
                waiting: false,
                missions: missions,
                mfaDisabledMissions: mfaDisabledMissions,
                orgs: orgList,
                hasTimeTracking: tt,
                theMissionsHaveLanded: true,
            },
            async () => {
                this.theMissionsHaveLanded = true

                this.loadLatestNotifications()

                this.routing()

                const q = getQ()

                if (q["action-item"]) {
                    this.showActionItemDetails(getQ()["action-item"])
                }

                this.changeListener()

                /*try {
                    let missing = []
                    missing = await getMissingTimesheets(this)
                    this.setState({
                        missingTimesheets: missing.length,
                    })
                } catch (e) {}*/

                this.checkVersion()
            }
        )
    }

    async buildMissionTree(orgList) {
        let mfaDisabledOrgs = []

        orgList = orgList.map((o) => ({ ...o, clients: o.clients || [] }))

        if (!this.state.multiFactor) {
            mfaDisabledOrgs = orgList.filter((o) => {
                return o.isMFARequired
            })

            this.setState({
                mfaDisabledOrgs: mfaDisabledOrgs,
            })
        }

        if (!this.state.missions?.length) {
            // Load from cache until is loaded from API
            try {
                const data = await apiMission.streamMissionListTree(missionTreeConfig, { cached: true })

                if (data) {
                    this.onAsyncMissionsLoaded({ missions: data, orgList })
                }
            } catch (err) {
                // Nothing
            }
        }

        if (mfaDisabledOrgs?.length && !this.state.multiFactor && !this.hasSeenMsg("org-2fa-must")) {
            this.confirm({
                severe: true,
                comp: (
                    <>
                        <p>Hey {this.state.person.firstName}👋</p>
                        <p>
                            {mfaDisabledOrgs.length === 1 ? "An organization requires" : "Some organizations require"}{" "}
                            you to setup two-factor authentication for extra account security at login.{" "}
                        </p>
                        <p>You will not be able to access projects and data until you do so.</p>
                    </>
                ),
                yesText: "Setup up 2FA",
                noText: "I'll do it later",
                singleClick: true,
                noCancel: true,
                onNo: () => {
                    this.setUiSeenFlags("org-2fa-must")
                },
                onYes: () => {
                    this.setUiSeenFlags("org-2fa-must")
                    removeParams("org,mission,phase,action")
                    addParam("myspace", "2fa")
                },
            })
        }

        apiMission
            .streamMissionListTree(missionTreeConfig)
            .then((missions) => this.onAsyncMissionsLoaded({ missions, orgList }))
            .catch((err) => {
                this.setState(
                    {
                        waiting: false,
                        theMissionsHaveLanded: true,
                        orgs: orgList,
                    },
                    () => {
                        this.loadLatestNotifications()
                    }
                )

                throw err
            })
    }
    checkVersion() {
        return
        const myVersion = localStorage.getItem("mission-x-version-no")

        if (!VERSION) {
            return
        }

        if (!myVersion) {
            localStorage.setItem("mission-x-version-no", VERSION)
        }

        if (+myVersion !== VERSION) {
            this.setState({
                showRefreshMessage: true,
            })
        }
    }
    getUserDomain(em) {
        const email = em || this.state.person?.email

        if (!email) return

        return email.slice(email.indexOf("@") + 1, email.length)
    }
    async personAuthInit() {
        const me = this

        await apiAuth
            .getProfile()
            .then(async (personRes) => {
                if (typeof personRes.theme === "object") {
                    personRes.theme = "empty"
                }

                this.setState(
                    {
                        person: personRes,
                    },
                    () => {
                        me.inLogic()

                        apiOrg
                            .getOrgList(this)
                            .then((orgList) => {
                                orgList = orgList.map((o) => ({ ...o, clients: o.clients || [] }))
                                this.buildMissionTree(orgList)
                            })
                            .catch((err) => {
                                toast.error("There was an error getting Orgs. Notifcations sent.")
                            })

                        if (personRes.mode === "dark") {
                            document.getElementById("dna-body").className = "dna-dark dna-dark-bg"
                        } else {
                            document.getElementById("dna-body").className = ""
                        }
                    }
                )
            })
            .catch((err) => {
                if (err.code === "auth/gt-inactive") {
                    return this.personSignOut()
                }
            })
    }

    personAcceptInvite(inviteId, noticeId, infoObj) {
        const me = this

        const noticeIndex = me.state.notificationList.findIndex((n) => n?._id === noticeId)

        me.setState({
            notificationList: update(me.state.notificationList, {
                $splice: [[noticeIndex, 1]],
            }),
        })

        const acceptMethod = infoObj?.informationalOnly === true ? apiMission.confirmInvite : apiMission.acceptInvite

        acceptMethod(inviteId)
            .then((res) => {
                if (!toast.isActive("welcoemAbord")) {
                    toast.success(
                        "Welcome aboard! 🚀 Check your Control panel or Mission. Vision. Board. from the project management workspace.",
                        {
                            toastId: "welcoemAbord",
                        }
                    )
                }

                if (res.org) {
                    apiOrg
                        .getOrgList(this)
                        .then((orgList) => {
                            this.buildMissionTree(orgList)
                        })
                        .catch((err) => {
                            toast.error("There was an error getting Orgs. Notifcations sent.")
                        })
                } else {
                    if (res._id) {
                        me.missionLoad(res)
                    }
                }
            })
            .catch((err) => {
                toast.error("Sorry that invite is longer valid.")
            })
    }
    personAcceptInviteOrg(inviteId, noticeId) {
        apiOrg
            .acceptInvite(inviteId)
            .then((org) => {
                toast.success("Welcome to the organization!")

                const newNotificationList = this.state.notificationList.slice()
                const notificationIndex = newNotificationList.findIndex((n) => n._id === noticeId)

                this.setState(
                    {
                        notificationList: update(this.state.notificationList, {
                            $splice: [[notificationIndex, 1]],
                        }),
                    },
                    () => {
                        if (!this.state.orgs.find((orggg) => orggg._id === org._id))
                            this.setState(
                                {
                                    orgs: update(this.state.orgs, { $push: [org] }),
                                },
                                () => {
                                    if (
                                        org.title.includes("missionX Trial") &&
                                        canAccessOrgSpace(this.state.person, org)
                                    ) {
                                        this.setState({
                                            controlPanel: true,
                                        })
                                    }
                                    this.buildMissionTree(this.state.orgs)
                                }
                            )
                    }
                )
            })
            .catch((err) => {
                toast.error(get(err, "message") || "Sorry that org invite is longer valid")
            })
    }
    personRejectInvite(inviteId, org, noticeId) {
        const apiCall = org ? apiOrg : apiMission
        apiCall
            .rejectInvite(inviteId)
            .then(() => {
                let newNotificationList = this.state.notificationList.slice()
                const notificationIndex = newNotificationList.findIndex((n) => n._id === noticeId)
                newNotificationList.splice(notificationIndex, 1)
                this.setState({
                    notificationList: newNotificationList,
                })
                toast("No problem. We'll pass the msg along. Thanks!")
            })
            .catch((err) => {
                console.error("Sorry that invite is longer valid or an error has occured.")
            })
    }
    missionLoad(mission, cb) {
        const me = this

        me.setState(
            {
                missions: update(this.state.missions, { $push: [mission] }),
            },
            () => {
                if (cb) cb()
            }
        )
    }

    missionCreate(data, org, cb, options = {}, dontOpenMission) {
        apiMission
            .createMission(data, options)
            .then((mission) => {
                if (data.proposalLinkId) {
                    let proposalParent = this.state.missions.find((mmp) => mmp._id === data.proposalLinkId)

                    if (proposalParent) {
                        this.missionUpdate(proposalParent._id, {
                            linkedProject: mission._id,
                        })
                    }
                }

                if (mission.projectType === "power") {
                    this.planItemCreateX(mission, {
                        type: "phase",
                        startDate: mission.startDate,
                        endDate: mission.endDate,
                    })
                }

                this.updateStateForMissionCreate(mission, () => {
                    if (!dontOpenMission) {
                        if (mission.type === "power") {
                            addParams([{ param: "mission", value: mission._id }])
                        } else {
                            addParam("mission", mission._id)
                            removeParams("mc,mc-org,mc-org-goal,mc-prop,create-proposal")
                        }
                    }
                    let meInOrg = {}
                    let orgRole
                    if (org) {
                        meInOrg = (org.people || []).find((p) => getRefId(p) === mission.createdBy._id)
                        if (meInOrg) {
                            orgRole = getRole(meInOrg.role, org)
                        }
                    }

                    let roleDetailsObj = {}

                    if (!org || !org.isLicensedActive || (org && !org.projectCreationRestricted)) {
                        roleDetailsObj = {
                            role: orgRole ? orgRole._id : "Project manager",
                            rate: orgRole ? orgRole.cost : 0,
                            rateTime: orgRole?.rateTime || "Monthly",
                            billRate: orgRole ? orgRole.billRate : 0,
                            billUnit: orgRole && orgRole.billUnit ? orgRole.billUnit : "Hourly",
                            person: mission.createdBy._id, //catch flow below
                        }
                    } else if (org && org.projectCreationRestricted) {
                        roleDetailsObj = {
                            role: "Project manager",
                            rate: 0,
                            rateTime: org?.roleDefaultRateTime || "Hourly",
                            billRate: 0,
                            billUnit: "Hourly",
                            person: null,
                        }
                    }

                    //Create default role for admin / pm unless the org requires approvals
                    const createConditions =
                        mission.projectType !== "mx-gantt" &&
                        !data.isTemplate &&
                        !mission.isModel &&
                        !options?.template &&
                        !org?.projectCreationRestricted &&
                        !org?.isLicensedActive

                    if (createConditions || !org) {
                        this.planItemCreateX(
                            mission._id,
                            {
                                title: "Project manager",
                                role: roleDetailsObj.role,
                                allocation: 100,
                                rateTime: roleDetailsObj?.rateTime || "Monthly",
                                type: "person",
                                pinnedTo: "entireMission",
                                rate: roleDetailsObj.rate || 0,
                                billRate: roleDetailsObj.billRate || 0,
                                billUnit: roleDetailsObj.billUnit || "Hourly",
                                y: 0,
                                person: roleDetailsObj.person,
                                startDate: mission.planStartDate
                                    ? mission.planStartDate
                                    : getTimeUtc(startOfDay(new Date())),
                                endDate: mission.planEndDate
                                    ? mission.planEndDate
                                    : getTimeUtc(endOfMonth(addMonths(startOfDay(new Date()), 4))),
                            },
                            (res) => {
                                //check if we can approve this role and assign person

                                //If PM

                                if (org && meInOrg) {
                                    if (
                                        org.rolesNeedApproval &&
                                        (meInOrg.canApproveRoles || meInOrg.permission === 2)
                                    ) {
                                        assignPersonToRole(meInOrg, res, meInOrg.role, org, mission, this, null, true)
                                    }
                                }
                            }
                        )
                    }

                    if (cb) cb(mission)
                })
            })
            .catch((err) => {
                toast.error(err?.msg || err || "Problem creating project please refresh and try again. We're sorry.")
                console.error(err)

                switch (err.code) {
                    case "account_limit":
                        return toast("Hello! Sorry there is a limit for now. Please contact us help@missionx.ai", {
                            autoClose: 7000,
                        })
                }

                this.unBlock()

                removeParam("create-mission")

                return toast.error(err.message)
            })
    }

    missionAddSectionTag(missionId, tag, cb) {
        const me = this

        apiMission
            .addMissionSectionTag(missionId, tag)
            .then((res) => {
                me.missionUpdateState(missionId, { sectionTags: res.sectionTags })

                if (cb && res.sectionTags) cb(res.sectionTags[res.sectionTags.length - 1])

                const myMission = this.state.missions.find((m) => m._id === missionId)
                if (myMission.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                toast.error(
                    get(err, "message") ||
                        "Sorry an error occured. Please refresh and try again. We are also investigating."
                )
            })
    }
    missionUpdateSectionTag(mission, tag, change, cb) {
        if (tag._id === "catch-all") {
            return
        }

        const tIndex = mission.sectionTags.findIndex((t) => t._id === tag._id)
        const oldTags = mission.sectionTags.slice()

        if (tIndex !== -1) {
            let newTags = mission.sectionTags.slice()
            newTags[tIndex] = { ...newTags[tIndex], ...change }

            this.missionUpdateState(mission._id, { sectionTags: newTags })
        }

        apiMission
            .updateMissionSectionTag(mission._id, tag._id, change)
            .then((res) => {
                this.missionUpdateState(mission._id, { sectionTags: res.sectionTags })
                this.missionUpdateSectionTagDependents(tag, change, mission)
                if (mission.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(mission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
                if (cb) {
                    cb(res)
                }
            })
            .catch((err) => {
                toast.error(
                    get(err, "message") ||
                        "Sorry an error occured. Please refresh and try again. We are also investigating."
                )

                this.missionUpdateState(mission._id, { sectionTags: oldTags })
            })
    }
    missionDeleteSectionTag(missionId, tag, cb) {
        apiMission
            .deleteMissionSectionTag(missionId, tag._id)
            .then((res) => {
                this.missionUpdateState(missionId, { sectionTags: res.sectionTags })
                if (cb) cb(res)

                const myMission = this.state.missions.find((m) => m._id === missionId)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                toast.error(
                    get(err, "message") ||
                        "Sorry an error occured. Please refresh and try again. We are also investigating."
                )
            })
    }

    simpleMissionsAddRoleForNewPerson(person, mission) {
        if (this.doubleClickProtectForsimpleMissionsAddRoleForNewPerson) return

        this.doubleClickProtectForsimpleMissionsAddRoleForNewPerson = true

        let org, orgRole, meInOrg

        if (!mission) return

        if (mission.org) {
            org = this.state.orgs.find((o) => o._id === getObjectId(mission.org))

            meInOrg = org?.people.find((op) => getRefId(op) === this.state.person._id)

            if (org && (!org.rolesNeedApproval || person.autoCreateRole)) {
                const personInOrg = (org.people || []).find(
                    (p) => getRefId(p) === (person.inviteeRef || getRefId(person.ref) || getRefId(person))
                )
                if (personInOrg) {
                    orgRole = getRole(personInOrg.role, org)
                }
            } else {
                return false
            }
        }

        if (!org?.isLicensed) {
            return false
        }

        //Catches the roles need approval scenario and the person can approve override (CheckBoxes from mission invite)
        if (org && org.rolesNeedApproval && !person.autoCreateRole) return

        const theID = person.inviteeRef || getRefId(person)

        if (getQ()["invite-to-phase"]) {
            const pi = mission.planItems.find((pi) => pi._id === getQ()["invite-to-phase"])

            if (pi) {
                this.planItemUpdateX(
                    pi,
                    {
                        person: theID,
                    },
                    () => {
                        toast("Person was added to the role.")
                    }
                )
            }

            removeParam("invite-to-phase")
            return
        }

        const planItemAlreadyExists = mission.planItems.find((pi) => pi.person === theID && !pi.personLeftRole)

        if (planItemAlreadyExists) {
            toast.error(
                'Sorry we found a potential conflict with another role. Please assign manually in the projects "Budget" panel',
                {
                    autoClose: false,
                }
            )
            return
        }

        const catchStd =
            isAfter(startOfDay(new Date()), toZonedTime(mission.planEndDate)) ||
            isBefore(startOfDay(new Date()), toZonedTime(mission.planStartDate))
                ? toZonedTime(mission.planStartDate)
                : startOfDay(new Date())

        const cathEnd = toZonedTime(mission.planEndDate)

        this.planItemCreateX(
            mission._id,
            {
                title: orgRole ? orgRole.title : person.config ? person.config.role : "Team member",
                role: orgRole ? orgRole._id : null,
                allocation: 100,
                rateTime: orgRole?.rateTime || org?.roleDefaultRateTime || "Hourly",
                type: "person",
                pinnedTo: "entireMission",
                rate: orgRole ? orgRole.cost : 0,
                billRate: mission.billUsingMilestones ? 0 : orgRole ? orgRole.billRate : 0,
                billUnit: orgRole?.billUnit || org?.roleDefaultRateTime || "Hourly",
                y: 0,
                person: theID,
                startDate: getTimeUtc(catchStd),
                endDate: getTimeUtc(cathEnd),
            },
            (piRes) => {
                if (org && meInOrg) {
                    if (org.rolesNeedApproval && (meInOrg.canApproveRoles || meInOrg.permission === 2)) {
                        assignPersonToRole(theID, piRes, orgRole ? orgRole._id : null, org, mission, this, null, true)
                    }
                }

                this.doubleClickProtectForsimpleMissionsAddRoleForNewPerson = undefined
            }
        )
    }
    profileUpdateState(changeObj) {
        this.setState({
            person: update(this.state.person, {
                $merge: changeObj,
            }),
        })
    }

    /**
     * Fetch one or more mission trees and update state.
     * @param mid {string|string[]} One or more mission ids
     */
    async missionGetTree(mid, cb) {
        mid = !Array.isArray(mid) ? [mid] : mid
        const me = this

        let newMissionArray = []

        try {
            newMissionArray = await apiMission.streamMissionListTree({
                mission: mid,
            })
        } catch (e) {
            this.silentFail("missionGetTree-3983" + e?.message)
            return
        }

        let orgList = this.state.orgs.slice()
        let uMissions = me.state.missions.slice()

        if (mid.length === 1 && !newMissionArray?.length) {
            this.missionCleanUpDeleted(mid[0])

            return
        } else {
            newMissionArray.forEach((m, i) => {
                newMissionArray[i] = this.cleanBadData(m, orgList)
            })

            newMissionArray.forEach((m) => {
                if (m.org && m.org._id && orgList.findIndex((o) => o._id === m.org._id) === -1) {
                    orgList.push(m.org)
                }

                let mIndex = this.state.missions.findIndex((p) => p._id === m._id)

                if (mIndex === -1) {
                    uMissions.push(m)
                } else {
                    uMissions = update(this.state.missions, {
                        [mIndex]: { $set: m },
                    })
                }
            })

            let openMissionIndex = this.state.mission ? uMissions.findIndex((m) => m._id === this.state.mission) : -1

            this.setState(
                {
                    missions: uMissions,
                    orgs: orgList,
                },
                () => {
                    if (cb) {
                        cb(uMissions)
                    }

                    if (openMissionIndex !== -1) {
                        this.setState({
                            missionChange: {
                                for: "mission",
                                change: {},
                                timestamp: uniqid(),
                                obj: this.state.missions[openMissionIndex],
                                missionId: this.state.missions[openMissionIndex]._id,
                            },
                        })
                    }

                    this.unBlock()
                }
            )
        }
    }
    missionUpdateState(id, change, cb, push) {
        let changedIndex = this.state.missions.findIndex((mission) => mission._id === id)

        let changeObj

        try {
            if (changedIndex !== -1) {
                changeObj = {
                    missions: update(this.state.missions, {
                        [changedIndex]: { $merge: change },
                    }),
                }
            } else if (push) {
                let newMs = this.state.missions.slice()
                newMs.push(change)
                changedIndex = newMs.length - 1
                changeObj = {
                    missions: newMs,
                }
            }
        } catch (e) {
            this.silentFail("emknrwje3oijrmkew", e?.message || e)
        }

        if (changedIndex === -1) {
            return
        }

        this.setState(changeObj, () => {
            this.setState(
                {
                    missionChange: {
                        for: "mission",
                        change: change,
                        timestamp: uniqid(),
                        obj: this.state.missions[changedIndex],
                        missionId: this.state.missions[changedIndex]._id,
                    },
                },
                () => {
                    if (cb) {
                        cb(this.state.missions[changedIndex])
                    }
                }
            )
        })
    }
    missionUpdate(id, change, cb, overrideState) {
        const changedIndex = this.state.missions.findIndex((mission) => mission._id === id)

        if (changedIndex === -1 && !overrideState) {
            toast.warning(
                "An update was triggered but I couldn't find the mission you are trying to update. Please email us at help@missionx.ai if the problem persists",
                {
                    autoClose: 6000,
                }
            )
            this.silentFail("An update was triggered but I couldn't find the mission you are trying to " + id)
            return
        }

        if (change.org && typeof change.org === "string") {
            change.org = this.state.orgs.find((org) => org._id === change.org)
        }

        if (change.org && typeof change.org !== "string") {
            change.org = change.org._id
        }

        const preChange = { ...this.state.missions[changedIndex] }

        let missionData = { ...this.state.missions[changedIndex], ...change }

        if (missionData?.isTemplate && !change.hasOwnProperty("isTemplateSaved")) {
            change.isTemplateSaved = false
            missionData.isTemplateSaved = false
        }

        if (missionData.planEndDate < missionData.planStartDate) {
            missionData.planEndDate = getTimeUtc(
                endOfWeek(toZonedTime(missionData.planStartDate), 1, { weekStartsOn: 1 })
            )
            change.planEndDate = getTimeUtc(endOfWeek(toZonedTime(change.planStartDate), 1, { weekStartsOn: 1 }))
        }

        this.missionUpdateState(id, change, () => {
            if (cb) cb(this.state.missions[changedIndex])

            if (change.planStartDate || change.planEndDate) {
                this.missionUpdatePinnedItems(missionData, preChange.planStartDate, preChange.planEndDate)
            }
        })

        return apiMission.updateMission(id, change).catch((err) => {
            try {
                this.silentFail(getErrorMsg(err))
            } catch (e) {
            } finally {
            }
        })
    }

    missionUpdateSectionTagDependents(tag, change, mission) {
        if (!change.from && !change.to) {
            return
        }

        let actionChanges = []
        let allActionItemChanges = []

        const actions = getAllActions(mission).filter(
            (a) =>
                a.startDate &&
                a.endDate &&
                a.actionItems &&
                a.actionItems[0] &&
                a.actionItems[0].sectionTagId === tag._id
        )

        let updateActions = actions.filter((ac) => {
            if (
                ac.status !== "done" &&
                ac.actionItems[0] &&
                ac.actionItems[0].status !== "done" &&
                ac.startDate &&
                ac.endDate &&
                (isBefore(ac.endDate, change.from) || isBefore(change.to, ac.startDate))
            ) {
                return true
            }

            return false
        })

        if (mission.projectType === "kanban") {
            //Items in prigress leave alone

            updateActions = updateActions.filter((a) => a.actionItems[0].col === "todo")
        } else if (mission.projectType === "simple") {
            //Items in progress leave alone

            updateActions = updateActions.filter((a) => {
                let ok = true

                const ai = a.actionItems[0]

                if (
                    isThisWeek(toZonedTime(ai.startDate)) &&
                    isBefore(toZonedTime(ai.startDate), new Date()) &&
                    ai.people.length > 0
                ) {
                    ok = false
                }

                return ok
            })
        }

        updateActions.forEach((action, i) => {
            let aEndDate = endOfWeek(change.from, { weekStartsOn: 1 })

            if (isAfter(aEndDate, toZonedTime(mission.planEndDate))) {
                aEndDate = toZonedTime(mission.planEndDate)
            }

            const actionEndDate =
                toZonedTime(change.to) && isAfter(aEndDate, change.to) ? change.to : getTimeUtc(aEndDate)

            actionChanges.push({
                _id: action._id,
                startDate: change.from,
                endDate: actionEndDate,
            })

            const ai = action.actionItems[0]
            if (ai.startDate && (ai.startDate < change.from || ai.startDate > change.to)) {
                if (mission.projectType === "kanban") {
                    allActionItemChanges.push({
                        obj: ai,
                        change: {
                            _id: ai._id,
                            startDate: change.from,
                        },
                    })
                } else if (mission.projectType === "simple") {
                    let sStartDay = toZonedTime(change.from).getDay()
                    let sStartHour = sStartDay === 0 ? 6 * 8 : (sStartDay - 1) * 8

                    let sEstimateDuration =
                        sStartHour + ai.estimatedDuration > 56 ? 56 - sStartHour : ai.estimatedDuration

                    allActionItemChanges.push({
                        obj: ai,
                        change: {
                            _id: ai._id,
                            startDate: change.from,
                            startHour: sStartHour,
                            estimatedDuration: sEstimateDuration,
                        },
                    })
                }
            }
        })

        if (actionChanges.length) {
            const endingS = actionChanges.length === 1 ? "" : "s"
            if (!toast.isActive("sectTagKiller"))
                toast.success(
                    actionChanges.length +
                        " task" +
                        endingS +
                        " on your work board not being worked on " +
                        (endingS === "s" ? "have been" : "has been") +
                        " moved to align with the new dates.",
                    {
                        autoClose: 7000,
                        toastId: "sectTagKiller",
                    }
                )

            this.actionUpdateBulk(mission._id, actionChanges, true)
        }
        if (allActionItemChanges.length) {
            this.actionItemUpdateBulk(mission._id, allActionItemChanges)
        }
    }
    missionUpdatePerson(missionId, missionPersonId, changeObj, cb) {
        const myMission = this.state.missions.find(m=>m._id===missionId)

        return apiMission
            .updateMissionPeople(missionId, missionPersonId, changeObj)
            .then((res) => {

                let newMission = {...myMission}

                if (res?.people) {
                    this.missionUpdateState(missionId, { people: res.people })
                    let newMission = res
                }else if(res){
                    const myIndex =myMission.people?.findIndex(p=>p._id===missionPersonId)
                    myMission.people[myIndex] = res
                        let newMission = myMission

                    this.missionUpdateState(missionId, { people: myMission.people })
                }

                if (cb) cb(myMission)
            })
            .catch((err) => {
                toast.error(`🤔 Something went wrong.... ${err ? err.message : ""}`)
                if (cb) cb()
            })
    }
    orgUpdatePerson(orgId, orgPersonId, changeObj, cb) {
        apiOrg
            .updateOrgPeople(orgId, orgPersonId, changeObj)
            .then((res) => {
                if (cb) {
                    cb(res)
                }

                let newOrg = this.state.orgs.find((o) => getObjectId(o) === orgId)
                let personIndex = newOrg.people.findIndex((p) => getRefId(p) === getRefId(res))
                const ref = newOrg.people[personIndex].ref

                if (personIndex === -1) return

                let newPeople = newOrg.people.slice()

                newPeople[personIndex] = { ...res, ref }

                this.orgUpdateState(newOrg, { people: newPeople })
            })
            .catch((err) => {
                toast.error(`On no. Something went wrong updating the member. ${err ? err.message : ""}`, {
                    autoClose: 5000,
                })
                this.silentFail("wjehyhkk-1" + err?.message || err)
            })
    }

    ganttGetEndDate(ai, newStartDate) {
        const dur = ai.estimatedDuration / 8

        let theEnd = endOfDay(addDays(newStartDate, dur - 1))

        if (ai.includeWeekends) {
            return theEnd
        } else {
            if (isSaturday(newStartDate)) {
                theEnd = addDays(theEnd, 2)
            } else if (isSunday(newStartDate)) {
                theEnd = addDays(theEnd, 1)
            }

            if (isSaturday(theEnd)) {
                theEnd = nextMonday(theEnd)
            } else if (isSunday(theEnd)) {
                theEnd = nextTuesday(theEnd)
            }

            return theEnd
        }
    }
    missionPlanDates(id) {
        let mission

        if (typeof id === "string") {
            mission = this.state.missions.find((m) => m._id === id)
        } else {
            mission = this.state.missions.find((m) => m._id === id._id)
        }

        if (!mission) return

        const myPerm = getMissionPerson(mission, this.state.person._id)

        if (myPerm && myPerm.permission !== 1 && myPerm.permission !== 2) {
            return
        }

        if (mission.projectType === "power") {
            if (mission.planItems.filter((p) => p.type === "phase").length === 0) {
                return
            }

            const planItems = mission.planItems.filter((p) => p.type === "phase")

            if (planItems.length) {
                const planStartDate = planItems.sort((a, b) => a.startDate - b.startDate)[0].startDate
                const planEndDate = planItems.sort((a, b) => a.endDate - b.endDate).reverse()[0].endDate

                this.missionUpdate(mission._id, {
                    planStartDate: planStartDate,
                    planEndDate: planEndDate,
                })
            }
        }
    }
    missionUpdatePinnedItems(mission, beforeStartDate, beforeEndDate) {
        if (typeof mission === "string") {
            mission = this.state.missions.find((m) => m._id === mission)
        }

        let changeArray = []

        if (!mission.planStartDate || !mission.planEndDate) {
            return
        }

        mission.planItems
            .filter(
                (pi) =>
                    (pi.pinnedTo === "entireMission" || pi.pinnedTo === "startend") &&
                    !pi.personLeftRole &&
                    !pi.inactive
            )
            .forEach((item, i) => {
                changeArray.push({
                    obj: item,
                    change: {
                        _id: item._id,
                        startDate: mission.planStartDate,
                        endDate: mission.planEndDate,
                    },
                })
            })

        mission.planItems
            .filter((pi) => (pi.pinnedTo === "endOfMission" || pi.pinnedTo === "end") && !pi.personLeftRole)
            .forEach((item, i) => {
                const zePlanStartDate = mission.planStartDate
                const zePlanEndDate = mission.planEndDate

                let newStartDate = item.startDate

                //Project hasn't started yet, Lets change the start date as well
                if (isAfter(toZonedTime(zePlanStartDate), new Date()) && isBefore(item.startDate, zePlanStartDate)) {
                    newStartDate = zePlanStartDate
                }

                changeArray.push({
                    obj: item,
                    change: {
                        _id: item._id,
                        startDate: newStartDate,
                        endDate: zePlanEndDate,
                    },
                })
            })

        mission.planItems
            .filter((pi) => (pi.pinnedTo === "startOfMission" || pi.pinnedTo === "start") && !pi.personLeftRole)
            .forEach((item, i) => {
                let newEndDate = item.endDate

                const uStd = toZonedTime(item.startDate)
                const uEnd = toZonedTime(item.endDate)

                if (mission.planStartDate > item.endDate) {
                    const shift = eachDayOfInterval({
                        start: uStd,
                        end: uEnd,
                    }).length

                    newEndDate = endOfDay(addDays(toZonedTime(mission.planStartDate), shift - 1))

                    newEndDate = getTimeUtc(newEndDate)
                }

                changeArray.push({
                    obj: item,
                    change: {
                        _id: item._id,
                        startDate: mission.planStartDate,
                        endDate: newEndDate,
                    },
                })
            })

        if (mission.projectType !== "mx-gantt") {
            mission.planItems
                .filter((pi) => pi.type === "cost")
                .forEach((pi, i) => {
                    let newEndDate, newStartDate

                    const isRecurring = pi.rateTime !== "One time"

                    const zePlanStartDate = pi.isForecast ? mission.forecastStartDate : mission.planStartDate
                    const zePlanEndDate = pi.isForecast ? mission.forecastEndDate : mission.planEndDate

                    const amountChangeOfStartDate = beforeStartDate - zePlanStartDate
                    const amountChangeOfEndDate = zePlanEndDate - beforeEndDate

                    let numMonths = 0

                    try {
                        numMonths = eachMonthOfInterval({
                            start: toZonedTime(pi.startDate),
                            end: toZonedTime(pi.endDate),
                        }).length
                    } catch (e) {}

                    if (pi.startDate < zePlanStartDate || pi.startDate > zePlanEndDate) {
                        //Dates are fucked just fix them for now

                        newStartDate = zePlanStartDate

                        if (pi.rateTime === "One time") {
                            newEndDate = getTimeUtc(endOfMonth(toZonedTime(newStartDate)))
                        } else if (isRecurring) {
                            if (numMonths) {
                                newEndDate = getTimeUtc(endOfMonth(toZonedTime(newStartDate)))
                            } else {
                                newEndDate = getTimeUtc(addMonths(toZonedTime(newStartDate), numMonths))
                            }
                        }
                    } else if (amountChangeOfStartDate > 0 && amountChangeOfEndDate === 0) {
                        //Moved only start date back

                        if (pi.rateTime === "One time") {
                            //Shift back amount
                            newStartDate = getTimeUtc(
                                startOfMonth(toZonedTime(pi.startDate - Math.abs(amountChangeOfStartDate)))
                            )
                            newEndDate = getTimeUtc(endOfMonth(newStartDate))
                        } else if (isRecurring) {
                            //Just pull the start date back

                            newStartDate = getTimeUtc(
                                startOfMonth(toZonedTime(pi.startDate - Math.abs(amountChangeOfStartDate)))
                            )

                            //If after mission end date will get caught in fuck ups
                            if (numMonths) {
                                newEndDate = getTimeUtc(endOfMonth(toZonedTime(newStartDate)))
                            } else {
                                newEndDate = getTimeUtc(addMonths(toZonedTime(newStartDate), numMonths))
                            }
                        }
                    } else if (amountChangeOfStartDate < 0 && amountChangeOfEndDate === 0) {
                        //Start date moved forward
                        if (pi.rateTime === "One time") {
                            if (pi.startDate < zePlanStartDate) {
                                newStartDate = zePlanStartDate
                                newEndDate = getTimeUtc(endOfMonth(toZonedTime(newStartDate)))
                            }
                        } else if (isRecurring) {
                            if (pi.startDate < zePlanStartDate) {
                                newStartDate = zePlanStartDate

                                if (numMonths) {
                                    newEndDate = getTimeUtc(endOfMonth(toZonedTime(newStartDate)))
                                } else {
                                    newEndDate = getTimeUtc(addMonths(toZonedTime(newStartDate), numMonths))
                                }
                            }
                        }
                    } else if (amountChangeOfEndDate < 0 && amountChangeOfStartDate === 0) {
                        //Moved only end date backward

                        if (pi.rateTime === "One time") {
                            if (pi.endDate > zePlanEndDate) {
                                newEndDate = zePlanEndDate
                                newStartDate = getTimeUtc(startOfMonth(toZonedTime(newEndDate)))
                            } else if (isSameMonth(toZonedTime(pi.endDate), toZonedTime(zePlanEndDate))) {
                                newStartDate = pi.startDate
                                newEndDate = zePlanEndDate
                            }
                        } else if (isRecurring) {
                            if (pi.endDate > zePlanEndDate) {
                                newEndDate = zePlanEndDate

                                if (pi.startDate > newEndDate) {
                                    newStartDate = getTimeUtc(startOfMonth(toZonedTime(newEndDate)))
                                } else {
                                    newStartDate = pi.startDate
                                }
                            }
                        }
                    } else if (amountChangeOfEndDate > 0 && amountChangeOfStartDate === 0) {
                        //Moved only end date forward

                        if (isSameMonth(toZonedTime(pi.endDate), toZonedTime(zePlanEndDate))) {
                            newStartDate = pi.startDate
                            newEndDate = zePlanEndDate
                        }
                    }

                    //Catch more fuck ups
                    if (newStartDate < zePlanStartDate) {
                        newStartDate = zePlanStartDate
                    }
                    if (newEndDate > zePlanEndDate) {
                        newEndDate = zePlanEndDate
                    }

                    if (newStartDate && newEndDate)
                        changeArray.push({
                            obj: pi,
                            change: {
                                _id: pi._id,
                                startDate: newStartDate,
                                endDate: newEndDate,
                            },
                        })
                })
        }

        if (changeArray.length) {
            this.planItemUpdateBulk(mission._id, changeArray)
        }
    }
    missionCleanUpDeleted(id, personId, cb) {
        let q = getQ()

        const isMissionOpen = q.mission && q.mission === id

        const paramArray = []

        if (q["mission-create"]) {
            paramArray.push("mission-create")
        }
        if (q["mc"]) {
            paramArray.push("mc")
        }

        if (isMissionOpen) {
            paramArray.push("mission")
            paramArray.push("mission-tab")
            paramArray.push("make-week")
            paramArray.push("week")

            if (personId && personId !== this.state.personId)
                toast("Sorry this project is no longer accessible", {
                    autoClose: 6000,
                })
        }

        const missionIndex = this.state.missions.findIndex((m) => m._id === id)

        if (missionIndex === -1) {
            return
        }

        removeParams(paramArray.join(","))

        const missionData = this.state.missions[missionIndex]

        let orgOfMission = missionData?.org
            ? this.state.orgs.find((o) => getObjectId(o) === getObjectId(missionData.org))
            : null

        const meInOrg = orgOfMission ? orgOfMission?.people?.find((p) => getRefId(p) === this.state.person._id) : null

        let passThrough = false

        if (meInOrg?.permission === 1 || meInOrg?.permission === 2) {
            if (!meInOrg.accessibleDepartments?.length) {
                //Can see it at  org level
                passThrough = true
            } else if (!missionData.departments?.length) {
                //free for all
                passThrough = true
            } else if (missionData.departments?.filter((value) => meInOrg.accessibleDepartments.includes(value))) {
                //has access to the dept
                passThrough = true
            }
        }

        let newMissions = this.state.missions.slice()

        if (passThrough && personId) {
            const meInMissionIndex = newMissions[missionIndex].people.findIndex(
                (p) => getRefId(p) === this.state.person._id
            )

            if (meInMissionIndex !== -1) {
                newMissions[missionIndex].people[meInMissionIndex].permission = 4
                newMissions[missionIndex].people[meInMissionIndex].isProjectManager = null
            }
        } else {
            newMissions.splice(missionIndex, 1)
        }

        let changePasser = {
            missions: newMissions,
        }

        if (orgOfMission?.missions) {
            let mOrgIndex = orgOfMission.missions.findIndex((mm) => mm._id === missionData._id)

            if (mOrgIndex !== -1) {
                orgOfMission.missions.splice(mOrgIndex, 1)

                let newOrgs = this.state.orgs.slice()

                const myOrgIndex = this.state.orgs.find((o) => getObjectId(o) === getObjectId(missionData.org))

                newOrgs[myOrgIndex] = orgOfMission

                changePasser.orgs = newOrgs
            }
        }

        this.setState(changePasser, () => {
            this.setState(
                {
                    missionChange: {
                        for: "mission",
                        change: "people",
                        timestamp: uniqid(),
                        missionId: id,
                    },
                },
                () => {
                    if (cb) cb()
                }
            )
        })

        //test
    }

    orgRemoveMissionFromDeadline(mission, org) {
        if (!org) return

        let newProposalDeadlines = (org.proposalDeadlines || []).slice()
        let newProposalDeadlinesIndex = newProposalDeadlines.findIndex((t) => t.missionId === mission._id)

        if (newProposalDeadlinesIndex === -1) {
            return
        }

        newProposalDeadlines[newProposalDeadlinesIndex] = {
            ...newProposalDeadlines[newProposalDeadlinesIndex],
            ...{
                missionId: null,
            },
        }

        newProposalDeadlines.forEach((item, i) => {
            item.y = item.y || 0
            delete item._id
        })

        this.orgUpdate(org._id, {
            proposalDeadlines: newProposalDeadlines,
        })
    }
    missionArchive(id, cb) {
        //  this.block("Removing project ☠️")

        const me = this
        const mission = this.state.missions.find((m) => m._id === id)

        //Delete a proposal with linked project
        if (mission.linkedProject) {
            const linkedMission = this.state.missions.find((m) => m._id === mission.linkedProject)

            apiMission
                .deleteMission(id)
                .then((res) => {
                    me.missionCleanUpDeleted(id, null, () => {
                        toast("Deleted " + mission.title + ". help@missionx.ai.", {
                            autoClose: 3000,
                        })
                    })

                    if (linkedMission) {
                        apiMission
                            .deleteMission(linkedMission._id)
                            .then((res) => {
                                me.missionCleanUpDeleted(linkedMission._id)
                            })
                            .catch((err) => {
                                toast.error("🤔 " + err?.message)
                            })
                    }
                })
                .catch((err) => {
                    this.silentFail("kvnjerhfk44---" + (err?.message + " - " + err?.toString()))

                    toast.error("🤔 " + err?.message)
                })
        } else if (mission.isTemplate && mission.linkedTemplate) {
            this.block("One sec...")

            apiTemplate
                .deleteTemplateBulk([mission.linkedTemplate])
                .then(() => {
                    apiMission
                        .deleteMission(id)
                        .then((res2) => {
                            this.unBlock()
                            me.missionCleanUpDeleted(id, null, () => {
                                toast("Ok done help@missionx.ai", {
                                    autoClose: 3000,
                                })
                                if (cb) cb()
                            })
                        })
                        .catch((err) => {
                            toast.error("🤔 " + err?.message)
                        })
                })
                .catch((err) => {
                    this.silentFail("we3333rredfcerewr-" + (err?.message + " - " + err?.toString()))
                    toast.error("🤔 " + err?.message)
                    this.unBlock()
                })
        } else {
            apiMission
                .deleteMission(id)
                .then((res) => {
                    me.missionCleanUpDeleted(id, null, () => {
                        toast("Deleted " + mission.title + ". help@missionx.ai.", {
                            autoClose: 3000,
                        })
                    })
                })
                .catch((err) => {
                    this.silentFail("ewty56uhfdrtr---" + (err?.message + " - " + err?.toString()))
                    //toast.error("🤔 " + err?.message)
                })
        }
    }
    orgInvitePerson(orgid, inviteeEmail, details, cb, noTip) {
        apiOrg
            .createInvite(orgid, inviteeEmail, details)
            .then((res) => {
                if (!noTip) toast.success("Great! Invitation sent to " + inviteeEmail, { autoClose: 1000 })

                if (cb) cb(res)
            })
            .catch((err) => {
                if (cb) cb("ERROR")
                toast.error(
                    "Oh oh. Something unexpected just happened. An urgent ticket was created and a missionX helper will get back to you ASAP. In the meantime please try a browser refresh to see if that helps",
                    { autoClose: 8000 }
                )
                this.silentFail("243oih3henw" + (err?.message || err))
            })
    }
    missionInvitePerson(missionId, inviteeEmail, deets, cb) {
        let details = { ...deets, ...{ invitee: null } }

        const myMission = this.state.missions.find((m) => m._id === missionId)

        const myOrg = myMission.org ? this.state.orgs.find((o) => o._id === getObjectId(myMission.org)) : null

        const isOrgPersonAddingThemselves = myOrg?.people?.find((p) => p.email === inviteeEmail)

        apiMission
            .createInvite(missionId, inviteeEmail, details, { notify: !isOrgPersonAddingThemselves })
            .then((res) => {
                if (isOrgPersonAddingThemselves) {

                    const newMissionPeople = myMission.people.slice()
                    const myIndex = myMission.people.findIndex(
                        (p) => getRefId(p) === getRefId(isOrgPersonAddingThemselves)
                    )

                    newMissionPeople[myIndex] = res?._id  ? res : { ...newMissionPeople[myIndex], permission: 2, isProjectManager: true }

                    this.missionUpdateState(myMission._id, { people: newMissionPeople })

                    return
                }
                toast.success("Mission invite sent to " + inviteeEmail, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                })

                if (cb) cb({ ...res, ...{ inviteDetails: deets } })

                if (details.autoCreateRole) {
                    this.simpleMissionsAddRoleForNewPerson({ ...deets, ...res }, myMission)
                }

                if (myMission.autoAssign) {
                    this.missionUpdate(missionId, {
                        autoAssign: false,
                    })
                }
            })
            .catch((err) => {


                if (err.code && err.code.replaceAll(" ", "") === "invite/already_invited") {
                    //Makis

                    const personsOnMission = myMission.people.find((p) => getRefId(p) === err.data.personId)

                    if (!personsOnMission) return

                    if (personsOnMission.permission <= 3) {
                        return
                    }

                    this.missionUpdatePerson(
                        missionId,
                        personsOnMission._id,
                        { permission: details.config.permission, isProjectManager: details.config.isProjectManager },
                        null
                    )

                    if (details.autoCreateRole) {
                        this.simpleMissionsAddRoleForNewPerson({ ...deets, ...personsOnMission }, myMission)
                    }
                    setTimeout(() => {
                        if (cb) cb(personsOnMission)
                    }, 100)

                    toast.success("Mission invite for " + inviteeEmail, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    })

                    return
                }

                try {
                    this.silentFail("welkj983k03---3" + (err?.message + " - " + err?.toString()))

                    if (cb) cb(false)
                    toast.error("Sorry. " + err.message, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 5000,
                        hideProgressBar: true,
                    })
                } catch (err) {
                    this.silentFail("welkj983k03---47498" + (err?.message + " - " + err?.toString()))

                    toast.error("Sorry an issue occured. We are investigating. Please try again.")
                }
            })
    }

    missionDeletePerson({ mission, person, noToast, app }) {
        const missionPerson = mission.people.find((p) => getRefId(p) === getRefId(person))

        if (!missionPerson) {
            toast.warning(
                "Hmmm. It appears that person in not on the mission so that was easy. If this is not the case could you please refresh and try again? I have also sent an email to the team to investigate",
                { autoClose: 8000 }
            )
            app?.silentFail(
                "missionDeletePerson no person" + missionPerson?._id + "-" + getRefId(person) + "---" + mission?._id
            )

            return
        }

        const myOrg = mission.org ? app?.state.orgs.find((o) => o._id === getObjectId(mission.org)) : null

        const orgPerson = myOrg?.people?.find((p) => getRefId(p) === getRefId(person))

        const isSeniorOrgPerson = orgPerson?.permission === 2 || orgPerson?.permission === 1

        const missionPersonIndex = mission.people.findIndex((p) => getRefId(p) === getRefId(person))
        const ogPeople = mission.people.slice()
        let newMissionPeople = mission.people.slice()

        if (!isSeniorOrgPerson) {
            newMissionPeople.splice(missionPersonIndex, 1)
        } else {
            newMissionPeople[missionPersonIndex] = {
                ...newMissionPeople[missionPersonIndex],
                permission: 4,
                isProjectManager: null,
            }
        }

        if (!isSeniorOrgPerson) {
            if (this.state.mission === mission._id && getRefId(person) === this.state.person._id) {
                removeParam("mission")
            }
        }

        this.missionUpdateState(mission._id, { people: newMissionPeople })

        return apiMission
            .deleteMissionPeople(mission._id, missionPerson._id)
            .then((res) => {

                if (!noToast)
                    toast(
                        `${
                            getFullName(missionPerson?.ref?.firstName, missionPerson?.ref?.lastName) || "Person"
                        } has been removed.`
                    )
            })
            .catch((err) => {
                this.missionUpdateState(mission._id, { people: ogPeople })
                toast.error(
                    "An issue occured and the team has been notfied! Please refresh and try again or hang tight for short while while we investigate",
                    {
                        autoClose: 6000,
                    }
                )
                this.silentFail("wewww3333qeq-w8" + (err?.message + " - " + err?.toString()))
            })
    }
    orgDeletePerson(orgId, refId, ref, options = {}, cb) {
        const org = this.state.orgs.find((o) => o._id === orgId)

        if (!org) {
            window.location.href = "/home"
        }

        const meInOrg = org.people?.find((p) => getRefId(p) === this.state.person._id)
        const isMeBeingRemoved = refId === this.state.person._id
        const numberOfAdmins = org.people?.filter((p) => p.permission === 2).length
        const iAmAnAdmin = meInOrg?.permission === 2

        //Deleteing myselef scenarios

        if (isMeBeingRemoved && numberOfAdmins === 1 && iAmAnAdmin && org.people.length > 1) {
            this.confirm({
                severe: true,
                comp: (
                    <div>
                        <p>🖐️ Warning 🖐️</p>
                        <p>
                            You are the only admin for this organization. If you leave it without making someone else an
                            admin it will be deleted along with all projects.
                        </p>
                        <p>Are you 100% sure you want to delete your organization?</p>
                    </div>
                ),
                onYes: () => {
                    this.orgDelete(orgId)
                },
            })

            return
        }
        if (isMeBeingRemoved && org.people?.length === 1) {
            this.confirm({
                severe: true,
                comp: (
                    <div>
                        <p>🖐️ Warning 🖐️</p>
                        <p>
                            Leaving this org along with all its projects will delete it since you are the only person in
                            it!
                        </p>
                        <p>Are you 100% sure you want to delete this organization?</p>
                    </div>
                ),
                onYes: () => {
                    this.orgDelete(orgId)
                },
            })

            return
        }

        if (isMeBeingRemoved) {
            this.confirm({
                severe: true,
                comp: (
                    <div>
                        <p>😢 Leave this organization and all projects?</p>
                    </div>
                ),

                onYes: () => {
                    apiOrg
                        .deleteOrgPeople(org._id, refId, { removeFromMissions: true })
                        .then(() => {
                            toast.success(
                                "Ok! You no longer have access to the organization. Why not start your own? 🦁",
                                {
                                    autoClose: 5000,
                                }
                            )

                            if (cb) cb()

                            this.orgCleanUpDeleted(org._id)
                        })
                        .catch((err) => {
                            toast.error(err.message)
                        })
                },
            })

            return
        }

        //Its not me anymore....

        const personBeingRemoved = org.people.find((p) => getRefId(p) === refId)

        this.confirm({
            severe: true,
            comp: (
                <div>
                    <p>
                        Remove{" "}
                        {getFullName(
                            personBeingRemoved.ref?.firstName,
                            personBeingRemoved.ref?.lastName,
                            "this person"
                        )}
                        ? This will remove them from the organization and all projects they are on!
                    </p>
                </div>
            ),
            onYes: () => {
                this.block()

                this.orgUpdatePerson(
                    orgId,
                    refId,
                    {
                        endDate: getTimeUtc(endOfDay(new Date())),
                    },
                    () => {
                        apiOrg
                            .deleteOrgPeople(org._id, refId, { removeFromMissions: true })
                            .then(() => {
                                if (ref) {
                                    toast(`${getFullName(ref.firstName, ref.lastName) || "Person"} has been removed.`)
                                } else {
                                    toast("Done.")
                                }
                                this.unBlock()

                                if (cb) cb()
                                this.updateStateForPersonRemovedOrg(refId, orgId, true)
                            })
                            .catch((err) => {
                                toast.warning(err.message, {
                                    autoClose: 6000,
                                })
                                this.unBlock()
                                this.silentFail("2iu3sss2i3" + (err?.message + " - " + err?.toString()))
                            })
                    }
                )
            },
        })
    }
    actionResetItems(action) {
        let myActionItemsAffected = []

        action.actionItems
            .filter((localAi) => localAi.startDate && localAi.status !== "done")
            .forEach((affectedActionItem) => {
                //Reset all the action items
                myActionItemsAffected.push({
                    obj: affectedActionItem,
                    change: {
                        _id: affectedActionItem._id,
                        startDate: null,
                        endDate: null,
                        y: null,
                        estimatedDuration: null,
                        estimatedEndDate: null,
                        startHour: null,
                    },
                })
            })

        if (myActionItemsAffected.length) {
            clearTimeout(this.yourChangesMsgTO)

            this.yourChangesMsgTO = setTimeout(() => {
                if (!toast.isActive("actionKiller"))
                    toast(
                        "🚧  Hi!. " +
                            myActionItemsAffected.length +
                            " action item" +
                            (myActionItemsAffected.length === 1 ? "" : "s") +
                            " " +
                            (myActionItemsAffected.length === 1 ? "was" : "were") +
                            " moved. This affected your weekly plan.",
                        {
                            autoClose: 9000,
                            toastId: "actionKiller",
                        }
                    )
            }, 1000)

            this.actionItemUpdateBulk(action.missionId, myActionItemsAffected)
        }
    }
    actionUpdate(obj, change, ignoreState, cancelReset, cb) {
        if (!ignoreState) this.updateStateForActionUpdate(obj, change, ignoreState)

        if (!cancelReset && change.startDate && change.startDate !== obj.startDate) {
            this.actionResetItems(obj)
        }

        return apiAction
            .updateAction(obj._id, change)
            .then((res) => {
                if (cb) cb(res)

                const myMission = this.state.missions.find((m) => m._id === obj.missionId)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                try {
                    this.silentFail(
                        "wqproir3jkdeAAA" +
                            JSON.stringify(change) +
                            " " +
                            JSON.stringify(obj) +
                            " " +
                            (err?.message || JSON.stringify(err))
                    )
                } catch (e) {
                    this.silentFail("enrjejej-SILENT")
                }
            })
    }
    actionUpdateX(obj, change, ignoreState, cb, stateCb) {
        if (!ignoreState) this.updateStateForActionUpdate(obj, change, false, stateCb)

        return apiAction
            .updateAction(obj._id, change)
            .then((res) => {
                if (cb) cb(res)
                const myMission = this.state.missions.find((m) => m._id === obj.missionId)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                //toast.error("An issue occured. I've let the team know.")
                this.silentFail("wlkehj2wkkoooo" + err?.message)
            })
    }
    actionUpdateBulkX(missionId, changes, cb, stateCb) {
        this.updateStateForActionUpdateBulk(missionId, changes, stateCb)

        apiAction
            .updateActionBulk(missionId, changes)
            .then((res) => {
                const myMission = this.state.missions.find((m) => m._id === missionId)
                if (cb) {
                    cb(myMission)
                }

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                throw err
            })
    }
    actionUpdateBulk(missionId, actionChanges, updateState, cb) {
        if (actionChanges.length === 0) return

        if (updateState) {
            this.updateStateForActionUpdateBulk(missionId, actionChanges)
        }

        apiAction
            .updateActionBulk(missionId, actionChanges)
            .then((res) => {
                const myMission = this.state.missions.find((m) => m._id === missionId)
                const allActions = getAllActions(myMission)
                actionChanges.forEach((change) => {
                    const theAction = allActions.find((a) => a._id === change._id)

                    if (
                        change.startDate &&
                        this.state.missions.find((m) => m._id === missionId).projectType === "power"
                    ) {
                        this.actionResetItems(theAction)
                    }
                })

                if (cb) {
                    cb(res)
                }

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                throw err
            })
    }
    actionCreateX(action, cb, skipState, options) {
        if (
            (action.startDate && !action.endDate) ||
            (!action.startDate && action.endDate) ||
            (action.startDate && action.endDate && action.startDate === action.endDate) ||
            action.startDate > action.endDate
        ) {
            if (!toast.isActive("app-action-create"))
                toast("Sorry was not able to create. Please refresh and try again?", {
                    toastId: "app-action-create",
                })
            return
        }

        if (!action.actionItems) {
            action.actionItems = []
        }

        apiAction
            .createAction(action.planItemId, action, options)
            .then((res) => {
                if (!skipState) {
                    this.updateStateForActionCreate(res)
                }
                if (cb) cb(res)

                const myMission = this.state.missions.find((m) => m._id === res.missionId)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                throw err
            })
    }
    actionCreate(action, cb, tip, skipStateUpdate) {
        const me = this

        if (
            (action.startDate && !action.endDate) ||
            (!action.startDate && action.endDate) ||
            (action.startDate && action.endDate && action.startDate === action.endDate) ||
            action.startDate > action.endDate
        ) {
            this.silentFail("ewrkoi48i3e-238383" + action._id)
            toast("Sorry was not able to create. Please try again?")
            return
        }

        if (!action.actionItems) {
            action.actionItems = []
        }
        return apiAction
            .createAction(action.planItemId, action)
            .then((res) => {
                if (tip !== "NONE" && !toast.isActive("activityCreateApp"))
                    toast(tip ? tip : "Successfully created ⚡", {
                        toastId: "activityCreateApp",
                    })

                if (!skipStateUpdate) me.updateStateForActionCreate(res)

                if (cb) {
                    cb(res)
                }

                const myMission = this.state.missions.find((m) => m._id === res.missionId)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                throw err
            })
    }
    actionDelete(action, skipState, noToast, cb) {
        apiAction
            .deleteAction(action._id)
            .then((res) => {
                if (!this.skipState) {
                    this.updateStateForActionDelete(action)
                    if (!noToast)
                        toast.success((action.title || "item") + " was deleted", {
                            autoClose: 1000,
                        })
                }

                this.actionRemoveDependenciesAfterDelete(action)

                this.actionReplaceParentIdsAfterDelete(action)

                if (cb) cb(res, action)
            })
            .catch((err) => {
                throw err
            })
    }
    actionRemoveDependenciesAfterDelete(depAction) {
        const mission = this.state.missions.find((m) => m._id === depAction.missionId)

        getAllActions(mission)?.forEach((action, i) => {
            const foundMatch = action.dependencies?.find((d) => d.action._id === depAction._id)

            if (foundMatch) {
                apiAction.removeActionDependency(action._id, depAction._id).catch((err) => {
                    throw err
                })

                let dependencies = action.dependencies || []

                let myIndex = dependencies.find((d) => d.action._id === depAction._id)

                if (myIndex !== -1) {
                    dependencies.splice(myIndex, 1)
                }

                this.updateStateForActionUpdate(action, { dependencies: dependencies })
            }
        })
    }
    actionReplaceParentIdsAfterDelete(action, cb) {
        //Remove all parentId instances

        const myMission = this.state.missions.find((m) => m._id === action.missionId)
        const allActions = getAllActions(myMission)

        const myKids = allActions.filter((a) => a.parentId === action._id)

        let changesArray = []

        myKids.forEach((a, i) => {
            changesArray.push({
                _id: a._id,
                parentId: action.parentId || null,
            })
        })

        if (changesArray.length) {
            this.actionUpdateBulkX(myMission._id, changesArray, null, (res) => {
                if (cb) cb(res)
            })
        }
    }
    actionDeleteX(action, cb) {
        action = { ...action }

        apiAction
            .deleteAction(action._id)
            .then(() => {
                this.actionRemoveDependenciesAfterDelete(action)
                this.updateStateForActionDelete(action, (res) => {
                    if (cb) cb(res, action)
                })
            })
            .catch((err) => {
                throw err
            })
    }
    actionAddDependencyX({ action, depAction, mission, cb }) {
        apiAction
            .addActionDependency(action._id, depAction._id)
            .catch((err) => {
                throw err
            })
            .then((res) => {
                if (cb) {
                    cb(res)
                }
            })

        let dependencies = action.dependencies || []

        let newDep = {
            _id: depAction._id,
            title: depAction.title,
            missionId: depAction.missionId,
            planItemId: depAction.planItemId,
        }
        let newMiss = {
            _id: mission._id,
            title: mission.title,
        }
        let mathcingPi = mission.planItems.find((p) => p._id === depAction.missionPlanId)
        let newPi = {
            _id: mathcingPi._id,
            title: mathcingPi.title,
        }

        dependencies.push({
            action: newDep,
            missionPlan: newPi,
            mission: newMiss,
        })

        this.updateStateForActionUpdate(action, { dependencies: dependencies })
    }
    actionRemoveDependencyX({ action, depAction, mission, cb }) {
        apiAction
            .removeActionDependency(action._id, depAction._id)
            .catch((err) => {
                throw err
            })
            .then((res) => {
                if (cb) {
                    cb(res)
                }
            })

        let dependencies = action.dependencies || []

        let myIndex = dependencies.find((d) => d.action._id === depAction._id)

        if (myIndex !== -1) {
            dependencies.splice(myIndex, 1)
        }

        this.updateStateForActionUpdate(action, { dependencies: dependencies })
    }
    actionAddDependency(actionId, dependencyActionId, action, dependencies) {
        if (!actionId || !dependencyActionId) {
            console.error("id missing")
        }

        apiAction.addActionDependency(actionId, dependencyActionId).catch((err) => {
            throw err
        })

        this.updateStateForActionUpdate(action, { dependencies: dependencies })
    }
    actionRemoveDependency(actionId, dependencyActionId, action, dependencies) {
        if (!actionId || !dependencyActionId) {
            console.error("id missing")
        }

        apiAction.removeActionDependency(actionId, dependencyActionId).catch((err) => {
            throw err
        })

        this.updateStateForActionUpdate(action, { dependencies: dependencies })
    }
    actionItemAddDependency(ai, dependencyAi, linkType = "dependsOn", cb, lag) {
        if (!ai || !dependencyAi) return

        if (!linkType) {
            this.silentFail("we3e9999--" + ai._id)
            toast.warning("Oops. We spotted an issue and the team has been notified. We will respond asap! ")
            return
        }

        if (ai._id === dependencyAi._id) {
            this.silentFail("wewe727272--" + ai._id)
            return
        }

        return apiActionItem.addDependency(ai._id, dependencyAi._id, linkType, lag).then((deps) => {
            if (cb) cb({ ...ai, dependencies: deps })
        })
    }
    actionItemRemoveDependency(ai, dependencyItem, cb) {
        if (!ai || !dependencyItem) return

        if (ai._id === dependencyItem._id) {
            toast.error("Circular dependency")
            return
        }

        const removeDepIndex = ai.dependencies.findIndex((l) => l.linkTo._id === dependencyItem._id)
        const dependencyToKill = ai.dependencies[removeDepIndex]

        apiActionItem.removeDependency(ai._id, getObjectId(dependencyToKill)).then((res) => {
            this.updateStateForActionItemUpdate(ai, { dependencies: res }, false, (obj) => {
                if (cb) {
                    cb(obj)
                }
            })
        })
    }
    actionItemCreateX(action, data, cb) {
        if (!data.seen) {
            data.seen = {
                by: this.state.person._id,
                when: getTimeUtc(new Date()),
            }
        }

        const myMission = this.state.missions.find((m) => m._id === action.missionId)

        if (myMission.defaultTaskCode && !data.code) {
            const nextIndex = (getAllActionItems(myMission)?.filter((a) => a.metaType !== 4)?.length || 0) + 1
            data.code = myMission.defaultTaskCode + "-" + nextIndex
        }

        apiActionItem.createActionItem(action._id, data).then((res) => {
            this.updateStateForActionItemCreate(res, () => {
                if (cb) cb(res)
            })
        })
    }

    checklistItemCreateX({ ai, options, cb }) {
        const myIndex = (ai.checklist || []).sort((a, b) => b?.sortIndex - a?.sortIndex)[0]?.sortIndex || 0

        const saveObj = { ...options, sortIndex: myIndex > 0 ? myIndex + 1 : 0 }

        apiActionItem.addChecklistItem(ai._id, saveObj).then((res) => {
            //obj, change, dontUpdateView, cb, fromSocket
            this.updateStateForActionItemUpdate(
                ai,
                res,
                false,
                () => {
                    if (cb) cb(res)
                },
                true
            )
        })
    }
    checklistUpdateState(ai, res, cb) {
        this.updateStateForActionItemUpdate(
            ai,
            { checklist: res.checklist },
            null,
            () => {
                if (cb) cb()
            },
            true
        )
    }
    checklistItemsUpdateBulk(ai, changeList) {
        apiActionItem
            .updateChecklistItemBulk(ai._id, changeList)
            .then((res) => {
                this.checklistUpdateState(ai, res)
            })
            .catch((err) => {
                throw err.message
            })
    }
    checklistItemUpdateX(ai, cl, change, cb) {
        //Always an Optimist

        if (change.hasOwnProperty("person") && change.person) {
            this.actionItemAddPerson(ai, change.person)
        }

        if (change.hasOwnProperty("done")) {
            change.completedOn = getTimeUtc(new Date())
            change.completedBy = this.state.person._id
        }

        apiActionItem
            .updateChecklistItem(ai._id, cl._id, change)
            .then((res) => {
                this.checklistUpdateState(ai, res, cb)
            })
            .catch((err) => {
                throw err
            })
    }
    checklistItemDeleteX(ai, cl, cb) {
        apiActionItem
            .deleteChecklistItem(ai._id, cl._id)
            .then((res) => {
                this.checklistUpdateState(ai, res, cb)
            })
            .catch((err) => {
                throw err
            })
    }

    actionItemDuplicateX({ ai, options, cb, newMission }) {
        let mission = this.state.missions.find((m) => m._id === (newMission?._id || ai.missionId))

        const aiStartDate = toZonedTime(ai.startDate)
        const aiWeek = toZonedTime(ai.week)
        const missionStartDate = toZonedTime(mission.planStartDate)
        const missionEndDate = toZonedTime(mission.planEndDate)

        let actionId

        if (mission.projectType === "simple" || mission.projectType === "kanban") {
            actionId = getSimpleAction(mission)?._id
        } else {
            actionId = ai.actionId
        }

        if (!actionId) {
            toast.error("Please have an admin or porject manager visit that project before copying ")
            this.silentFail("seiwjowlked552525")
        }

        const action = getAllActions(mission).find((a) => a._id === actionId)

        let newStartDate = aiStartDate
        let newAiWeek = aiWeek
        let newEndDate = ai.endDate ? toZonedTime(ai.endDate) : undefined
        let newEstimatedDuration = ai.estimatedDuration
        let newStartHour = ai.startHour

        if (aiStartDate && isBefore(aiStartDate, missionStartDate)) {
            newStartDate = toZonedTime(mission.planEndDate)
            newStartHour = getStartHour(newStartDate)
        }

        if (aiWeek && isBefore(aiWeek, startOfWeek(missionStartDate, { weekStartsOn: 1 }))) {
            newAiWeek = startOfWeek(missionStartDate, { weekStartsOn: 1 })
        }

        if (aiStartDate && isAfter(aiStartDate, missionEndDate)) {
            newStartDate = toZonedTime(mission.planEndDate)
            newEstimatedDuration = 8
            newEndDate = endOfDay(newStartDate)
            newStartHour = getStartHour(newStartDate)
        }

        let cleanCheckList = []

        ai.checklist?.forEach((cl, i) => {
            cleanCheckList.push({
                title: cl.title,
                description: cl.description,
                sortIndex: cl.sortIndex,
                people: newMission ? [] : cl.people,
                col: cl.col,
                color: cl.color,
            })
        })

        let code

        if (ai.code) {
            const ind =
                getAllActionItems(this.props.mission).filter((a) => a.code?.includes(ai.code.split("-")[0] + "-"))
                    .length + 1 || 1

            code = ai.code.split("-")[0] + "-" + (ind + 1)
        }

        const aiObj = {
            week: getTimeUtc(newAiWeek),
            code: code,
            shortDescription: ai.shortDescription,
            startDate: getTimeUtc(newStartDate),
            startHour: newStartHour,
            endDate: newEndDate ? getTimeUtc(newEndDate) : null,
            people: ai.people,
            title: !newMission && ai.title ? ai.title + " (Copy)" : ai.title,
            description: ai.description,
            sectionTagId: !newMission ? ai.sectionTagId : undefined,
            col: newMission ? "todo" : ai.col,
            estimatedDuration: newEstimatedDuration,
            y: ai.y || 0,
            sortIndex: ai.y || 0,
            tags: newMission ? ai.tags.filter((t) => !isMongoId(t)) : ai.tags || [],
            complexityMultiplier: ai.complexityMultiplier,
            checklist: cleanCheckList,
            billRate: ai.billRate,
            billUnit: ai.billUnit,
            percentComplete: ai.percentComplete,
            templateId: ai.templateId,
            ...options,
        }

        this.actionItemCreateX(action, aiObj, (res) => {
            removeParam("action-item")
            toast.success("Created")

            if (ai.files?.length) {
                apiActionItem.copyFiles(ai._id, res._id)
            }

            this.unBlock()
        })
    }

    actionItemUpdateX(ai, change, cb, fromSocket, fromTask) {
        if (change.startDate && !change.initialStartDate) {
            if (!ai.initialStartDate || change.startDate < ai.initialStartDate) {
                change.initialStartDate = change.startDate
            }
        }

        if (change.status === "done") {
            change.completedOn = getTimeUtc(new Date())
            change.completedBy = this.state.person._id
        } else if (change.status) {
            change.completedOn = null
            change.completedBy = null
        }

        this.updateStateForActionItemUpdate(ai, change, false, () => {}, fromSocket)

        apiActionItem
            .updateActionItem(ai._id, change)
            .then((res) => {
                const myMission = this.state.missions.find((m) => m._id === ai.missionId)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }

                if (
                    myMission?.projectType === "mx-gantt" &&
                    (change.hasOwnProperty("startDate") || change.hasOwnProperty("endDate"))
                ) {
                    updateBudgetOnRaciTasks({ mission: myMission, app: this })
                }

                if (change.hasOwnProperty("col")) {
                    const myColIndex = myMission.cols.findIndex((c) => c.id === res.col)
                    const myCol = myMission.cols[myColIndex]
                    if (myColIndex !== 0 && myColIndex !== myMission.cols.length - 1) {
                        if (myCol.people?.length) {
                            myCol.people.forEach((newPerson, i) => {
                                const missionPerson = myMission.people.find(
                                    (ppp) => getRefId(ppp) === getRefId(newPerson)
                                )

                                if (
                                    missionPerson &&
                                    missionPerson.permission < 3 &&
                                    !ai.people.find((pp) => getRefId(pp) === getRefId(missionPerson))
                                ) {
                                    this.actionItemAddPerson(ai, getRefId(missionPerson))
                                }
                            })
                        }
                    }
                }

                if (cb) cb(res)
            })
            .catch((err) => {
                this.silentFail("dewkour903iow" + err?.message)

                toast.error(
                    "So sorry, but we may have encountered an issue. Our team has been notified. Reason: " + err.message
                )
            })
    }

    actionItemUpdate(id, change, obj, cb, skipOpenDoneLogic) {
        const me = this

        if (!obj) {
            console.error("Sorry you did not pass an Object to actionItemUpdate")
            return
        }

        //Catch initial back date for item so we know what timesheets it can appear on
        if (change.startDate && !change.initialStartDate) {
            if (!obj.initialStartDate || change.startDate < obj.initialStartDate) {
                change.initialStartDate = change.startDate
            }
        }

        const myMission = this.state.missions.find((m) => m._id === obj.missionId)

        //Check if being completed
        if (change.status === "done" && obj.status !== "done") {
            if (!change.completedOn) {
                change = {
                    ...change,

                    completedOn: getTimeUtc(new Date().getTime()),
                }
            }
        }
        if (change.status === "done") {
            change = { ...change, completedBy: this.state.person._id }
        } else if (change.status && change.status !== "done") {
            change = { ...change, completedBy: null }
        }

        if (change.status === "open" && obj.status === "done") {
            if (myMission && myMission.projectType === "power" && obj.startDate) {
                change = {
                    ...change,
                    completedBy: null,
                    completedOn: null,
                    startDate: null,
                    estimatedDuration: null,
                    y: null,
                    startHour: null,
                }
            } else {
                change = { ...change, completedBy: null, completedOn: null }
            }
        }

        if (!obj || !change) {
            console.log("Please pass an object.")
            this.silentFail("Please pass an object.")
        } else {
            me.updateStateForActionItemUpdate(obj, change) //just in case
        }

        delete change.people

        if (change.description) {
            change.descriptionUpdateById = this.state.person._id
            change.descriptionUpdate = getTimeUtc(new Date())
        }

        if ((this.state.showDetailsData || this.stateshowDocData) && this.state.showDetailsData._id === obj._id) {
            if (this.state.showDetailsData) {
                this.setState({
                    showDetailsData: update(this.state.showDetailsData, { $merge: change }),
                })
            }

            if (this.state.showDocData) {
                this.setState({
                    showDocData: update(this.state.showDocData, { $merge: change }),
                })
            }
        }

        return apiActionItem
            .updateActionItem(id, change)
            .then((res) => {
                //Should not populate people @mike

                res.people.forEach((p, i) => {
                    res.people[i] = p._id
                })

                if (cb) cb(res)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                throw err
            })
    }
    actionItemUpdateBulk(missionId, data, skipState, cb, cbAfterRes) {
        if (!skipState) {
            this.updateStateForActionItemUpdateBulk(missionId, data, cb)
        }

        //Check initial start date so we know what weeks this applies to for time tracking

        const changeArray = data.map((obj) => {
            const ai = obj.obj
            let change = obj.change || obj.changes

            if (change.startDate && !change.initialStartDate) {
                if (!ai.initialStartDate || change.startDate < ai.initialStartDate) {
                    change.initialStartDate = change.startDate
                }
            }

            if (!change._id) {
                change._id = ai._id
            }

            return change
        })

        /**
         * TODO: Return list of updated action items and update this
         */
        return apiActionItem
            .updateActionItemBulk(missionId, changeArray)
            .then(() => {
                apiMission
                    .streamMissionListTree({
                        mission: missionId,
                        myMissions: false,
                    })
                    .then((missionRes) => {
                        const newMission = missionRes[0]
                        const missionIndex = this.state.missions.findIndex((m) => m._id === missionId)
                        const myMission = this.state.missions[missionIndex]

                        const newMissions = this.state.missions.slice()

                        newMissions[missionIndex] = newMission

                        this.setState({
                            missions: newMissions,
                        })

                        if (cbAfterRes) {
                            cbAfterRes(missionRes[0])
                        }

                        if (myMission?.isTemplate) {
                            setTimeout(() => {
                                this.missionUpdate(myMission._id, {
                                    isTemplateSaved: false,
                                })
                            }, 200)
                        }
                    })
            })
            .catch((err) => {
                this.silentFail("29837jnd" + (err?.message || err))
                throw err
            })
    }
    closeActionItem() {
        const n = new URLSearchParams(window.location.search)

        if (n.get("action-item")) {
            removeQueryParam("action-item")
            this.setState({
                showDetailsData: null,
                showDetailsDataOptions: null,
            })
        }
    }
    showActionItemDetails(ai, options) {
        if (typeof ai === "string") {
            ai = flatMap(flatMap(flatMap(this.state.missions, "planItems"), "actions"), "actionItems").find(
                (a) => a._id === ai
            )
        }

        if (!ai || typeof ai === "string") {
            toast.warning("🥑 Sorry this task is no longer available.")
            removeParam("action-item")
            return
        }

        if (!new URLSearchParams(window.location.search).get("action-item")) {
            addParam("action-item", ai._id)
        }

        this.setState({
            showDetailsData: ai,
            showDetailsDataOptions: options,
            timeTracking: this.state.timeTracking,
        })
    }

    async actionItemDeleteBulk(actionItems, cb, stateCb) {
        this.block("Deleting...")

        const actionItemResults = await Promise.allSettled(
            actionItems.map((ai, i) => {
                return apiActionItem.deleteActionItem(ai._id)
            })
        )

        let deletedAis = actionItemResults.length
            ? actionItemResults.filter((result) => result.status === "fulfilled")
            : []

        if (deletedAis.length > 0) this.updateStateForActionItemDeleteBulk(actionItems, stateCb)

        this.unBlock()

        if (cb) cb()
    }
    updateStateForActionDeleteBulk(actions, cb) {
        const missionIndex = this.state.missions.findIndex((m) => m._id === actions[0].missionId)

        const mission = this.state.missions[missionIndex]

        let newMissions = this.state.missions.slice()

        actions.forEach((ai, i) => {
            const indexes = getActionItemIndexes(ai, this.state)

            if (!indexes) {
                console.error("indexes issue")
                return
            }

            try {
                newMissions[indexes.missionIndex].planItems[indexes.missionPhaseIndex]?.actions.splice(
                    indexes.missionActionIndex,
                    1
                )
            } catch (err) {
                console.error(err)
            }
        })

        if (cb) {
            cb(newMissions[missionIndex])
        }

        this.setState(
            {
                missions: newMissions,
            },
            () => {
                this.setState({
                    missionChange: {
                        for: "action",
                        change: "delete buld",
                        timestamp: uniqid(),
                        items: actions,
                        missionId: mission._id,
                    },
                })
            }
        )
    }
    updateStateForActionItemDeleteBulk(actionItems, cb) {
        const mission = this.state.missions.find((m) => m._id === actionItems[0].missionId)

        let newMissions = this.state.missions.slice()

        actionItems.forEach((ai, i) => {
            const indexes = getActionItemIndexes(ai, this.state)

            if (!indexes) {
                console.error("indexes issue")
                return
            }

            try {
                newMissions[indexes.missionIndex].planItems[indexes.missionPhaseIndex]?.actions[
                    indexes.missionActionIndex
                ]?.actionItems?.splice(indexes.missionActionItemIndex, 1)
            } catch (err) {
                console.error(err)
            }
        })

        this.setState(
            {
                missions: newMissions,
            },
            () => {
                if (cb) {
                    cb(newMissions.find((m) => m._id === mission._id))
                }
                this.setState({
                    missionChange: {
                        for: "actionItems",
                        change: "delete",
                        timestamp: uniqid(),
                        items: [actionItems],
                        missionId: mission._id,
                    },
                })
            }
        )
    }
    actionItemDeleteX(ai, mission, cb) {
        removeParam("action-item")
        this.updateStateForActionItemDelete(ai, cb)

        apiActionItem
            .deleteActionItem(ai._id)
            .then((res) => {
                if (this.state.showDetailsData?._id === ai._id) {
                    this.setState({
                        showDetailsData: null,
                        showDetailsDataOptions: null,
                    })
                }
                if (mission.isTemplate) {
                    this.missionUpdate(mission._id, {
                        isTemplateSaved: false,
                    })
                }
                toast.success("Done", { autoClose: 500 })

                if (mission.isProcess || mission.projectType === "mx-gantt") {
                    let pisNeedUpdating = mission.planItems.filter((p) =>
                        p.raciOnTasks?.find((r) => r.taskId === ai._id)
                    )
                    let changesArray = []
                    pisNeedUpdating.forEach((pi, i) => {
                        let newRaciOnTasks = pi.raciOnTasks.slice().filter((r) => r.taskId !== ai._id)

                        changesArray.push({
                            obj: pi,
                            change: {
                                _id: pi._id,
                                raciOnTasks: newRaciOnTasks,
                            },
                        })

                        if (changesArray.length) {
                            this.planItemUpdateBulk(mission._id, changesArray)
                        }
                    })
                }
            })
            .catch((err) => {
                throw err
            })
    }
    actionItemDelete(obj, skipState) {
        const myMission = this.state.missions.find((m) => m._id === obj.missionId)

        if (!skipState) this.updateStateForActionItemDelete(obj)

        apiActionItem.deleteActionItem(obj._id).then((res) => {
            if (myMission?.isTemplate) {
                setTimeout(() => {
                    this.missionUpdate(myMission._id, {
                        isTemplateSaved: false,
                    })
                }, 200)
            }
        })
    }
    actionItemAddPerson(actionItem, personId) {
        const id = actionItem?._id

        if (actionItem.people?.find((p) => getRefId(p) === personId)) {
            return
        }

        apiActionItem
            .addActionItemPeople(id, personId)
            .then((res) => {
                const alt = {
                    people: res.people,
                    peopleAttached: res.peopleAttached,
                }

                if (this.state.showDetailsData && this.state.showDetailsData._id === res._id) {
                    this.setState({
                        showDetailsData: { ...this.state.showDetailsData, ...alt },
                    })
                }
                this.updateStateForActionItemUpdate(res, alt)
            })
            .catch((err) => {
                this.silentFail("wejwie++we" + (err?.message + " - " + err?.toString()))
            })
    }
    actionItemRemovePerson(actionItem, personId, cb) {
        const id = actionItem?._id || actionItem
        apiActionItem
            .deleteActionItemPeople(id, personId)
            .then((res) => {
                this.updateStateForActionItemUpdate(res, { people: res.people }, false, cb)
            })

            .catch((err) => {
                this.silentFail("actionItemRemovePerson-3u983" + (err?.message + " - " + err?.toString()))
            })
    }
    actionItemRemovePersonAll(id, cb) {
        return apiActionItem
            .deleteActionItemPeopleAll(id)
            .then((res) => {
                this.updateStateForActionItemUpdate(res, { people: res.people }, null, () => {
                    if (cb) {
                        cb()
                    }
                })
            })
            .catch((err) => {
                throw err
            })
    }
    planItemCreateX(missionId, obj, cb) {
        return apiPlanItems.createPlanItem(missionId, obj).then((res) => {
            this.updateStateForPlanItemCreate(res)

            if (cb) cb(res)

            const myMission = this.state.missions.find((m) => m._id === missionId)

            if (myMission?.isTemplate) {
                setTimeout(() => {
                    this.missionUpdate(myMission._id, {
                        isTemplateSaved: false,
                    })
                }, 200)
            }
        })
    }
    planItemCreate(missionId, obj, cb, skipDateMatch) {
        const miss = this.state.missions.find((m) => m._id === missionId)

        return apiPlanItems
            .createPlanItem(missionId, obj)
            .then((res) => {
                this.updateStateForPlanItemCreate(res)

                if (!skipDateMatch) {
                    this.missionPlanDates(missionId)
                    this.missionUpdatePinnedItems(missionId)
                }

                if (cb) {
                    cb(res)
                }

                if (miss?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(miss._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                throw err
            })
    }
    async planItemCreateBulk(data) {
        /*this.block("One moment. Creating entries...")

        const planItemResults = await Promise.allSettled(
            data.map((planItemConfig) => {
                if (!start || !end) return null

                return apiPlanItems.createPlanItem(mission._id, planItemConfig)
            })
        )

        let planItemsCreated = []

        planItemResults
            .filter((result) => result.status === "fulfilled")
            .forEach((result, i) => {
                if (result.value) planItemsCreated.push(result.value)
            })

        if (planItemsCreated.length) this.updateStateForPlanItemCreateBulk(mission._id, planItemsCreated)*/
    }
    planItemAddDependency(planItem, dependencyItem, linkType = "dependsOn") {
        return apiPlanItems.addDependency(planItem._id, dependencyItem._id, linkType).catch((err) => {
            throw err
        })
        const myMission = this.state.missions.find((m) => m._id === planItem.missionId)

        if (myMission?.isTemplate) {
            setTimeout(() => {
                this.missionUpdate(myMission._id, {
                    isTemplateSaved: false,
                })
            }, 200)
        }
    }
    planItemRemoveDependency(planItem, dependencyItem) {
        if (!planItem || !dependencyItem) return
        planItem = { ...planItem }

        const mission = this.state.missions.find((m) => m._id === planItem.missionId)
        if (typeof dependencyItem === "string") {
            dependencyItem = mission.planItems.find((p) => p._id === dependencyItem)
        }

        const removeDepIndex = planItem.dependencies.findIndex((l) => l.linkTo._id === dependencyItem._id)
        const dependencyToKill = planItem.dependencies[removeDepIndex]

        if (dependencyToKill) {
            planItem.dependencies.splice(removeDepIndex, 1)
            this.updateStateForPlanItemUpdate(planItem, {
                dependencies: planItem.dependencies,
            })
        }

        const removeDepIndexOther = dependencyItem.dependencies.findIndex((l) => l.linkTo._id === planItem._id)
        const dependencyToKillOther = dependencyItem.dependencies[removeDepIndexOther]

        if (dependencyToKillOther) {
            dependencyItem.dependencies.splice(removeDepIndexOther, 1)
            this.updateStateForPlanItemUpdate(dependencyItem, {
                dependencies: dependencyItem.dependencies,
            })
        }

        if (mission?.isTemplate) {
            setTimeout(() => {
                this.missionUpdate(mission._id, {
                    isTemplateSaved: false,
                })
            }, 200)
        }

        return apiPlanItems.removeDependency(planItem._id, dependencyToKill._id).catch((err) => {
            throw err
        })
    }
    planItemUpdateX(pi, change, cb) {
        if (!dateValidationPass({ obj: pi, ...change })) {
            throw new Error("Invalid date values for planItemUpdateX")
        }

        this.updateStateForPlanItemUpdate(pi, change)

        if (pi.type === "person" && pi.pinnedTo === null && !Object.prototype.hasOwnProperty.call(change, "pinnedTo")) {
            change.pinnedTo = null
        }

        return apiPlanItems
            .updatePlanItem(pi.missionId, pi._id, change)
            .then((res) => {
                if (cb) cb(res)

                const myMission = this.state.missions.find((m) => m._id === pi.missionId)

                if (myMission?.isTemplate) {
                    setTimeout(() => {
                        this.missionUpdate(myMission._id, {
                            isTemplateSaved: false,
                        })
                    }, 200)
                }
            })
            .catch((err) => {
                throw err
            })
    }
    planItemRemoveRole(pi) {
        const startDateAfterToday = isAfter(toZonedTime(pi.startDate), new Date())
        const todayAfterEndDate = isAfter(new Date(), toZonedTime(pi.endDate))

        const whatIsTheEndDate = startDateAfterToday
            ? endOfDay(toZonedTime(pi.startDate))
            : todayAfterEndDate
            ? toZonedTime(pi.endDate)
            : endOfDay(new Date())

        const change = {
            person: null,
            endDate: getTimeUtc(whatIsTheEndDate),
            pinnedTo: null,
            personLeftRole: {
                when: getTimeUtc(new Date()),
                personId: pi.person,
                whoKilledTheRole: this.state.person._id,
            },
        }

        this.updateStateForPlanItemUpdate(pi, change)

        return apiPlanItems.updatePlanItem(pi.missionId, pi._id, change).then((res) => {
            toast("The project role was removed.")

            const myMission = this.state.missions.find((m) => m._id === res.missionId)

            if (myMission?.isTemplate) {
                setTimeout(() => {
                    this.missionUpdate(myMission._id, {
                        isTemplateSaved: false,
                    })
                }, 200)
            }
        })
    }
    planItemUpdate(obj, changeObj, skipMin, skipDateMatch) {
        if (!dateValidationPass({ obj, ...changeObj })) {
            throw new Error("Invalid date values for planItemUpdateX")
        }

        if (!obj || !changeObj) return

        obj = { ...obj }
        changeObj = { ...changeObj }

        if (obj.type === "milestone") {
            skipMin = true
            skipDateMatch = true
        }

        if (typeof obj.startDate === "object") obj.startDate = getTimeUtc(obj.startDate)

        if (typeof obj.endDate === "object") obj.endDate = getTimeUtc(obj.endDate)

        if (typeof changeObj.startDate === "object") changeObj.startDate = getTimeUtc(changeObj.startDate)

        if (typeof changeObj.endDate === "object") changeObj.endDate = getTimeUtc(changeObj.endDate)

        if (changeObj.endDate || changeObj.startDate) {
            const zeStartDate = changeObj.startDate || obj.startDate
            const zeEndDate = changeObj.endDate || obj.endDate

            if (changeObj.endDate && changeObj.endDate <= zeStartDate) {
                changeObj.endDate = getTimeUtc(addDays(toZonedTime(zeStartDate), 5))
            }
            if (changeObj.startDate && changeObj.startDate >= zeEndDate) {
                changeObj.endDate = getTimeUtc(addDays(toZonedTime(changeObj.startDate), 5))
            }
        }

        this.updateStateForPlanItemUpdate(obj, changeObj)

        if (!skipDateMatch && (changeObj.startDate || changeObj.endDate)) {
            setTimeout(() => {
                this.missionPlanDates(obj.missionId)
            }, 10)
            setTimeout(() => {
                this.missionUpdatePinnedItems(obj.missionId)
            }, 20)
        }

        const myMission = this.state.missions.find((m) => m._id === obj.missionId)

        if (myMission?.isTemplate) {
            setTimeout(() => {
                this.missionUpdate(myMission._id, {
                    isTemplateSaved: false,
                })
            }, 200)
        }

        return apiPlanItems.updatePlanItem(obj.missionId, obj._id, changeObj)
    }
    planItemUpdateBulk(missionId, changes, noStateChange, cb) {
        let sendOff = []

        if (!noStateChange) {
            this.updateStateForPlanItemUpdateBulk(changes, cb)

            changes.forEach((cc) => {
                sendOff.push({
                    ...(cc.change || cc.changes),
                    _id: getObjectId(cc.obj),
                })
            })

            if (sendOff.length) return apiPlanItems.updatePlanItemBulk(missionId, sendOff)
        } else {
            if (changes.length) return apiPlanItems.updatePlanItemBulk(missionId, changes)
        }

        const myMission = this.state.missions.find((m) => m._id === missionId)

        if (myMission?.isTemplate) {
            setTimeout(() => {
                this.missionUpdate(myMission._id, {
                    isTemplateSaved: false,
                })
            }, 200)
        }
    }
    planItemRemoveX(pi) {
        this.updateStateForPlanItemRemove(pi)
        const myMission = this.state.missions.find((m) => m._id === pi.missionId)
        if (myMission?.isTemplate) {
            setTimeout(() => {
                this.missionUpdate(myMission._id, {
                    isTemplateSaved: false,
                })
            }, 200)
        }

        return apiPlanItems.deletePlanItem(pi._id)
    }
    planItemRemove(mission, obj, skipDates) {
        if (!mission || typeof mission === "string") {
            mission = this.state.missions.find((m) => m._id === obj.missionId)
        }
        if (!mission) return

        const removeLogic = () => {
            this.updateStateForPlanItemRemove(obj)

            if (!skipDates && obj.type !== "cost") {
                setTimeout(() => {
                    this.planItemCleanUpPinnedTo(mission, obj)
                }, 300)

                setTimeout(() => {
                    this.planItemCleanUpDependencies(obj, mission)
                }, 100)

                setTimeout(() => {
                    this.missionPlanDates(mission._id)
                }, 150)
            }

            const myMission = this.state.missions.find((m) => m._id === mission._id)

            if (myMission?.isTemplate) {
                setTimeout(() => {
                    this.missionUpdate(myMission._id, {
                        isTemplateSaved: false,
                    })
                }, 200)
            }

            return apiPlanItems.deletePlanItem(obj._id)
        }

        return removeLogic()
    }
    planItemCleanUpPinnedTo(mission, planItem) {
        let changeArray = []

        mission.planItems
            .filter((pi) => pi.pinnedTo === planItem._id)
            .forEach((pi, i) => {
                changeArray.push({
                    obj: pi,
                    change: {
                        _id: pi._id,
                        pinnedTo: null,
                    },
                })
            })

        if (changeArray.length) {
            this.planItemUpdateBulk(mission._id, changeArray)
        }
    }
    planItemCleanUpDependencies(planItem, mission) {
        let changesArray = []
        let newPhases = mission.planItems.slice()

        newPhases = newPhases.filter((p) => {
            return (
                p.myDependencies &&
                p.dependencyOnMe &&
                (p.myDependencies.indexOf(planItem._id) !== -1 || p.dependencyOnMe.indexOf(planItem._id) !== -1)
            )
        })

        newPhases.forEach((pi, i) => {
            const index1 = pi.myDependencies.findIndex((d) => d === planItem._id)

            if (index1 !== -1) {
                pi.myDependencies.splice(index1, 1)
                changesArray.push({
                    obj: pi,
                    change: {
                        _id: pi._id,
                        myDependencies: pi.myDependencies,
                    },
                })
            }
            const index2 = pi.dependencyOnMe.findIndex((d) => d === planItem._id)
            if (index2 !== -1) {
                pi.dependencyOnMe.splice(index2, 1)
                changesArray.push({
                    obj: pi,
                    change: {
                        _id: pi._id,
                        dependencyOnMe: pi.dependencyOnMe,
                    },
                })
            }
        })

        if (changesArray.length) {
            this.planItemUpdateBulk(planItem.missionId, changesArray)
        }
    }

    orgCreate(data, logo, cb) {
        apiOrg
            .createOrg(data)
            .then((newOrg) => {
                if (logo) {
                    apiOrg.uploadLogo(newOrg._id, logo)
                }

                const meInOrgIndex = newOrg.people.findIndex((p) => getRefId(p) === this.state.person._id)

                newOrg.people[meInOrgIndex].ref = {
                    _id: this.state.person._id,
                    firstName: this.state.person.firstName,
                    lastName: this.state.person.lastName,
                    avatar: this.state.person.avatar,
                }

                this.setState(
                    {
                        orgs: update(this.state.orgs, { $push: [newOrg] }),
                    },
                    () => {
                        if (cb) cb(newOrg)

                        if (getQ()["create-proposal"]) {
                            return
                        }

                        removeParam("hq")

                        if (!getQ().mc) {
                            addParams([
                                { param: "org", value: newOrg._id },
                                { param: "org-cfg", value: "open" },
                            ])
                        } else {
                            addParam("mc-org", newOrg._id)
                        }
                    }
                )

                toast.success("Success 👍")
            })
            .catch((err) => {
                throw err
            })
    }
    orgDelete(id) {
        removeParams("org,hq,mc-org")

        this.orgCleanUpDeleted(id)

        apiOrg
            .deleteOrg(id)
            .then((res) => {
                toast.success("Org deleted as requested. help@missionx.ai")
                this.updateTimeTracking()
            })
            .catch((err) => {
                throw err
                //toast.error("I'm sorry but I was not able to delete this organization. help@missionx.ai")
            })
    }
    orgUpdate(id, change, cb) {
        if (id?._id) {
            id = getObjectId(id)
        }

        const beforeOrg = this.state.orgs.find((o) => o._id === id)

        return apiOrg
            .updateOrg(id, change)
            .then((res) => {
                let newUpdateObj = { ...res }

                if (!res.people && beforeOrg.people) {
                    newUpdateObj = { ...newUpdateObj, people: beforeOrg.people }
                }

                newUpdateObj = { ...newUpdateObj, ...change }

                this.orgUpdateState(newUpdateObj, change)

                if (cb) {
                    cb(res)
                }
            })
            .catch((err) => {
                switch (err.status) {
                    case 400:
                        return toast.error("A bad request received. Try again and if the problem persists contact us.")
                    case 401:
                        return toast.error("Make sure you have the right permissions to perform this action.")
                    case 402:
                        return toast.error("Requires an organization license.")
                    default:
                        throw err
                }
            })
    }
    orgUpdateState(obj, change, cb) {
        const orgIndex = this.state.orgs.findIndex((o) => o._id === obj._id)
        const orgA = this.state.orgs[orgIndex]

        if (!obj.people) {
            obj.people = orgA.people
        }

        if (orgIndex !== -1) {
            this.setState(
                {
                    orgs: update(this.state.orgs, {
                        [orgIndex]: { $merge: change },
                    }),
                },
                () => {
                    this.setState(
                        {
                            orgChange: {
                                _id: obj._id,
                                timestamp: uniqid(),
                                obj: this.state.orgs[orgIndex],
                            },
                        },
                        () => {
                            if (cb) {
                                cb(this.state.orgs[orgIndex])
                            }
                        }
                    )
                }
            )
        }
    }
    orgClientUpdate(org, client, change, cb) {
        apiOrg
            .updateOrgClient(org._id, client._id, change)
            .then((res) => {
                this.updateStateForClientUpdate(res, cb)
            })
            .catch((err) => {
                throw err
            })
    }
    orgClientCreate(org, data, cb) {
        apiOrg
            .createOrgClient(org._id, data)
            .then((res) => {
                this.updateStateForClientCreate(res, cb)
            })
            .catch((err) => {
                throw err
            })
    }
    orgClientRemove(org, client, cb) {
        apiOrg.deleteOrgClient(org._id, client._id).then(() => {
            this.updateStateForClientDelete(org._id, client._id, cb)
        })
        // TODO: Handle this
    }

    orgCleanUpDeleted(id) {
        const me = this

        const orgIndex = this.state.orgs.findIndex((o) => o._id === id)

        let newMissions = this.state.missions.slice()

        newMissions = newMissions.filter((m) => getObjectId(m.org) !== id)

        if (orgIndex !== -1)
            me.setState(
                {
                    missions: newMissions,
                    orgs: update(this.state.orgs, { $splice: [[orgIndex, 1]] }),
                },
                () => {}
            )
    }
    updateStateForGoalChange(org, goal) {
        const orgIndex = this.state.orgs.findIndex((o) => o._id === org._id)

        const fgIndex = org.goals.findIndex((g) => g._id === goal._id)

        const upOrg = update(this.state.orgs, {
            [orgIndex]: {
                goals: {
                    [fgIndex]: { $set: goal },
                },
            },
        })

        const orgGoalState = upOrg

        this.setState({
            orgs: orgGoalState,
        })
    }
    updateStateForGoalDelete(orgId, goalId) {
        const orgIndex = this.state.orgs.findIndex((o) => o._id === orgId)

        const fgIndex = this.state.orgs[orgIndex].goals.findIndex((g) => g._id === goalId)

        const upOrg = update(this.state.orgs, {
            [orgIndex]: {
                goals: { $splice: [[fgIndex, 1]] },
            },
        })

        const orgGoalState = upOrg

        this.setState({
            orgs: orgGoalState,
        })
    }
    updateStateForGoalCreate(org, goal) {
        const orgIndex = this.state.orgs.findIndex((o) => o._id === org._id)

        const upOrg = update(this.state.orgs, {
            [orgIndex]: {
                goals: { $push: [goal] },
            },
        })

        const orgGoalState = upOrg

        this.setState({
            orgs: orgGoalState,
        })
    }
    updateStateForPersonRemoved(personId, missionId) {
        const missionIndex = this.state.missions.findIndex((m) => m._id === missionId)
        const mission = this.state.missions[missionIndex]

        if (!mission) {
            return
        }

        let actions = getAllActions(mission).slice()

        ;(actions || []).forEach((a) => {
            a.actionItems.forEach((ai, i) => {
                if (!ai.people) return

                let pIndex = ai.people.findIndex((obj) => obj._id === personId)
                a.actionItems[i].people.splice(pIndex, 1)
            })
        })

        if (missionIndex === -1) return

        const missionPeopleIndex = this.state.missions[missionIndex].people.findIndex((mp) => {
            if (mp.ref) {
                return getRefId(mp) === personId
            } else {
                return false
            }
        })

        if (missionPeopleIndex === -1) return

        this.setState(
            {
                missions: update(this.state.missions, {
                    [missionIndex]: {
                        people: { $splice: [[missionPeopleIndex, 1]] },
                    },
                }),
            },
            () => {
                this.setState({
                    missionChange: {
                        for: "mission",
                        change: "people",
                        timestamp: uniqid(),
                        missionId: this.state.missions[missionIndex]._id,
                    },
                })
            }
        )
    }
    updateStateForPersonRemovedOrg(refId, orgId) {
        const orgIndex = this.state.orgs.findIndex((m) => m._id === orgId)
        const personIndex = this.state.orgs[orgIndex]?.people?.findIndex((mp) => getRefId(mp) === refId)

        let newOrgs = this.state.orgs.slice()

        if (personIndex !== -1) {
            newOrgs = update(this.state.orgs, {
                [orgIndex]: {
                    people: { $splice: [[personIndex, 1]] },
                },
            })
        } else {
        }

        this.setState(
            {
                orgs: newOrgs,
            },
            () => {
                this.state.missions
                    .filter((m) => getObjectId(m.org) === orgId)
                    .forEach((m) => {
                        const missionPerson = (m.people || []).find((mPerson) => getRefId(mPerson) === refId)

                        if (missionPerson) {
                            this.updateStateForPersonRemoved(missionPerson._id, m._id)
                        }
                    })
            }
        )
    }
    updateStateForPersonAvatar(obj, isAvatarChange) {
        let newMissions = this.state.missions.slice()
        let newOrgs = this.state.orgs.slice()

        newMissions.forEach((m, ind) => {
            let i = m.people?.findIndex((p) => getRefId(p) === obj._id)
            if (i !== -1 && typeof newMissions[ind].people[i].ref === "object") {
                newMissions[ind].people[i].ref.avatar = obj.avatar
            }
        })

        newOrgs.forEach((o, ind) => {
            if (o.people) {
                let i = o.people?.findIndex((p) => getRefId(p) === obj._id)
                if (i !== -1 && typeof newOrgs[ind].people[i].ref === "object") {
                    newOrgs[ind].people[i].ref.avatar = obj.avatar
                }
            }
        })

        this.setState(
            {
                missions: newMissions,
                orgs: newOrgs,
                avKey: isAvatarChange ? uniqid() : this.state.avKey,
            },
            () => {
                if (isAvatarChange) this.forceUpdate()
            }
        )
    }
    updateStateForActionItemCreateBulk(actionItems, mission, fastCallBack) {
        let missions = this.state.missions.slice()
        const mIndex = missions.findIndex((m) => m._id === mission._id)

        actionItems.forEach((obj, i) => {
            let indexes = getActionItemIndexes(obj, this.state)

            missions = update(missions, {
                [indexes.missionIndex]: {
                    planItems: {
                        [indexes.missionPhaseIndex]: {
                            actions: {
                                [indexes.missionActionIndex]: {
                                    actionItems: { $push: [obj] },
                                },
                            },
                        },
                    },
                },
            })
        })

        if (fastCallBack) {
            fastCallBack(missions[mIndex])
        }

        this.setState(
            {
                missions: missions,
            },
            () => {
                this.setState({
                    missionChange: {
                        for: "actionItem",
                        change: "create-bulk",
                        changes: actionItems,
                        timestamp: uniqid(),
                        missionId: mission?._id,
                    },
                })
            }
        )
    }
    updateStateForActionUpdateBulk(missionId, changes, cb) {
        const missionIndex = this.state.missions.findIndex((m) => m._id === missionId)

        if (missionIndex === -1) {
            this.silentFail("ewrmjoi4enridss")
            return
        }

        const mission = this.state.missions[missionIndex]

        const allActions = getAllActions(mission)
        const actionsByPlanItems = groupBy(allActions, "missionPlanId")
        const planItemMap = makeHash(mission.planItems)
        const actionMap = makeHash(allActions)

        let newPlanItems = [...mission.planItems.slice()]

        Object.keys(actionsByPlanItems).forEach((piId, i) => {
            const planItem = planItemMap[piId]
            const planItemIndex = newPlanItems.findIndex((p) => p._id === piId)

            changes.forEach((aChange, i) => {
                const action = actionMap[aChange._id]

                const changeIndex = action ? planItem.actions.findIndex((a) => a._id === action?._id) : -1

                if (changeIndex !== -1) {
                    const updatedActions = [...newPlanItems[planItemIndex].actions.slice()]

                    updatedActions[changeIndex] = { ...action, ...aChange }

                    newPlanItems[planItemIndex] = {
                        ...newPlanItems[planItemIndex],
                        actions: updatedActions,
                    }
                }
            })
        })

        this.setState(
            {
                missions: update(this.state.missions, {
                    [missionIndex]: {
                        planItems: { $set: newPlanItems },
                    },
                }),
            },
            () => {
                const updatedMission = this.state.missions[missionIndex]
                this.setState(
                    {
                        missionChange: {
                            for: "action",
                            change: "bulk",
                            timestamp: uniqid(),
                            changes: changes,
                            missionId: missionId,
                        },
                    },
                    () => {
                        if (cb) cb(updatedMission)
                    }
                )
            }
        )
    }
    updateStateForActionCreateBulk(actions) {
        //Supports simple and kanban and gantt only
        const action = actions[0]

        const myMissionIndex = this.state.missions.findIndex((m) => m._id === action.missionId)

        if (myMissionIndex === -1) return null

        const myPhaseInMissionIndex = this.state.missions[myMissionIndex].planItems.findIndex(
            (p) => p._id === action.missionPlanId
        )
        if (myPhaseInMissionIndex === -1) return null

        let newMissions = this.state.missions.slice()

        const newActionsForMission = uniqBy(
            [...newMissions[myMissionIndex].planItems[myPhaseInMissionIndex].actions, ...actions],
            "_id"
        )

        newMissions[myMissionIndex].planItems[myPhaseInMissionIndex].actions = newActionsForMission

        this.setState(
            {
                missions: newMissions,
            },
            () => {
                this.setState({
                    missionChange: {
                        for: "action",
                        change: "create-bulk",
                        changes: actions,
                        timestamp: uniqid(),
                        missionId: this.state.missions[myMissionIndex]._id,
                    },
                })
            }
        )
    }
    updateStateForActionCreate(obj) {
        let missionIndex = this.state.missions.findIndex((m) => m._id === obj.missionId)

        if (missionIndex === -1) {
            window.location.href = window.location.href
            return
        }

        const missionPhaseIndex = this.state.missions[missionIndex].planItems.findIndex(
            (m) => m._id === obj.missionPlanId
        )

        this.setState(
            {
                missions: update(this.state.missions, {
                    [missionIndex]: {
                        planItems: {
                            [missionPhaseIndex]: { actions: { $push: [obj] } },
                        },
                    },
                }),
            },
            () => {
                this.setState({
                    missionChange: {
                        for: "action",
                        change: "new",
                        timestamp: uniqid(),
                        obj: obj,
                        missionId: this.state.missions[missionIndex]._id,
                    },
                })
            }
        )
    }
    updateStateForActionUpdate(obj, change, waitToUpdate, cb) {
        let indexes = getActionItemIndexes(obj, this.state)

        if (!indexes) {
            return
        }

        const newMissions = this.state.missions.slice()

        const originalActionFromState =
            newMissions[indexes.missionIndex].planItems[indexes.missionPhaseIndex].actions[indexes.missionActionIndex]

        obj.actionItems?.forEach((ai, i) => {
            if (typeof ai === "string") {
                //its an id
                const hydrated = originalActionFromState.actionItems.find((a) => a._id === ai)

                obj.actionItems[i] = hydrated
            }
        })

        newMissions[indexes.missionIndex].planItems[indexes.missionPhaseIndex].actions[indexes.missionActionIndex] = {
            ...obj,
            ...change,
        }

        this.setState(
            {
                missions: newMissions,
            },
            () => {
                if (cb) {
                    cb(this.state.missions[indexes.missionIndex], {
                        ...obj,
                        ...change,
                    })
                }
                if (!waitToUpdate) {
                    this.setState({
                        missionChange: {
                            for: "action",
                            change: change,
                            timestamp: uniqid(),
                            obj: obj,
                            missionId: obj.missionId,
                        },
                    })
                }
            }
        )
    }
    updateStateForActionDelete(obj, cb) {
        let indexes = getActionItemIndexes(obj, this.state)

        this.setState(
            {
                missions: update(this.state.missions, {
                    [indexes.missionIndex]: {
                        planItems: {
                            [indexes.missionPhaseIndex]: {
                                actions: {
                                    $splice: [[indexes.missionActionIndex, 1]],
                                },
                            },
                        },
                    },
                }),
            },
            () => {
                if (cb) {
                    cb(this.state.missions[indexes.missionIndex])
                }
                this.setState({
                    missionChange: {
                        for: "action",
                        change: "delete",
                        obj: obj,
                        timestamp: uniqid(),
                        missionId: obj.missionId,
                    },
                })
            }
        )
    }
    updateStateForActionItemCreate(obj, cb) {
        const indexes = getActionItemIndexes(obj, this.state)

        if (!indexes) {
            console.error("indexs issue")
            return
        }

        this.setState(
            {
                missions: update(this.state.missions, {
                    [indexes.missionIndex]: {
                        planItems: {
                            [indexes.missionPhaseIndex]: {
                                actions: {
                                    [indexes.missionActionIndex]: {
                                        actionItems: { $push: [obj] },
                                    },
                                },
                            },
                        },
                    },
                }),
            },
            () => {
                this.setState(
                    {
                        missionChange: {
                            for: "actionItem",
                            change: "create",
                            timestamp: uniqid(),
                            obj: obj,
                            missionId: obj.missionId,
                        },
                    },
                    () => {
                        if (cb) cb()

                        const m = this.state.missions[indexes.missionIndex]

                        if (m.isProcess && m.isTemplate) {
                            setTimeout(() => {
                                //syncProcessFlow({ mission: m, app: this })
                            }, 500)
                        }
                    }
                )
            }
        )
    }

    updateStateForActionItemUpdateBulk(mission, changes, cb) {
        if (changes.length === 0 || !mission) return

        if (typeof mission === "string") {
            mission = this.state.missions.find((m) => m._id === mission)
        }
        if (!mission) {
            console.error("Bulk AI update requires mission")
            return
        }

        let newMissions = this.state.missions.slice()
        let newShowDetailsData

        changes.forEach((change, i) => {
            let c = change.change || change.changes

            const indexes = getActionItemIndexes(change.obj, this.state)

            if (this.state.showDetailsData?._id === change.obj._id) {
                newShowDetailsData = { ...newShowDetailsData, ...c }
            }

            if (c.actionId && c.actionId !== change.obj.actionId) {
                //Move to another action

                //Remove
                newMissions = update(newMissions, {
                    [indexes.missionIndex]: {
                        planItems: {
                            [indexes.missionPhaseIndex]: {
                                actions: {
                                    [indexes.missionActionIndex]: {
                                        actionItems: { $splice: [[indexes.missionActionItemIndex, 1]] },
                                    },
                                },
                            },
                        },
                    },
                })

                //Move to new action

                newMissions = update(newMissions, {
                    [indexes.missionIndex]: {
                        planItems: {
                            [indexes.missionPhaseIndex]: {
                                actions: {
                                    [indexes.missionActionIndex]: {
                                        actionItems: { $push: [{ ...change.obj, ...c }] },
                                    },
                                },
                            },
                        },
                    },
                })
            } else {
                newMissions = update(newMissions, {
                    [indexes.missionIndex]: {
                        planItems: {
                            [indexes.missionPhaseIndex]: {
                                actions: {
                                    [indexes.missionActionIndex]: {
                                        actionItems: {
                                            [indexes.missionActionItemIndex]: { $merge: c },
                                        },
                                    },
                                },
                            },
                        },
                    },
                })
            }
        })

        let updateObj = {
            missions: newMissions,
        }

        if (newShowDetailsData) {
            updateObj.showDetailsData = newShowDetailsData
        }

        this.setState(updateObj, () => {
            const newMission = this.state.missions.find((m) => m._id === getObjectId(mission))
            if (cb) cb(newMission)

            if (newMission?.projectType === "mx-gantt") {
                updateBudgetOnRaciTasks({ mission: newMission, app: this })
            }

            this.setState({
                missionChange: {
                    timestamp: uniqid(),
                    for: "actionItem",
                    change: "bulk",
                    changes: changes,
                    missionId: mission?._id,
                },
            })
        })
    }
    updateStateForActionItemUpdate(obj, change, dontUpdateView, cb, fromSocket) {
        if (!change) {
            console.error("change missing!")
            this.silentFail("change was not passed")
            return
        }

        const indexes = getActionItemIndexes(obj, this.state)
        const newState = {}

        if (!indexes) {
            return
        }

        if (this.state.showDetailsData && this.state.showDetailsData._id === obj._id) {
            newState.showDetailsData = update(this.state.showDetailsData, { $merge: change })
        }

        if (indexes.missionActionItemIndex > -1) {
            newState.missions = update(this.state.missions, {
                [indexes.missionIndex]: {
                    planItems: {
                        [indexes.missionPhaseIndex]: {
                            actions: {
                                [indexes.missionActionIndex]: {
                                    actionItems: {
                                        [indexes.missionActionItemIndex]: { $merge: change },
                                    },
                                },
                            },
                        },
                    },
                },
            })
        }

        if (!Object.keys(newState).length) {
            return
        }

        this.setState(newState, () => {
            if (cb) cb({ ...obj, ...change }, newState.missions[indexes.missionIndex])

            if (!dontUpdateView) {
                this.setState({
                    missionChange: {
                        for: "actionItem",
                        from: fromSocket ? "socket" : null,
                        change: change,
                        timestamp: uniqid(),
                        obj: { ...obj, ...obj.change },
                        missionId: obj.missionId,
                        dependencyChange: Object(change).hasOwnProperty("dependencies"),
                    },
                })
            }
        })
    }
    updateStateForActionItemDelete(obj, cb) {
        const indexes = getActionItemIndexes(obj, this.state)

        if (!indexes) {
            console.error("indexes issue")
            return
        }

        const missions = update(this.state.missions, {
            [indexes.missionIndex]: {
                planItems: {
                    [indexes.missionPhaseIndex]: {
                        actions: {
                            [indexes.missionActionIndex]: {
                                actionItems: { $splice: [[indexes.missionActionItemIndex, 1]] },
                            },
                        },
                    },
                },
            },
        })

        let allActionItems = getAllActionItems(this.state.missions[indexes.missionIndex])

        allActionItems.splice(indexes.missionActionItemIndex, 1)

        let bulkChanges = []

        allActionItems.forEach((ai, i) => {
            const inDepIndex = ai.dependencies
                ? ai.dependencies.findIndex((d) => {
                      return d?.linkTo?._id === obj._id
                  })
                : -1

            if (inDepIndex !== -1) {
                ai.dependencies.splice(inDepIndex, 1)
                bulkChanges.push({
                    obj: ai,
                    change: {
                        _id: ai._id,
                        dependencies: ai.dependencies,
                    },
                })
            }
        })

        this.setState(
            {
                missions: missions,
            },
            () => {
                if (cb) cb(missions[indexes.missionIndex])
                this.setState(
                    {
                        missionChange: {
                            for: "actionItem",
                            change: "delete",
                            timestamp: uniqid(),
                            obj: obj,
                            missionId: obj.missionId,
                        },
                    },
                    () => {
                        if (bulkChanges.lenth) {
                            this.updateStateForActionItemUpdateBulk(missions[indexes.missionIndex]._id, bulkChanges)
                        }
                        const m = missions[indexes.missionIndex]
                        if (m.isProcess && m.isTemplate) {
                            setTimeout(() => {
                                //syncProcessFlow({ mission: m, app: this })
                            }, 500)
                        }
                    }
                )
            }
        )
    }

    updateStateForClientCreate(client, cb) {
        const orgIndex = this.state.orgs.findIndex((org) => org._id === client.org)

        if (orgIndex < 0) {
            return
        }

        this.setState(
            {
                orgs: update(this.state.orgs, {
                    [orgIndex]: {
                        clients: {
                            $push: [client],
                        },
                    },
                }),
            },
            () => {
                cb?.(client)
            }
        )
    }

    updateStateForClientUpdate(client, cb) {
        const orgIndex = this.state.orgs.findIndex((org) => org._id === client.org)
        const clientIndex = this.state.orgs?.[orgIndex]?.clients?.findIndex((item) => item._id === client._id)

        if (isNil(clientIndex) || clientIndex < 0) {
            return cb?.(client)
        }

        this.setState(
            {
                orgs: update(this.state.orgs, {
                    [orgIndex]: {
                        clients: {
                            [clientIndex]: {
                                $set: client,
                            },
                        },
                    },
                }),
            },
            () => {
                cb?.(client)
            }
        )
    }

    updateStateForClientDelete(orgId, clientId, cb) {
        const orgIndex = this.state.orgs.findIndex((org) => org._id === orgId)
        const clientIndex = this.state.orgs?.[orgIndex]?.clients?.findIndex((item) => item._id === clientId)

        if (isNil(clientIndex) || clientIndex < 0) {
            return cb?.()
        }

        this.setState(
            {
                orgs: update(this.state.orgs, {
                    [orgIndex]: {
                        clients: {
                            $splice: [[clientIndex, 1]],
                        },
                    },
                }),
            },
            () => {
                cb?.()
            }
        )
    }

    updateStateForMissionPeopleChange(missionIndex, changeItem) {
        const mission = this.state.missions?.[missionIndex]
        let newMissions = this.state.missions.slice()
        let openMission

        let newPeople = newMissions[missionIndex].people.slice()

        let updatedPersonIndex = mission?.people?.findIndex((person) => getRefId(person) === getRefId(changeItem?.doc))

        if (!changeItem || !mission?.people) {
            return
        }

        if (
            changeItem.changeType === "create" &&
            !mission?.people?.some((person) => getRefId(person) === getRefId(changeItem?.doc))
        ) {
            newMissions = update(this.state.missions, {
                [missionIndex]: {
                    people: {
                        $push: [changeItem?.doc],
                    },
                },
            })
        } else if (changeItem.changeType === "update") {
            if (updatedPersonIndex !== -1) {
                newMissions = update(this.state.missions, {
                    [missionIndex]: {
                        people: {
                            $set: mission.people?.toSpliced(updatedPersonIndex, 1, {
                                ...changeItem.doc,
                                ref:
                                    typeof changeItem.doc?.ref === "string"
                                        ? mission.people?.[updatedPersonIndex]?.ref
                                        : changeItem.doc?.ref,
                            }),
                        },
                    },
                })
            }
        } else if (changeItem.changeType === "delete") {
            const personAffected = newPeople[updatedPersonIndex]
            const orgPerson = mission.org
                ? this.state.orgs
                      .find((o) => o._id === getObjectId(mission.org))
                      ?.people?.find?.((p) => getRefId(p) === getRefId(personAffected))
                : null

            if (orgPerson) {
                if (orgPerson.permission === 1 || orgPerson.permission === 2) {
                } else {
                    newPeople.splice(updatedPersonIndex, 1)
                    newMissions[missionIndex].people = newPeople
                }
            } else {
                if (getRefId(personAffected) === this.state.person._id) {
                    newMissions.splice(missionIndex, 1)
                } else {
                    newPeople.splice(updatedPersonIndex, 1)
                    newMissions[missionIndex].people = newPeople
                }
            }
        }

        this.setState(
            {
                missions: newMissions,
            },
            () => {
                this.setState({
                    missionChange: {
                        for: "mission",
                        change: "people",
                        timestamp: uniqid(),
                        missionId: mission._id,
                        people: newPeople,
                    },
                })

                if (openMission) {
                    toast("Sorry but this project is no longer available.", {
                        autoClose: 6000,
                    })
                }
            }
        )
    }
    updateStateForMissionCreate(mission, cb) {
        const me = this

        let newMissions = me.state.missions.slice()
        newMissions.push(mission)

        let changeObj = {
            missions: newMissions,
        }

        if (mission.org) {
            const orgIndex = this.state.orgs.findIndex((o) => o._id === getObjectId(mission.org))

            if (orgIndex !== 1) {
                let newOrgs = this.state.orgs.slice()

                if (newOrgs[orgIndex].missions) {
                    newOrgs[orgIndex].missions.push(mission)
                    changeObj.orgs = newOrgs
                }
            }
        }

        this.setState(changeObj, () => {
            this.setState({
                missionChange: {
                    for: "mission",
                    change: "create",
                    timestamp: uniqid(),
                    obj: mission,
                    missionId: mission._id,
                },
            })

            if (cb) cb()
        })
    }
    updateStateForMissionUpdate({ mission, changes }) {
        this.missionUpdateState(mission._id, changes)
    }
    updateStateForPlanItemCreateBulk(missionId, planItems) {
        const missionIndex = this.state.missions.findIndex((m) => m._id === missionId)

        if (missionIndex === -1) {
            return
        }

        let newPlanItems = [...this.state.missions[missionIndex].planItems, ...planItems]

        this.setState({
            missions: update(this.state.missions, {
                [missionIndex]: {
                    planItems: {
                        $set: newPlanItems,
                    },
                },
            }),
        })
    }
    updateStateForPlanItemCreate(obj, cb) {
        const missionIndex = this.state.missions.findIndex((m) => m._id === obj.missionId)

        if (missionIndex === -1) {
            return
        }

        let newState = {
            missions: update(this.state.missions, {
                [missionIndex]: {
                    planItems: {
                        $push: [obj],
                    },
                },
            }),
        }

        //Set and do
        this.setState(newState, () => {
            this.setState({
                missionChange: {
                    for: "planItem",
                    change: "create",
                    timestamp: uniqid(),
                    obj: obj,
                    missionId: obj.missionId,
                },
            })

            if (cb) cb()
        })
    }
    updateStateForPlanItemUpdateBulk(changes, cb, fastCallBack) {
        let newStateObj = {}

        if (!changes || changes.length === 0) {
            return
        }

        const obj = changes[0].obj

        const missionIndex = this.state.missions.findIndex((m) => m._id === obj.missionId)

        if (missionIndex === -1) return

        let planItems = []

        let newMissions = this.state.missions.slice()

        this.state.missions[missionIndex].planItems.forEach((pi, i) => {
            const fp = changes.find((c) => c.obj._id === pi._id)

            if (fp) {
                planItems.push({ ...pi, ...fp.change })
            } else {
                planItems.push(pi)
            }
        })

        newMissions[missionIndex].planItems = planItems
        newStateObj.missions = newMissions

        if (fastCallBack) {
            fastCallBack(newMissions[missionIndex])
        }

        newStateObj.missionChange = {
            for: "planItem",
            planItems: planItems,
            changes: changes,
            timestamp: uniqid(),
            missionId: this.state.missions[missionIndex]._id,
        }

        this.setState(newStateObj, () => {
            if (cb) {
                const newM = this.state.missions[missionIndex]
                cb(newM)
            }
        })
    }
    updateStateForPlanItemUpdate(obj, change, cb) {
        let newStateObj = {}

        if (!obj || !change) {
            return
        }

        if (this.state.phaseObj && this.state.phaseObj._id === obj._id) {
            newStateObj.phaseObj = { ...this.state.phaseObj, ...change }
        }

        const missionIndex = this.state.missions.findIndex((m) => m._id === obj.missionId)

        if (missionIndex === -1) return
        const mission = this.state.missions[missionIndex]

        const planItemIndex = this.state.missions[missionIndex].planItems.findIndex((p) => p._id === obj._id)

        if (planItemIndex === -1) return

        newStateObj.missions = update(this.state.missions, {
            [missionIndex]: {
                planItems: {
                    [planItemIndex]: { $merge: change },
                },
            },
        })

        this.setState(newStateObj, () => {
            if (this.state.missions[missionIndex].org) {
                const newOrgObj = this.state.orgs.find((o) => o._id === getObjectId(mission.org))

                this.setState({
                    missionChange: {
                        for: "planItem",
                        obj: obj,
                        change: change,
                        timestamp: uniqid(),
                        missionId: this.state.missions[missionIndex]._id,
                        orgId: getObjectId(mission.org),
                        newStateOrg: newOrgObj,
                    },
                    orgChange: {
                        for: "mission",
                        timestamp: uniqid(),
                        missionId: this.state.missions[missionIndex]._id,
                    },
                })
            }

            if (cb) cb({ ...obj, ...change })
        })
    }
    updateStateForPlanItemRemoveRolesBulk(items) {
        let newMissions = this.state.missions.slice()
        items.forEach((pi, i) => {
            const missionIndex = this.state.missions.findIndex((m) => m._id === pi.missionId)
            if (missionIndex === -1) return
            const missionPlanIndex = this.state.missions[missionIndex].planItems.findIndex((p) => p._id === pi._id)
            if (missionPlanIndex === -1) return

            newMissions[missionIndex].planItems.splice(missionPlanIndex, 1)
        })

        this.setState({
            missions: newMissions,
        })
    }
    updateStateForPlanItemRemove(obj) {
        const missionIndex = this.state.missions.findIndex((m) => m._id === obj.missionId)

        if (missionIndex === -1) return

        const missionPlanIndex = this.state.missions[missionIndex].planItems.findIndex((m) => m._id === obj._id)

        if (missionPlanIndex === -1) return

        this.setState(
            {
                missions: update(this.state.missions, {
                    [missionIndex]: { planItems: { $splice: [[missionPlanIndex, 1]] } },
                }),
                missionChange: {
                    for: "planItem",
                    change: "delete",
                    timestamp: uniqid(),
                    obj: obj,
                    missionId: obj.missionId,
                },
            },
            () => {
                setTimeout(() => {
                    try {
                        let mission = this.state.missions[missionIndex]
                        if (mission && mission.org) {
                            this.setState({
                                orgChange: {
                                    for: "mission",
                                    timestamp: uniqid(),
                                },
                            })
                        }
                    } catch (e) {}
                }, 400)
            }
        )
    }

    async changeListener() {
        const me = this

        apiOrg.onChanges("delete", (changes) => {
            changes.forEach((changeObj) => {
                if (changeObj.byRequestId !== getUserRequestId()) {
                    this.orgCleanUpDeleted(changeObj._id)
                }
            })
        })
        apiOrg.onChanges("update", (changes) => {
            const orgs = this.state.orgs
            changes.forEach((changeObj) => {
                const changedOrgIndex = (orgs || []).findIndex((o) => o._id === changeObj._id)

                if (changedOrgIndex === -1) return

                if (changeObj.change.people) {
                    this.setState(
                        {
                            orgs: update(orgs, {
                                [changedOrgIndex]: {
                                    people: {
                                        $set: changeObj.change.people.map((item) => {
                                            const statePerson = (get(orgs[changedOrgIndex], "people") || []).find(
                                                (person) => person._id === item._id
                                            )
                                            return {
                                                ...item,
                                                ref: get(statePerson, "ref") || item.ref,
                                            }
                                        }),
                                    },
                                },
                            }),
                        },
                        () => {
                            this.setState({
                                orgChange: {
                                    for: "people",
                                    timestamp: uniqid(),
                                },
                            })
                        }
                    )
                } else if (changeObj.byRequestId !== getUserRequestId() || changeObj.change.programs) {
                    const changedOrgIndex = (orgs || []).findIndex((o) => o._id === changeObj._id)

                    this.orgUpdateState(orgs[changedOrgIndex], changeObj.change)
                }
            })
        })

        apiOrg.onPeopleChanges("create", (changeList) => {
            const orgList = this.state.orgs

            changeList.forEach((changeItem) => {
                const changedOrgIndex = (orgList || []).findIndex((org) => org._id === changeItem.orgId)

                if (changedOrgIndex === -1) {
                    return
                }

                if (!changeItem?.doc) {
                    return
                }

                try {
                    this.setState(
                        {
                            orgs: update(orgList, {
                                [changedOrgIndex]: {
                                    people: {
                                        $push: [changeItem.doc],
                                    },
                                },
                            }),
                        },
                        () => {
                            this.setState({
                                orgChange: {
                                    for: "people",
                                    timestamp: uniqid(),
                                },
                            })
                        }
                    )
                } catch (e) {
                } finally {
                }
            })
        })

        apiOrg.onPeopleChanges("update", (changeList) => {
            const orgList = this.state.orgs

            changeList.forEach((changeItem) => {
                const changedOrgIndex = (orgList || []).findIndex((org) => org._id === changeItem.orgId)

                if (changedOrgIndex === -1 || !changeItem.doc) {
                    return
                }

                const org = orgList[changedOrgIndex]
                const orgPersonIndex =
                    org?.people?.findIndex((person) => getObjectId(person.ref) === getObjectId(changeItem.doc?.ref)) ??
                    -1

                if (orgPersonIndex === -1) {
                    return
                }

                const newOrgData = update(orgList, {
                    [changedOrgIndex]: {
                        people: {
                            [orgPersonIndex]: {
                                $set: changeItem.doc,
                            },
                        },
                    },
                })

                this.setState(
                    {
                        orgs: newOrgData,
                    },
                    () => {
                        this.setState({
                            orgChange: {
                                for: "people",
                                timestamp: uniqid(),
                            },
                        })
                    }
                )
            })
        })

        //

        apiOrg.onPeopleChanges("delete", (changeList) => {
            const orgList = this.state.orgs

            changeList.forEach((changeItem) => {
                const changedOrgIndex = (orgList || []).findIndex((org) => org._id === changeItem.orgId)

                if (changedOrgIndex === -1) {
                    return
                }

                if (changeItem._id === this.state.person._id) {
                    // I got kicked out of this org

                    const missionsToClean = this.state.missions.filter((m) => getObjectId(m.org) === changeItem.orgId)

                    missionsToClean.forEach((m) => {
                        this.missionCleanUpDeleted(m._id, this.state.person._id)
                    })

                    this.orgCleanUpDeleted(changeItem.orgId)
                } else {
                    const org = orgList[changedOrgIndex]
                    this.setState(
                        {
                            orgs: update(orgList, {
                                [changedOrgIndex]: {
                                    people: {
                                        $set:
                                            org.people?.filter(
                                                (person) => getObjectId(person.ref) !== changeItem._id
                                            ) ?? [],
                                    },
                                },
                            }),
                        },
                        () => {
                            this.setState({
                                orgChange: {
                                    for: "people",
                                    timestamp: uniqid(),
                                },
                            })
                        }
                    )
                }
            })
        })

        apiOrg.onClientChanges("create", (changes) => {
            changes.forEach((changeObj) => {
                if (changeObj.byRequestId !== getUserRequestId()) {
                    this.updateStateForClientCreate(changeObj.doc)
                }
            })
        })

        apiOrg.onClientChanges("update", (changes) => {
            changes.forEach((changeObj) => {
                if (changeObj.byRequestId !== getUserRequestId()) {
                    this.updateStateForClientUpdate(changeObj.doc)
                }
            })
        })

        apiOrg.onClientChanges("delete", (changes) => {
            changes.forEach((changeObj) => {
                if (changeObj.byRequestId !== getUserRequestId()) {
                    this.updateStateForClientDelete(changeObj.orgId, changeObj._id)
                }
            })
        })

        apiMission.onChanges("rebuild", (changes) => {
            this.missionGetTree(changes.map((item) => item._id))
        })

        apiMission.onChanges("update", (changes) => {
            changes.forEach((changeObj) => {
                const missionIndex = this.state.missions.findIndex((m) => m._id === changeObj._id)
                if (missionIndex === -1) return

                if (
                    Object.keys(changeObj.change).length === 1 &&
                    Object(changeObj.change).hasOwnProperty("people") &&
                    !changeObj.change.people
                ) {
                    this.updateStateForMissionPeopleChange(missionIndex, changeObj)
                } else if (changeObj.change.people) {
                    if (changeObj.change.people && changeObj.change.people.length === 0) {
                        me.missionCleanUpDeleted(changeObj._id, changeObj.by)
                        return
                    }

                    this.updateStateForMissionPeopleChange(missionIndex, changeObj)
                } else if (changeObj.byRequestId !== getUserRequestId() || changeObj.change.files) {
                    this.updateStateForMissionUpdate({
                        mission: this.state.missions[missionIndex],
                        changes: changeObj.change,
                    })
                }
            })
        })

        apiMission.onChanges("delete", (changes) => {
            changes.forEach((changeObj) => {
                // TODO: @makis Remove from all phases of all missions, all the dependencies that have linkToMission._id === changeObj._id

                if (changeObj.byRequestId !== getUserRequestId()) {
                    const stateMission = this.state.missions.find((m) => m._id === changeObj.doc?._id)

                    if (
                        stateMission?.people?.find((p) => getRefId(p) === this.state.person._id)?.permission < 3 &&
                        !toast.isActive("deletedMission" + changeObj.doc?._id)
                    ) {
                        toast.warning("FYI: Project " + changeObj.doc.title + " was just archived.", {
                            autoClose: 6000,
                            toastId: "deletedMission" + changeObj.doc?._id,
                            position: toast.POSITION.BOTTOM_RIGHT,
                        })
                    }

                    me.missionCleanUpDeleted(changeObj._id, changeObj.by)
                }
            })
        })

        apiMission.onChanges("create", (changes) => {
            changes.forEach((changeObj) => {
                if (changeObj.byRequestId !== getUserRequestId()) {
                    me.updateStateForMissionCreate(changeObj.doc)
                }
            })
        })

        apiMission.onPeopleChanges("create", (changes) => {
            changes.forEach((changeItem) => {
                const missionIndex = this.state.missions.findIndex(
                    (m) => m._id === getObjectId(changeItem.doc?.mission)
                )
                if (missionIndex !== -1) {
                    this.updateStateForMissionPeopleChange(missionIndex, changeItem)
                }
            })
        })

        apiMission.onPeopleChanges("update", (changes) => {
            changes.forEach((changeItem) => {
                const missionIndex = this.state.missions.findIndex(
                    (m) => m._id === getObjectId(changeItem.doc?.mission)
                )
                if (missionIndex !== -1) {
                    this.updateStateForMissionPeopleChange(missionIndex, changeItem)
                }
            })
        })

        apiMission.onPeopleChanges("delete", (changes) => {
            changes.forEach((changeItem) => {
                if (changeItem.byRequestId !== getUserRequestId()) {
                    const missionIndex = this.state.missions.findIndex(
                        (m) => m._id === getObjectId(changeItem.doc?.mission)
                    )
                    if (missionIndex !== -1) {
                        this.updateStateForMissionPeopleChange(missionIndex, changeItem)
                    }
                }
            })
        })

        apiPlanItems.onChanges("update", (changes) => {
            changes.forEach((change) => {
                const hasDependencyChanges = !!get(change, "change.dependencies")
                let doc = change.doc

                if (!change.doc) {
                    return // FIXME:
                }

                if (
                    hasDependencyChanges ||
                    change.byRequestId !== getUserRequestId() ||
                    (change?.change?.personLeftRole && change?.change?.person === null)
                ) {
                    me.updateStateForPlanItemUpdate(doc, change.change)
                }
            })
        })

        apiPlanItems.onChanges("create", (changes) => {
            changes.forEach((change) => {
                if (change.byRequestId !== getUserRequestId()) {
                    me.updateStateForPlanItemCreate(change.doc)
                }
            })
        })
        apiPlanItems.onChanges("delete", (changes) => {
            changes.forEach((change) => {
                if (change.byRequestId !== getUserRequestId()) {
                    me.updateStateForPlanItemRemove(change.doc)
                }
            })
        })

        apiAction.onChanges("create", (changes) => {
            changes.forEach((change) => {
                if (change.byRequestId !== getUserRequestId()) {
                    me.updateStateForActionCreate(change.doc)
                }
            })
        })

        apiAction.onChanges("update", (changes) => {
            changes.forEach((change) => {
                if (change.byRequestId !== getUserRequestId()) {
                    if (change.doc.actionItems)
                        //@mike weird bug first time sends the doc, second sends a short version
                        me.updateStateForActionUpdate(change.doc, change.change)
                }
            })
        })

        apiAction.onChanges("delete", (changes) => {
            changes.forEach((change) => {
                if (change.byRequestId !== getUserRequestId() && change.doc) {
                    me.updateStateForActionDelete(change.doc)
                }
            })
        })

        //Action Items

        apiActionItem.onChanges("create", (changes) => {
            changes.forEach((change) => {
                if (change.byRequestId !== getUserRequestId()) {
                    this.updateStateForActionItemCreate(change.doc)
                }
            })
        })

        apiActionItem.onChanges("update", (changes) => {
            changes.forEach((change) => {
                if (!change.doc) {
                    return
                }

                const isMe = change.byRequestId === getUserRequestId()

                if (change?.change?.dependencies) {
                    me.updateStateForActionItemUpdate(change.doc, change.change, false, null, true)
                } else if (!isMe) {
                    //updateStateForActionItemUpdate(obj, change, dontUpdateView, cb, fromSocket) {
                    me.updateStateForActionItemUpdate(change.doc, change.change, false, null, true)
                }
            })
        })
        apiActionItem.onChanges("delete", (changes) => {
            changes.forEach((change) => {
                if (change.byRequestId !== getUserRequestId()) {
                    me.updateStateForActionItemDelete(change.doc)
                }
            })
        })
        apiNotification.onChanges("create", (changes) => {
            // this.loadLatestNotifications();

            const notificationChanges = changes
                .filter((item) => !this.state.notificationList.some((ni) => ni._id === item._id))
                .map((item) => item.doc)

            try {
                setTimeout(() => {
                    me?.msgBeep?.current?.play()
                }, 1500)
            } catch (e) {
                me.silentFail("me.msgBeep.current")
            }

            me.setState({
                notificationUnread: this.state.notificationUnread + notificationChanges.length,
                notificationList: [...this.state.notificationList, ...notificationChanges],
            })
        })
        apiNotification.onChanges("update", (changes) => {
            const notificationList = this.state.notificationList.slice()
            const updatedNotificationList = notificationList.map((item) => {
                let changedItem = changes.find((change) => item._id === change._id) || {}
                return {
                    ...item,
                    ...pick(changedItem.change, ["isRead", "isDisabled"]),
                }
            })
            const existsUnread = updatedNotificationList.some((item) => item.isRead === false)

            if (!existsUnread) {
                apiNotification.setNotificationUserLastRead().catch(() => {})
            }

            this.setState({
                notificationUnread: existsUnread ? this.state.notificationUnread : 0,
                notificationList: updatedNotificationList,
            })
        })
        apiNotification.onChanges("delete", (changes) => {
            const notificationList = this.state.notificationList.slice()
            const updatedNotificationList = notificationList.filter(
                (item) => !changes.some((change) => item._id === change._id)
            )
            const existsUnread = updatedNotificationList.some((item) => item.isRead === false)

            if (notificationList.length === updatedNotificationList.length) {
                return
            }

            if (!existsUnread) {
                apiNotification.setNotificationUserLastRead().catch(() => {})
            }

            this.setState({
                notificationUnread: existsUnread ? this.state.notificationUnread : 0,
                notificationList: updatedNotificationList,
            })
        })
    }

    onFileDelete(file) {
        if (!file || !file.attachedTo || !file.attachedToId) {
            return
        }

        apiFile
            .deleteFile(file._id)
            .then((res) => {
                if (file.attachedTo === "action.items") {
                    let actionItem = this.state.showDetailsData

                    if (actionItem) {
                        const fileIndex = actionItem.files.findIndex((item) => getObjectId(item) === file._id)

                        if (fileIndex > -1) {
                            let clonedFiles = actionItem.files.slice()
                            clonedFiles.splice(fileIndex, 1)

                            this.updateStateForActionItemUpdate(actionItem, {
                                files: clonedFiles,
                            })
                        }
                    }
                } else {
                    let mission = (this.state.missions || []).find((mi) =>
                        (mi.files || []).some((item) => getObjectId(item) === file._id)
                    )

                    if (mission) {
                        const fileIndex = mission.files.findIndex((item) => getObjectId(item) === file._id)

                        if (fileIndex > -1) {
                            let clonedFiles = mission.files.slice()
                            clonedFiles.splice(fileIndex, 1)

                            this.missionUpdateState(mission._id, {
                                files: clonedFiles,
                            })
                        }
                    }
                }
            })
            .catch((err) => {
                toast.error(err.message)
                this.silentFail("x-23ds4422-" + (err?.message + " - " + err?.toString()))
            })
    }
    showLeaveTracking() {
        if (this.state.orgs.length === 0) return false
        let show = false
        this.state.orgs.forEach((o, i) => {
            if (o.isLicensedActive) {
                show = true
            }
        })

        return show
    }
    showExpenseTracking() {
        if (this.state.orgs.length === 0) return false
        let show = false
        this.state.orgs.forEach((o, i) => {
            if (o.isLicensedActive) {
                show = true
            }
        })

        return show
    }

    confirm({
        comp,
        onYes,
        onNo,
        onCancel,
        noCancel,
        width,
        yesText,
        yesColor,
        singleClick,
        noText,
        noMint,
        severe,
        noImg,
        className,
        imgComp,
    }) {
        //props = {comp, onYes, onNo, onCancel}

        const onCancelMe = () => {
            this.setState({
                confirm: null,
            })

            if (onCancel) {
                onCancel()
            }
        }
        const onYesMe = () => {
            if (onYes) {
                let ok = onYes()

                if (ok !== false)
                    this.setState({
                        confirm: null,
                    })
            }
        }
        const onNoMe = () => {
            this.setState({
                confirm: null,
            })
            if (onNo) {
                onNo()
            }
        }

        this.setState({
            confirm: {
                onCancel: onCancelMe,
                onYes: onYesMe,
                noImg,
                noCancel,
                width: width,
                onNo: onNo ? onNoMe : undefined,
                comp: comp,
                yesText: yesText,
                yesColor: yesColor,
                singleClick: singleClick,
                severe: severe,
                noText: noText,
                className,
                noMint,
                imgComp,
            },
        })
    }
    msg(msg) {
        this.setState({
            msg: msg,
        })
    }

    render() {
        const theEaglesHaveLanded =
            !this.state.person?._id ||
            (this.state.theMissionsHaveLanded && this.state.person?._id && this.state.theNotificationsHaveLanded)

        if (!theEaglesHaveLanded) {
            return (
                <div className="dna-col dna-main-loading-data">
                    <BarLoader color={"#b3f542"} loading={true} />
                </div>
            )
        }

        const state = this.state

        const cn = cx("dna", {
            "dna-show-home": this.state.home,
            "dna-show-board": this.state.board,
            "dna-not-base": this.state.mission || this.state.phase || this.state.org,
            "dna-no-me-avatar":
                this.state.myspace ||
                this.state.login ||
                this.state.orgCrud ||
                this.state.missionCrud ||
                this.state.createProposal ||
                this.state.createMission ||
                this.state.action,

            "dna-no-ai": this.state.myspace,
            "dna-tone-down": this.state.waiting,
            "dna-mute-phase": this.state.action,
            "dna-mission-landing": this.state.theMissionsHaveLanded,
            "dna-show-control-panel": this.state.controlPanel,
            "dna-show-notifications-panel": this.state.notificationOpen,
            "dna-show-msg": this.state.msg,
        })

        const orgDataToShow = Boolean(this.state.orgIndex !== undefined && this.state.org)
            ? this.state.orgs.find((o) => getObjectId(o) === this.state.org)
            : null

        return (
            <>
                <AnimatePresence>
                    {this.state.showRefreshMessage && (
                        <motion.div
                            transition={{ duration: 0.4 }}
                            initial={{ y: -50 }}
                            animate={{ y: 0 }}
                            exit={{ y: -50 }}
                            className="x-refresh-please"
                        >
                            🔥 Updates available.{" "}
                            <span
                                className="xsre-button"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    localStorage.setItem("mission-x-version-no", VERSION)
                                    const url = new URL(window.location.href)
                                    url.searchParams.set("_v", Date.now()) // Add or replace _v param
                                    window.location.href = url.toString()
                                }}
                            >
                                Update now
                            </span>{" "}
                        </motion.div>
                    )}
                </AnimatePresence>

                <div key={this.state.avKey} className={cn}>
                    <ActionItem
                        ai={this.state.showDetailsData}
                        options={this.state.showDetailsDataOptions}
                        app={this}
                        onClose={() => {
                            removeParam("action-item")
                        }}
                        open={Boolean(this.state.showDetailsData)}
                        stateChange={this.state.missionChange}
                    />

                    {/* ++++++++ FILE VIEWER */}
                    {!!state.fileSelected && (
                        <Drive
                            onClose={() =>
                                this.setState({
                                    fileSelected: null,
                                    fileSelectedList: null,
                                })
                            }
                            onFileDelete={(file) => this.onFileDelete(file)}
                            file={state.fileSelected}
                            fileList={state.fileSelectedList}
                            app={this}
                        />
                    )}

                    {/* +++++++++ LOGIN */}
                    <FullScreen
                        param="login"
                        className="dna-login-screen"
                        closeClass="dna-dark"
                        style={{ zIndex: 9 }}
                        open={state.login}
                        onClose={() => {
                            setTimeout(() => {
                                if (!this.state.person._id) {
                                    window.location.href = "https://www.missionx.ai/" + window.location.search
                                }
                            }, 0)
                        }}
                    >
                        <Login app={this} reset={state.resetLoginStates} />
                    </FullScreen>
                    {(this.state.showMySpace || this.state.showAll) && (
                        <FullScreen
                            param="myspace"
                            style={{ zIndex: this.state.myspace ? 99 : 5 }}
                            className="myspace-fs"
                            open={state.myspace}
                        >
                            <ErrorBoundary app={this} context="my-space">
                                <MySpace
                                    app={this}
                                    person={this.state.person}
                                    profileUpdateState={(change) => this.profileUpdateState(change)}
                                />
                            </ErrorBoundary>
                        </FullScreen>
                    )}
                    {/*  ++++++++ HOME & BOARD */}
                    {!this.state.mission &&
                        this.state.person?._id &&
                        !this.state.org &&
                        !this.state.myspace &&
                        this.state.person.firstName &&
                        this.state.person.lastName && (
                            <ErrorBoundary app={this} context="home">
                                <Home
                                    notificationList={this.state.notificationList}
                                    app={this}
                                    theMissionsHaveLanded={this.state.theMissionsHaveLanded}
                                    missionChange={this.state.missionChange}
                                />
                            </ErrorBoundary>
                        )}

                    {this.state.board && !this.state.org && !this.state.mission && (
                        <ErrorBoundary app={this} context="board">
                            <Board app={this} stateChange={this.state.missionChange} />
                        </ErrorBoundary>
                    )}

                    {/*  ++++++++ CRUD MISSION */}
                    {this.state.showAll && this.state.theMissionsHaveLanded && (
                        <>
                            <FullScreen
                                key="p-crud"
                                param="create-proposal"
                                style={{ zIndex: 8 }}
                                open={state.createProposal}
                            >
                                {state.createProposal && (
                                    <ErrorBoundary app={this} context="create-bid">
                                        <CreateBid
                                            app={this}
                                            onClose={() => {
                                                this.setState({
                                                    proposalCreate: false,
                                                })
                                            }}
                                        />
                                    </ErrorBoundary>
                                )}
                            </FullScreen>
                            <FullScreen
                                param="mc,mc-org,mc-program,create-mission,mc-org-goal,mc-prop,create-proposal,mc-departments,mc-offices,mc-client"
                                style={{ zIndex: 120 }}
                                open={state.createMission}
                            >
                                {state.createMission && (
                                    <ErrorBoundary app={this} context="create-mission">
                                        <CreateMission
                                            app={this}
                                            onClose={() => {
                                                this.setState({
                                                    createMission: false,
                                                })
                                            }}
                                        />
                                    </ErrorBoundary>
                                )}
                            </FullScreen>
                            <FullScreen
                                style={{ zIndex: 999999 }}
                                open={state.createTemplate}
                                onClose={() => {
                                    this.setState({
                                        createTemplate: false,
                                    })
                                }}
                            >
                                {state.createTemplate && (
                                    <ErrorBoundary app={this} context="create-template">
                                        <CreateTemplate
                                            app={this}
                                            onClose={() => {
                                                this.setState({
                                                    createTemplate: false,
                                                })
                                            }}
                                        />
                                    </ErrorBoundary>
                                )}
                            </FullScreen>
                            <FullScreen key="crud" param="mc,mc-org" style={{ zIndex: 8 }} open={state.missionCrud}>
                                {this.state.mission && (
                                    <ErrorBoundary app={this} context="crud-mission">
                                        <CrudMission
                                            app={this}
                                            data={this.state.missions.find((m) => m._id === this.state.mission)}
                                            missionUpdateState={this.missionUpdateState.bind(this)}
                                            onClose={() => {
                                                this.setState({
                                                    missionCrud: false,
                                                })
                                            }}
                                        />
                                    </ErrorBoundary>
                                )}
                            </FullScreen>
                        </>
                    )}
                    {this.state.mission && <MissionLoader app={this} />}

                    <Card
                        closeButton
                        className="dna-center-card"
                        modal
                        modalIndex={998}
                        style={{ zIndex: 9999, maxWidth: 600 }}
                        open={Boolean(this.state.missionSetupBudget)}
                        onClose={() => {
                            this.setState({
                                missionSetupBudget: null,
                            })
                        }}
                    >
                        {Boolean(this.state.missionSetupBudget) && (
                            <BudgetSetup {...this.state.missionSetupBudget} app={this} />
                        )}
                    </Card>

                    {/*  ++++++++ ORG */}

                    <FullScreen
                        param="org,org-tab,org-goal,mc-prop,org-cfg,oc-domains,invoice,appsumo-email,otPeriodEnd,otPeriodStart,otPeriodType"
                        style={{ zIndex: 3 }}
                        open={Boolean(orgDataToShow)}
                        closeClass="org-close-x"
                        closeTip={"Exit organization"}
                    >
                        {theEaglesHaveLanded && !this.state.mission && (
                            <ErrorBoundary app={this} context="org">
                                <Org
                                    key={orgDataToShow?._id}
                                    orgUpdateState={this.orgUpdateState.bind(this)}
                                    missionChange={this.state.missionChange}
                                    orgData={orgDataToShow}
                                    orgChange={this.state.orgChange}
                                    app={this}
                                />
                            </ErrorBoundary>
                        )}
                    </FullScreen>

                    {/* +++++++++ CRUD ORG */}
                    <FullScreen param="hq" style={{ zIndex: 10 }} open={this.state.orgCrud}>
                        {this.state.orgCrud && (
                            <ErrorBoundary app={this} context="crud-org">
                                <CrudOrg
                                    app={this}
                                    data={state.orgs[state.orgIndex]}
                                    onClose={() => {
                                        this.setState({
                                            orgCrud: false,
                                        })
                                    }}
                                />
                            </ErrorBoundary>
                        )}
                    </FullScreen>
                    <ErrorBoundary app={this} context="budget-pro">
                        <BudgetPro
                            app={this}
                            flashRowId={this.state.budgetProMission?.flashRowId}
                            dontShowAppToolsOnExit={this.state.budgetProMission?.dontShowAppToolsOnExit}
                            open={Boolean(this.state.budgetProMission)}
                            missionId={this.state.budgetProMission?.missionId}
                            mission={
                                this.state.budgetProMission?.mission
                                    ? this.state.missions.find(
                                          (m) => m._id === this.state.budgetProMission?.mission?._id
                                      )
                                    : undefined
                            }
                            timesheets={this.state.budgetProMission?.timesheets?.filter(
                                (t) => t.snapshot?.mission?._id === this.state.budgetProMission?.mission?._id
                            )}
                            startTab={this.state.budgetProMission?.budgetProStartTab}
                            stateChange={this.state.missionChange}
                            onClose={() => {
                                if (this.state.budgetProMission?.onClose) this.state.budgetProMission.onClose()
                                this.setState({
                                    budgetProMission: undefined,
                                })
                            }}
                            fetchTimesheets={true}
                        />
                    </ErrorBoundary>
                    {/* ====== Promos ============= */}
                    <Card
                        onClose={() => {
                            removeParams("from,oobCode,appsumo-email")
                            this.setState({
                                appsumo: false,
                                appSumoOobCode: null,
                            })
                        }}
                        closeButton
                        modal
                        className="dna-center-card"
                        style={{ zIndex: 9999999, maxWidth: this.state.orgs.length > 0 ? 620 : 550 }}
                        open={Boolean(this.state.appsumo && !this.state.myspace)}
                    >
                        {this.state.appsumo && (
                            <ErrorBoundary app={this}>
                                <AppSumoFlow
                                    app={this}
                                    planDetails={this.state.appsumo}
                                    oobCode={this.state.appSumoOobCode}
                                    onClose={() => {
                                        this.setState({
                                            appsumo: null,
                                            appSumoOobCode: null,
                                        })
                                        removeParams("from,oobCode,appsumo-email,email")
                                    }}
                                />
                            </ErrorBoundary>
                        )}
                    </Card>
                    <ToastContainer
                        closeButton={CloseToast}
                        autoClose={3000}
                        className="toast-the-dna no-blur"
                        position={toast.POSITION.TOP_CENTER}
                    />
                    <Confirm open={this.state.confirm} {...this.state.confirm} />

                    {theEaglesHaveLanded && (
                        <ErrorBoundary app={this}>
                            <PanelNotification
                                open={this.state.notificationOpen && this.state.person && this.state.person._id}
                                onClose={() => {
                                    this.setState({
                                        notificationOpen: false,
                                    })
                                }}
                                app={this}
                                notifications={this.state.notificationList}
                            />
                        </ErrorBoundary>
                    )}

                    {/*Knobs*/}
                    {this.state.person._id &&
                        this.state.person.avatar &&
                        this.state.person.firstName &&
                        this.state.theMissionsHaveLanded &&
                        !this.state.missionCrud &&
                        !this.state.createProposal &&
                        !this.state.createMission &&
                        !this.state.orgCrud &&
                        !this.state.hideDamKnob && (
                            <>
                                <Navigator app={this} open={this.state.controlPanel} />
                            </>
                        )}

                    <span
                        className={cx({
                            "dna-dark":
                                darkThemes.includes(this.state.person.theme) &&
                                this.state.home &&
                                !this.state.timeTracking &&
                                !this.state.mission &&
                                !this.state.org &&
                                !this.state.myspace,
                        })}
                    >
                        {/* ++++++++ MY AVATAR */}
                        {state.person?._id && (
                            <>
                                {this.state.theMissionsHaveLanded &&
                                    !this.state.missionCrud &&
                                    !this.state.createProposal &&
                                    !this.state.createMission &&
                                    !this.state.orgCrud &&
                                    !this.state.homeCalendar &&
                                    !this.state.timeTracking &&
                                    !this.state.mission &&
                                    !this.state.action &&
                                    !this.state.hideExtras && (
                                        <>
                                            <div
                                                className="dna-cal-trigger"
                                                onClick={() => {
                                                    this.setState({
                                                        homeCalendar: true,
                                                    })
                                                }}
                                            >
                                                <Tip title="Your assignment calendar">
                                                    <BsCalendar4Week fontSize={19} />
                                                </Tip>
                                            </div>
                                        </>
                                    )}

                                {!this.state.homeCalendar && !this.state.timeTracking && !this.state.hideAvatar && (
                                    <>
                                        <div
                                            className="dna-me-avatar"
                                            onMouseOver={() => MySpace.preload()}
                                            onClick={() => {
                                                removeParams("phase,search-mode")
                                                addParam("myspace", "open")
                                            }}
                                            style={{ backgroundImage: `url(${this.state.person.avatar})` }}
                                        />
                                    </>
                                )}

                                {(this.state.person?.email === "mike@missionx.ai" ||
                                    this.state.person?.email === "makis@missionx.ai") && (
                                    <FullScreen
                                        style={{ zIndex: 99999 }}
                                        className="dna-dark"
                                        open={this.state.mxAdmin}
                                        onClose={() =>
                                            this.setState({
                                                mxAdmin: false,
                                            })
                                        }
                                    >
                                        <MxAdmin />
                                    </FullScreen>
                                )}

                                {this.state.theMissionsHaveLanded &&
                                    !this.state.homeCalendar &&
                                    !this.state.hideExtras &&
                                    !this.state.hideAdminTools && (
                                        <Tip
                                            className="dna-speed-trigger"
                                            position="left"
                                            interactive
                                            html={
                                                <>
                                                    <p>My timesheets 🍸</p>
                                                    {!this.state.hasTimeTracking && (
                                                        <>
                                                            <p>
                                                                Requires an{" "}
                                                                <span
                                                                    className="dna-cursor dna-orange-text"
                                                                    onClick={() => {
                                                                        window.open(
                                                                            "https://missionx.ai/pricing/",
                                                                            "_blank"
                                                                        )
                                                                    }}
                                                                >
                                                                    Unlimited subscription
                                                                </span>{" "}
                                                                for one of your organizations
                                                            </p>
                                                            <p>
                                                                Learn more about{" "}
                                                                <span
                                                                    className="dna-cursor dna-mint"
                                                                    onClick={() => {
                                                                        window.open(
                                                                            "https://missionx.ai/guide/time-tracking/",
                                                                            "_blank"
                                                                        )
                                                                    }}
                                                                >
                                                                    time tracking
                                                                </span>
                                                            </p>
                                                        </>
                                                    )}
                                                </>
                                            }
                                        >
                                            <div
                                                key={this.state.missingTimesheets?.length}
                                                onClick={() => {
                                                    if (this.state.hasTimeTracking) {
                                                        addParams([
                                                            { param: "time-tracking", value: "open" },
                                                            {
                                                                param: "week",
                                                                value: startOfWeek(new Date(), {
                                                                    weekStartsOn: 1,
                                                                }).getTime(),
                                                            },
                                                        ])
                                                    } else {
                                                        toast(
                                                            "There are no eligible organizations for Time Tracking. 🍸",
                                                            {
                                                                autoClose: 10000,
                                                            }
                                                        )
                                                    }
                                                }}
                                            >
                                                <Badge
                                                    badgeContent={this.state.missingTimesheets || null}
                                                    color="secondary"
                                                >
                                                    <IconSpeed />
                                                </Badge>
                                            </div>
                                        </Tip>
                                    )}
                            </>
                        )}

                        {this.state.theMissionsHaveLanded &&
                            !this.state.timeTracking &&
                            !this.state.homeCalendar &&
                            !this.state.hideExtras &&
                            !this.state.hideAdminTools && (
                                <>
                                    <div
                                        className="dna-leave-trigger"
                                        onClick={() => {
                                            if (!this.showLeaveTracking()) {
                                                toast(
                                                    "Requires an organization with an Unlimited subscription. Start a free trial to test it out 🌻",
                                                    {
                                                        autoClose: 10000,
                                                    }
                                                )
                                                return
                                            }
                                            this.setState({
                                                showLeaveTracker: true,
                                            })
                                        }}
                                    >
                                        <Tip
                                            position="left"
                                            interactive
                                            html={
                                                <>
                                                    <p>My leave requests 🌻</p>
                                                    {!this.showLeaveTracking() && (
                                                        <>
                                                            <p>
                                                                Requires an{" "}
                                                                <span
                                                                    className="dna-cursor dna-orange-text"
                                                                    onClick={() => {
                                                                        window.open(
                                                                            "https://missionx.ai/pricing/",
                                                                            "_blank"
                                                                        )
                                                                    }}
                                                                >
                                                                    Unlimited subscription
                                                                </span>{" "}
                                                                for one of your organizations
                                                            </p>
                                                            <p>
                                                                Learn more about{" "}
                                                                <span
                                                                    className="dna-cursor dna-mint"
                                                                    onClick={() => {
                                                                        window.open(
                                                                            "https://missionx.ai/guide/leave-tracking/",
                                                                            "_blank"
                                                                        )
                                                                    }}
                                                                >
                                                                    leave tracking
                                                                </span>
                                                            </p>
                                                        </>
                                                    )}
                                                </>
                                            }
                                        >
                                            <IconLeave width={25} />
                                        </Tip>
                                    </div>
                                </>
                            )}

                        {this.state.theMissionsHaveLanded &&
                            !this.state.timeTracking &&
                            !this.state.homeCalendar &&
                            !this.state.hideExtras &&
                            !this.state.hideAdminTools && (
                                <>
                                    <div
                                        className="x-expense-trigger"
                                        onClick={() => {
                                            if (!this.showExpenseTracking()) {
                                                toast(
                                                    "Requires an organization with an Unlimited subscription. Start a free trial to test it out 🌻",
                                                    {
                                                        autoClose: 10000,
                                                    }
                                                )
                                                return
                                            }
                                            this.hideAppElements()
                                            this.setState({
                                                showExpenses: true,
                                            })
                                        }}
                                    >
                                        <Tip
                                            interactive
                                            position="left"
                                            html={
                                                <>
                                                    <p>My expenses. Ka-ching 💰</p>
                                                    {!this.showExpenseTracking() && (
                                                        <>
                                                            <p>
                                                                Requires an{" "}
                                                                <span
                                                                    className="dna-cursor dna-orange-text"
                                                                    onClick={() => {
                                                                        window.open(
                                                                            "https://missionx.ai/pricing/",
                                                                            "_blank"
                                                                        )
                                                                    }}
                                                                >
                                                                    Unlimited subscription
                                                                </span>{" "}
                                                                for one of your organizations
                                                            </p>
                                                            <p>
                                                                Learn more about{" "}
                                                                <span
                                                                    className="dna-cursor dna-mint"
                                                                    onClick={() => {
                                                                        window.open(
                                                                            "https://missionx.ai/guide/expenses-online/",
                                                                            "_blank"
                                                                        )
                                                                    }}
                                                                >
                                                                    submitting expenses
                                                                </span>
                                                            </p>
                                                        </>
                                                    )}
                                                </>
                                            }
                                        >
                                            <BsReceipt />
                                        </Tip>
                                    </div>

                                    <>
                                        {this.state.orgs.find((o) => o.people?.length) && (
                                            <div
                                                className="x-wfh-trigger"
                                                onClick={() => {
                                                    if (this.state.orgs?.length > 0) {
                                                        this.setState({
                                                            showWfh: true,
                                                        })
                                                    } else {
                                                        toast.warning(
                                                            "Please create or join an organization first. Once you're part of an organization, you'll be able to book work-from-home days.",
                                                            { autoClose: 5000 }
                                                        )
                                                    }
                                                }}
                                            >
                                                <Tip
                                                    interactive
                                                    position="left"
                                                    html={
                                                        <>
                                                            <p>Manage my WFH bookings</p>
                                                        </>
                                                    }
                                                >
                                                    <PiHouseLight width={28} />
                                                </Tip>
                                            </div>
                                        )}
                                        {this.state.orgs.find((o) => o.people?.length) && (
                                            <Card
                                                closeButton
                                                modal
                                                padded
                                                portal
                                                center
                                                style={{ width: "90vw", zIndex: 9999 }}
                                                onClose={() => {
                                                    this.setState({
                                                        showWfh: false,
                                                    })
                                                }}
                                                open={this.state.showWfh}
                                            >
                                                <ErrorBoundary app={this}>
                                                    {this.state.showWfh && <Wfh app={this} />}
                                                </ErrorBoundary>
                                            </Card>
                                        )}

                                        {(this.state.person?.email === "mike@missionx.ai" ||
                                            this.state.person?.email === "makis@missionx.ai") && (
                                            <div
                                                className="x-mx-admin-control "
                                                onClick={() => {
                                                    this.setState({
                                                        mxAdmin: true,
                                                    })
                                                }}
                                            >
                                                <Tip
                                                    interactive
                                                    position="left"
                                                    html={
                                                        <>
                                                            <p>missionX admin panel</p>
                                                        </>
                                                    }
                                                >
                                                    <PiLightningDuotone />
                                                </Tip>
                                            </div>
                                        )}
                                    </>
                                </>
                            )}
                    </span>

                    {state.person._id && (
                        <>
                            {this.state.theMissionsHaveLanded && (
                                <FullScreen
                                    param="time-tracking,week"
                                    style={{ zIndex: 2 }}
                                    closeStyle={{ zIndex: 25 }}
                                    open={this.state.timeTracking}
                                >
                                    {this.state.timeTracking && (
                                        <ErrorBoundary app={this} context="time-tracking">
                                            <TimeTracking
                                                app={this}
                                                missionChange={this.state.missionChange}
                                                onClose={() => {
                                                    removeParams("time-tracking,week")
                                                }}
                                            />
                                        </ErrorBoundary>
                                    )}
                                </FullScreen>
                            )}

                            <Card
                                closeButton
                                modal
                                style={{ minWidth: 1150, width: 1150, zIndex: 9999 }}
                                onClose={() => {
                                    this.setState({
                                        showLeaveTracker: false,
                                    })
                                }}
                                open={this.state.showLeaveTracker}
                                className="dna-right-card x-lt-card"
                            >
                                <ErrorBoundary app={this} context="leave-tracking">
                                    {this.state.showLeaveTracker && <LeaveTracker orgs={this.state.orgs} app={this} />}
                                </ErrorBoundary>
                            </Card>

                            <Card
                                closeButton
                                modal
                                modalIndex={99}
                                className="dna-center-card x-expense-tracker-card"
                                onClose={() => {
                                    this.setState({
                                        showExpenses: false,
                                    })
                                    this.showAppElements()
                                }}
                                open={this.state.showExpenses}
                            >
                                <ErrorBoundary app={this}>
                                    {this.state.showExpenses && (
                                        <ExpenseTracker hideExtras={true} app={this} context="personal" />
                                    )}
                                </ErrorBoundary>
                            </Card>
                        </>
                    )}

                    {this.state.syncBlocker && (
                        <div
                            className="dna-dark dna-center courier dna-modal "
                            style={{ pointerEvents: "all", zIndex: 99999999 }}
                            onClick={(e) => {
                                e.stopPropagation()
                            }}
                        >
                            Synchronizing your session... one moment please
                        </div>
                    )}
                    <AnimatePresence>
                        {this.state.loadingBlocker && (
                            <motion.div
                                transition={{ duration: 0.2 }}
                                initial={{ opacity: 1 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                className="dna-center dna-modal dna-main-model"
                                style={{ pointerEvents: "all", zIndex: 99999999 }}
                                onClick={(e) => {
                                    e.stopPropagation()
                                }}
                            >
                                {typeof this.state.loadingBlockerMessage === "string" ? (
                                    <div className="dna-middle-flex" style={{ marginLeft: 40, marginTop: -50 }}>
                                        {this.state.loadingBlockerLoader === "bar" && (
                                            <BarLoader loading color="gray" width={70} />
                                        )}
                                        {this.state.loadingBlockerLoader === "pacman" && (
                                            <PacmanLoader
                                                loading
                                                color="gray"
                                                size={20}
                                                cssOverride={{ marginRight: 40 }}
                                            />
                                        )}
                                        {this.state.loadingBlockerLoader === "rings" && (
                                            <>
                                                <RingLoader loading color="gray" size={40} />
                                            </>
                                        )}
                                        {this.state.loadingBlockerLoader === "rise" && (
                                            <RiseLoader loading color="gray" size={10} />
                                        )}
                                        <div style={{ marginLeft: 20 }}>
                                            <b style={{ marginRight: 8, letterSpacing: 1 }}>
                                                {this.state.loadingBlockerTag}
                                            </b>{" "}
                                            {this.state.loadingBlockerMessage}
                                        </div>
                                    </div>
                                ) : (
                                    this.state.loadingBlockerMessage
                                )}
                            </motion.div>
                        )}
                    </AnimatePresence>
                    {/*----- Search ---------- */}
                    <FullScreen
                        open={this.state.homeCalendar && !this.state.mission}
                        closeClass="dna-dark"
                        style={{ zIndex: 2 }}
                        closeStyle={{ right: 30 }}
                        onClose={() => {
                            this.setState({
                                homeCalendar: false,
                            })
                        }}
                    >
                        {this.state.homeCalendar && !this.state.mission && (
                            <ErrorBoundary app={this}>
                                <Calendar app={this} />
                            </ErrorBoundary>
                        )}
                    </FullScreen>

                    <div className="dna-app-msg">{this.state.msg}</div>
                </div>

                <audio ref={this.msgBeep} style={{ display: "none" }}>
                    <source src="/video/message.mp3" type="audio/mpeg" />
                </audio>
            </>
        )
    }
}

const getActionItemIndexes = (obj, state) => {
    if (!obj) {
        return false
    }

    const isActionItem = obj.actionId
    const theid = isActionItem ? obj.actionId : obj._id

    let missionActionItemIndex

    const missionIndex = state.missions.findIndex((a) => a._id === obj.missionId)

    if (missionIndex === -1) {
        return false
    }

    const missionPhaseIndex = state.missions[missionIndex].planItems.findIndex((a) => a._id === obj.missionPlanId)

    if (missionPhaseIndex === -1) {
        return false
    }
    const missionActionIndex = state.missions[missionIndex].planItems[missionPhaseIndex].actions.findIndex(
        (a) => a._id === theid
    )

    if (missionActionIndex === -1) {
        return false
    }

    if (isActionItem) {
        missionActionItemIndex = state.missions[missionIndex].planItems[missionPhaseIndex].actions[
            missionActionIndex
        ].actionItems.findIndex((a) => a._id === obj._id)
    }

    return {
        missionIndex: missionIndex,
        missionPhaseIndex: missionPhaseIndex,
        missionActionIndex: missionActionIndex,
        missionActionItemIndex: missionActionItemIndex,
    }
}

const CloseToast = ({ closeToast }) => (
    <span className="cursor" onClick={closeToast}>
        <IoClose color="gray" />
    </span>
)

const setCookie = (cname, cvalue, exdays) => {
    const d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    let expires = "expires=" + d.toUTCString()
    document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=missionx.ai;path=/"
}

const MissionLoader = ({ app }) => {
    const missionRef = useRef()
    const [mission, setMission] = useState()

    const missionHash = makeHash(app.state.missions)
    const orgData = mission?.org ? app.state.orgs.find((o) => o._id === getObjectId(mission?.org)) : undefined

    const loadMission = async (missionId) => {
        //Get the full tree
        try {
            const missionArray = await apiMission.streamMissionListTree({
                mission: missionId,
                myMissions: false,
            })

            const missionData = missionArray[0]

            if (!missionData || missionData === "[") {
                if (!missionData) {
                    const meInOrg = orgData.people.find((p) => getRefId(p) === app.state.person._id)

                    if (meInOrg.permission) {
                        toast.error(
                            "Oops. As an org observer you have access to all organization workspace reports but not the projects. Please ask an admin to grant you more access. ",
                            {
                                autoClose: 9000,
                            }
                        )

                        return
                    }
                }

                toast("Sorry that mission was not found and may have been archived or please refresh and try again", {
                    autoClose: 5000,
                })
                app.silentFail("ewlkjrokef-ere: " + missionId + "-md-" + missionData)
                removeParam("mission")
                return
            }

            const cleanData = { ...app.cleanBadData(missionData), loadedFromOrg: null }

            app.missionUpdateState(
                missionId,
                cleanData,
                () => {
                    //wait for state to catch up
                    setMission(cleanData)
                },
                true
            )
        } catch (e) {
            app.unBlock()
            toast.error(
                "I could not find data for this mission. Please refersh and try again or contact help@missionx.ai",
                {
                    autoClose: 5000,
                }
            )

            app.silentFail("Mission Error")

            return
        }
    }

    useEffect(() => {
        missionRef.current = mission
    }, [mission])

    useEffect(() => {
        if (app.state.mission) {
            const stateMission = missionHash[app.state.mission]

            if (stateMission?.loadedFromOrg) {
                loadMission(app.state.mission)
            } else {
                if (stateMission) {
                    setMission(stateMission)
                }

                loadMission(app.state.mission)
            }
        } else if (missionRef.current) {
            setMission(null)
            missionRef.current = null
        }
    }, [app.state.mission])

    useEffect(() => {
        const mc = app.state.missionChange

        if (!missionRef.current) {
            return
        }

        if (mc && mc?.missionId === missionRef.current?._id) {
            const stateMission = app.state.missions.find((mm) => mm._id === missionRef.current?._id)

            setMission(stateMission)
        }
    }, [app.state.missionChange.timestamp])

    useDebouncedEffect(
        () => {
            const stateMission = missionHash[missionRef.current?._id]
            setMission(stateMission)
        },
        [orgData],
        400
    )

    return (
        <>
            <FullScreen
                param="mission,mission-tab,make-week,make-phase,action,phase,mission-timeline,budget-bar,powerTab,make-week"
                style={{ zIndex: 6 }}
                open={Boolean(mission)}
            >
                {mission && (
                    <ErrorBoundary app={app} context={mission.projectType}>
                        {(mission.projectType === "simple" || mission.projectType === "kanban") && (
                            <SimplyX
                                key={mission?._id}
                                mission={mission}
                                app={app}
                                stateChange={app.state.missionChange}
                            />
                        )}
                        {mission.projectType === "power" && (
                            <Power
                                key={mission?._id}
                                mission={mission}
                                app={app}
                                stateChange={app.state.missionChange}
                            />
                        )}
                        {mission.projectType === "mx-gantt" && (
                            <MxGanttMission
                                key={mission?._id}
                                mission={mission}
                                app={app}
                                stateChange={app.state.missionChange}
                            />
                        )}
                    </ErrorBoundary>
                )}
            </FullScreen>
        </>
    )
}

App.displayName = "App"

export default App
